/*!
  * WKO Design System  v0.4.6-develop.2 (https://wko.at/)
  * Copyright 2011-2020 WKO Inhouse Frontend Team (https://www.wko.at/service/dienststelle.html?orgid=20425)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.bootstrap = {}));
}(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, basedir, module) {
		return module = {
		  path: basedir,
		  exports: {},
		  require: function (path, base) {
	      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
	    }
		}, fn(module, module.exports), module.exports;
	}

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
	}

	(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof commonjsRequire&&commonjsRequire;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t);}return n[i].exports}for(var u="function"==typeof commonjsRequire&&commonjsRequire,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
	module.exports = (function() {

	  if(typeof EventTarget === 'undefined') {
	    window.EventTarget = Node;
	  }

	  /**
	   * Event listener interceptor
	   */

	  var EventListenerInterceptor = {
	    interceptors: [] // { target: EventTarget, interceptors: [{ add: Function, remove: Function }, ...] }
	  };


	  /**
	   * Returns if exists a previously registered listener from a target and the normalized arguments
	   * @param target
	   * @param normalizedArguments
	   * @return {*}
	   */
	  EventListenerInterceptor.getRegisteredEventListener = function(target, normalizedArguments) {
	    var key = normalizedArguments.type + '-' + (normalizedArguments.options.capture ? '1' : '0');
	    if(
	      (target.__eventListeners !== void 0) &&
	      (target.__eventListeners[key] !== void 0)
	    ) {
	      var map = target.__eventListeners[key];
	      for(var i = 0; i < map.length; i++) {
	        if(map[i].listener === normalizedArguments.listener) {
	          return map[i];
	        }
	      }
	    }
	    return null;
	  };

	  /**
	   * Registers a listener on a target with some options
	   * @param target
	   * @param normalizedArguments
	   */
	  EventListenerInterceptor.registerEventListener = function(target, normalizedArguments) {
	    var key = normalizedArguments.type + '-' + (normalizedArguments.options.capture ? '1' : '0');

	    if(target.__eventListeners === void 0) {
	      target.__eventListeners = {};
	    }

	    if(target.__eventListeners[key] === void 0) {
	      target.__eventListeners[key] = [];
	    }

	    target.__eventListeners[key].push(normalizedArguments);
	  };

	  /**
	   * Unregisters a listener on a target with some options
	   * @param target
	   * @param normalizedArguments
	   */
	  EventListenerInterceptor.unregisterEventListener = function(target, normalizedArguments) {
	    var key = normalizedArguments.type + '-' + (normalizedArguments.options.capture ? '1' : '0');
	    if(
	      (target.__eventListeners !==  void 0) &&
	      (target.__eventListeners[key] !== void 0)
	    ) {
	      var map = target.__eventListeners[key];
	      for(var i = 0; i < map.length; i++) {
	        if(map[i].listener === normalizedArguments.listener) {
	          map.splice(i, 1);
	        }
	      }

	      if(map.length === 0) {
	        delete target.__eventListeners[key];
	      }
	    }
	  };



	  EventListenerInterceptor.normalizeListenerCallback = function(listener) {
	    if((typeof listener === 'function') || (listener === null) || (listener === void 0)) {
	      return listener;
	    } else if((typeof listener === 'object') && (typeof listener.handleEvent === 'function')) {
	      return listener.handleEvent;
	    } else {
	      // to support Symbol
	      return function(event) {
	        listener(event);
	      };
	    }
	  };

	  EventListenerInterceptor.normalizeListenerOptions = function(options) {
	    switch(typeof options) {
	      case 'boolean':
	        options = { capture: options };
	        break;
	      case 'undefined':
	        options = { capture: false };
	        break;
	      case 'object':
	        if (options === null) {
	          options = { capture: false };
	        }
	        break;
	      default:
	        throw new Error('Unsupported options type for addEventListener');
	    }

	    options.once      = Boolean(options.once);
	    options.passive   = Boolean(options.passive);
	    options.capture   = Boolean(options.capture);

	    return options;
	  };

	  EventListenerInterceptor.normalizeListenerArguments = function(type, listener, options) {
	    return {
	      type: type,
	      listener: this.normalizeListenerCallback(listener),
	      options: this.normalizeListenerOptions(options)
	    };
	  };



	  EventListenerInterceptor.intercept = function(target, interceptors) {
	    // get an interceptor with this target or null
	    var interceptor = null;
	    for (var i = 0; i < this.interceptors.length; i++) {
	      if(this.interceptors[i].target === target) {
	        interceptor = this.interceptors[i];
	      }
	    }

	    // if no interceptor already set
	    if (interceptor === null) {
	      interceptor = { target: target, interceptors: [interceptors] };
	      this.interceptors.push(interceptor);

	      this.interceptAddEventListener(target, interceptor);
	      this.interceptRemoveEventListener(target, interceptor);
	    } else { // if an interceptor already set, simply add interceptors to the list
	      interceptor.interceptors.push(interceptors);
	    }

	    // var release = function() {
	    //   target.prototype.addEventListener = addEventListener;
	    //   target.prototype.removeEventListener = removeEventListener;
	    // };
	    // this.interceptors.push(release);
	    // return release;
	  };

	  EventListenerInterceptor.interceptAddEventListener = function(target, interceptor) {
	    var _this = this;

	    var addEventListener = target.prototype.addEventListener;
	    target.prototype.addEventListener = function(type, listener, options) {
	      var normalizedArguments = _this.normalizeListenerArguments(type, listener, options);
	      var registeredEventListener = _this.getRegisteredEventListener(this, normalizedArguments);

	      if (!registeredEventListener) {

	        normalizedArguments.polyfilled = {
	          type: normalizedArguments.type,
	          listener: normalizedArguments.listener,
	          options: {
	            capture: normalizedArguments.options.capture,
	            once: normalizedArguments.options.once,
	            passive: normalizedArguments.options.passive
	          }
	        };

	        for (var i = 0; i < interceptor.interceptors.length; i++) {
	          var interceptors = interceptor.interceptors[i];
	          if (typeof interceptors.add === 'function') {
	            interceptors.add(normalizedArguments);
	          }
	        }

	        // console.log('normalizedArguments', normalizedArguments.polyfilled);

	        _this.registerEventListener(this, normalizedArguments);

	        addEventListener.call(
	          this,
	          normalizedArguments.polyfilled.type,
	          normalizedArguments.polyfilled.listener,
	          normalizedArguments.polyfilled.options
	        );
	      }
	    };

	    return function() {
	      target.prototype.addEventListener = addEventListener;
	    };
	  };

	  EventListenerInterceptor.interceptRemoveEventListener = function(target, interceptor) {
	    var _this = this;

	    var removeEventListener = target.prototype.removeEventListener;
	    target.prototype.removeEventListener = function(type, listener, options) {
	      var normalizedArguments = _this.normalizeListenerArguments(type, listener, options);
	      var registeredEventListener = _this.getRegisteredEventListener(this, normalizedArguments);

	      if (registeredEventListener) {
	        _this.unregisterEventListener(this, normalizedArguments);
	        removeEventListener.call(
	          this,
	          registeredEventListener.polyfilled.type,
	          registeredEventListener.polyfilled.listener,
	          registeredEventListener.polyfilled.options
	        );
	      } else {
	        removeEventListener.call(this, type, listener, options);
	      }
	    };

	    return function() {
	      target.prototype.removeEventListener = removeEventListener;
	    };
	  };

	  EventListenerInterceptor.interceptAll = function(interceptors) {
	    this.intercept(EventTarget, interceptors);
	    if(!(window instanceof EventTarget)) {
	      this.intercept(Window, interceptors);
	    }
	  };

	  EventListenerInterceptor.releaseAll = function() {
	    for(var i = 0, l = this.interceptors.length; i < l; i++) {
	      this.interceptors();
	    }
	  };


	  EventListenerInterceptor.error = function(error) {
	    // throw error;
	    console.error(error);
	  };

	  return EventListenerInterceptor;
	})();

	},{}],2:[function(require,module,exports){
	(function(EventListenerInterceptor) {
	  /**
	   * Event listener type support
	   */

	  EventListenerInterceptor.isSupportedOnEvent = function(target, type) {
	    return (('on' + type) in target);
	  };

	  EventListenerInterceptor.isSupportedTransitionEvent = function(target, type) {
	    return EventListenerInterceptor.isSupportedOnEvent(target, type) || (('style' in target) && (target.style['transition'] !== void 0));
	  };

	  EventListenerInterceptor.isSupportedFullScreenEvent = function(target, type) {
	    if(EventListenerInterceptor.isSupportedOnEvent(target, type)) {
	      return true;
	    } else {
	      if(/^ms/.test(type.toLowerCase())) {
	        return 'msRequestFullscreen' in document.body;
	      } else if(/^moz/.test(type)) {
	        return 'mozRequestFullscreen' in document.body;
	      } else if(/^webkit/.test(type)) {
	        return 'webkitRequestFullscreen' in document.body;
	      } else {
	        return false;
	      }
	    }
	  };


	  EventListenerInterceptor.generateEventTypes = function() {
	    var _this = this;

	    this.eventTypes = {}; // map of types that resolved to something else
	    this.vendorPrefixes = ['', 'webkit', 'moz', 'ms', 'o'];


	    this.eventTypes['wheel'] = ['wheel', 'mousewheel', 'DOMMouseScroll'].map(function(type) {
	      return { type: type, isSupported: _this.isSupportedOnEvent } ;
	    });

	    this.eventTypes['fullscreenchange'] = ['fullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange', 'MSFullscreenChange', 'msfullscreenchange'].map(function(type) {
	      return { type: type, isSupported: _this.isSupportedFullScreenEvent } ;
	    });

	    this.eventTypes['fullscreenerror'] = ['fullscreenerror', 'mozfullscreenerror', 'webkitfullscreenerror', 'MSFullscreenError', 'msfullscreenerror'].map(function(type) {
	      return { type: type, isSupported: _this.isSupportedFullScreenEvent } ;
	    });

	    [
	      'pointerlockchange', 'pointerlockerror',
	      'animationstart', 'animationiteration', 'animationend',
	      'pointercancel', 'pointerdown', 'pointerhover', 'pointermove', 'pointerout', 'pointerover', 'pointerup'
	    ].forEach(function(type) {
	      _this.eventTypes[type] = _this.vendorPrefixes
	        .map(function(prefix) {
	          return { type: (prefix + type), isSupported: _this.isSupportedOnEvent } ;
	        });
	    });

	    ['transitionstart', 'transitionrun', 'transitionend'].forEach(function(type) {
	      _this.eventTypes[type] = _this.vendorPrefixes
	        .map(function(prefix) {
	          return { type: (prefix + type), isSupported: _this.isSupportedTransitionEvent } ;
	        });
	    });
	  };

	  EventListenerInterceptor.getSupportedEventType = function(target, type) {
	    var types = this.eventTypes[type];
	    if(types === void 0) {
	      return type;
	    } else {
	      var _type;
	      for(var i = 0; i < types.length; i++) {
	        _type = types[i];
	        if(_type.isSupported(target, _type.type)) {
	          // console.log('use : ' + eventTypesPolyfiller[i].type);
	          return _type.type;
	        }
	      }

	      // this.error(new Error('Event listener type ' + String(type) + ' on ' + String(target) + ' is not supported by current environment'));
	      return type;
	    }
	  };


	  EventListenerInterceptor.polyfillListenerEventTypes = function() {
	    this.generateEventTypes();

	    var _this = this;

	    this.interceptAll({
	      add: function(normalizedArguments) {
	        normalizedArguments.polyfilled.type = _this.getSupportedEventType(this, normalizedArguments.polyfilled.type);
	      }
	    });
	  };


	  EventListenerInterceptor.polyfillListenerEventTypes();

	})(require('./EventListenerInterceptor.js'));
	},{"./EventListenerInterceptor.js":1}],3:[function(require,module,exports){
	(function(EventListenerInterceptor) {
	  /**
	   * Event listener options support
	   */

	  EventListenerInterceptor.detectSupportedOptions = function() {
	    var _this = this;

	    this.supportedOptions = {
	      once: false,
	      passive: false,
	      capture: false,

	      all: false,
	      some: false
	    };

	    document.createDocumentFragment().addEventListener('test', function() {}, {
	      get once() {
	        _this.supportedOptions.once = true;
	        return false;
	      },
	      get passive() {
	        _this.supportedOptions.passive = true;
	        return false;
	      },
	      get capture() {
	        _this.supportedOptions.capture = true;
	        return false;
	      }
	    });

	    // useful shortcuts to detect if options are all/some supported
	    this.supportedOptions.all  = this.supportedOptions.once && this.supportedOptions.passive && this.supportedOptions.capture;
	    this.supportedOptions.some = this.supportedOptions.once || this.supportedOptions.passive || this.supportedOptions.capture;
	  };

	  EventListenerInterceptor.polyfillListenerOptions = function() {
	    this.detectSupportedOptions();
	    if (!this.supportedOptions.all) {
	      var _this = this;

	      this.interceptAll({
	        add: function(normalizedArguments) {
	          // console.log('intercepted', normalizedArguments);

	          var once = normalizedArguments.options.once && !_this.supportedOptions.once;
	          var passive = normalizedArguments.options.passive && !_this.supportedOptions.passive;

	          if (once || passive) {
	            var listener = normalizedArguments.polyfilled.listener;

	            normalizedArguments.polyfilled.listener = function(event) {
	              if(once) {
	                this.removeEventListener(normalizedArguments.type, normalizedArguments.listener, normalizedArguments.options);
	              }

	              if(passive) {
	                event.preventDefault = function() {
	                  throw new Error('Unable to preventDefault inside passive event listener invocation.');
	                };
	              }

	              return listener.call(this, event);
	            };
	          }

	          if (!_this.supportedOptions.some) {
	            normalizedArguments.polyfilled.options = normalizedArguments.options.capture;
	          }
	        }
	      });
	    }
	  };


	  EventListenerInterceptor.polyfillListenerOptions();


	  // var onclick = function() {
	  //   console.log('click');
	  // };

	  // document.body.addEventListener('click', onclick, false);
	  // document.body.addEventListener('click', onclick, { once: true });
	  // document.body.addEventListener('click', onclick, { once: true });
	  // document.body.addEventListener('click', onclick, false);
	  // document.body.addEventListener('click', onclick, false);

	})(require('./EventListenerInterceptor.js'));
	},{"./EventListenerInterceptor.js":1}],4:[function(require,module,exports){
	module.exports = (function() {
	  return function ApplyThisPrototype(event, target) {
	    if ((typeof target === 'object') && (target !== null)) {
	      var proto = Object.getPrototypeOf(target);
	      var property;

	      for (property in proto) {
	        if (!(property in event)) {
	          var descriptor = Object.getOwnPropertyDescriptor(proto, property);
	          if (descriptor) {
	            Object.defineProperty(event, property, descriptor);
	          }
	        }
	      }

	      for (property in target) {
	        if (!(property in event)) {
	          event[property] = target[property];
	        }
	      }
	    }
	  }
	})();

	},{}],5:[function(require,module,exports){
	(function(ApplyThisPrototype) {
	  /**
	   * Polyfill CustomEvent
	   */
	  try {
	    var event = new window.CustomEvent('event', { bubbles: true, cancelable: true });
	  } catch (error) {
	    var CustomEventOriginal = window.CustomEvent || window.Event;
	    var CustomEvent = function(eventName, params) {
	      params = params || {};
	      var event = document.createEvent('CustomEvent');
	      event.initCustomEvent(
	        eventName,
	        (params.bubbles === void 0) ? false : params.bubbles,
	        (params.cancelable === void 0) ? false : params.cancelable,
	        (params.detail === void 0) ? {} : params.detail
	      );
	      ApplyThisPrototype(event, this);
	      return event;
	    };
	    CustomEvent.prototype = CustomEventOriginal.prototype;
	    window.CustomEvent = CustomEvent;
	  }
	})(require('./ApplyThisPrototype.js'));
	},{"./ApplyThisPrototype.js":4}],6:[function(require,module,exports){
	(function(ApplyThisPrototype) {
	  // ✓, ✗

	  /**
	   * Polyfill Event
	   */
	  try {
	    var event = new window.Event('event', { bubbles: true, cancelable: true });
	  } catch(error) {
	    var EventOriginal = window.Event;
	    var Event = function(eventName, params) {
	      params = params || {};
	      var event = document.createEvent('Event');
	      event.initEvent(
	        eventName,
	        (params.bubbles === void 0) ? false : params.bubbles,
	        (params.cancelable === void 0) ? false : params.cancelable,
	        (params.detail === void 0) ? {} : params.detail
	      );
	      ApplyThisPrototype(event, this);
	      return event;
	    };
	    Event.prototype = EventOriginal.prototype;
	    window.Event = Event;
	  }
	})(require('./ApplyThisPrototype.js'));
	},{"./ApplyThisPrototype.js":4}],7:[function(require,module,exports){
	(function(ApplyThisPrototype) {
	  /**
	   * Polyfill FocusEvent : https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/FocusEvent
	   *  - relatedTarget ✓
	   */
	  try {
	    var event = new window.FocusEvent('event', { bubbles: true, cancelable: true });
	  } catch (error) {
	    var FocusEventOriginal = window.FocusEvent || window.Event;
	    var FocusEvent = function(eventName, params) {
	      params = params || {};
	      var event = document.createEvent('FocusEvent');

	      // https://msdn.microsoft.com/en-us/library/ff975954(v=vs.85).aspx
	      event.initFocusEvent(
	        eventName,
	        (params.bubbles === void 0) ? false : params.bubbles,
	        (params.cancelable === void 0) ? false : params.cancelable,
	        (params.view === void 0) ? window : params.view,
	        (params.detail === void 0) ? {} : params.detail,
	        (params.relatedTarget === void 0) ? null : params.relatedTarget
	      );

	      ApplyThisPrototype(event, this);

	      return event;
	    };
	    FocusEvent.prototype = FocusEventOriginal.prototype;
	    window.FocusEvent = FocusEvent;
	  }
	})(require('./ApplyThisPrototype.js'));
	},{"./ApplyThisPrototype.js":4}],8:[function(require,module,exports){
	(function(ApplyThisPrototype) {
	  /**
	   * Polyfill KeyboardEvent : https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/KeyboardEvent
	   *  - key ✓
	   *  - char ✓
	   *  - code ✓
	   *  - location ✓
	   *  - ctrlKey ✓
	   *  - shiftKey ✓
	   *  - altKey ✓
	   *  - metaKey ✓
	   *  - repeat ✓
	   *  - isComposing ✗
	   *  - charCode ✓
	   *  - keyCode ✓
	   *  - which ✓
	   */
	  try {
	    var event = new window.KeyboardEvent('event', { bubbles: true, cancelable: true });
	  } catch (error) {
	    var KeyboardEventOriginal = window.KeyboardEvent || window.Event;
	    var KeyboardEvent = function(eventName, params) {
	      params = params || {};
	      var event = document.createEvent('KeyboardEvent');

	      // https://msdn.microsoft.com/en-us/library/ff975297(v=vs.85).aspx
	      event.initKeyboardEvent(
	        eventName,
	        (params.bubbles === void 0) ? false : params.bubbles,
	        (params.cancelable === void 0) ? false : params.cancelable,
	        (params.view === void 0) ? window : params.view,
	        (params.key === void 0) ? '' : params.key,
	        (params.location === void 0) ? 0 : params.location,
	        ((params.ctrlKey === true) ? 'Control ' : '') +
	        ((params.altKey === true) ? 'Alt ' : '') +
	        ((params.shiftKey === true) ? 'Shift ' : '') +
	        ((params.metaKey === true) ? 'Meta ' : ''),
	        (params.repeat === void 0) ? false : params.repeat,
	        (params.locale === void 0) ? navigator.language : params.locale
	      );

	      event.keyCode   = (params.keyCode === void 0) ? 0 : params.keyCode;
	      event.code      = (params.code === void 0) ? '' : params.code;
	      event.charCode  = (params.charCode === void 0) ? 0 : params.charCode;
	      event.char      = (params.charCode === void 0) ? '' : params.charCode;
	      event.which     = (params.which === void 0) ? 0 : params.which;

	      ApplyThisPrototype(event, this);

	      return event;
	    };
	    KeyboardEvent.prototype = KeyboardEventOriginal.prototype;
	    window.KeyboardEvent = KeyboardEvent;
	  }

	})(require('./ApplyThisPrototype.js'));
	},{"./ApplyThisPrototype.js":4}],9:[function(require,module,exports){
	(function(ApplyThisPrototype) {
	  /**
	   * Polyfill MouseEvent : https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent
	   *  - screenX ✓
	   *  - screenY ✓
	   *  - clientX ✓
	   *  - clientY ✓
	   *  - ctrlKey ✓
	   *  - shiftKey ✓
	   *  - altKey ✓
	   *  - metaKey ✓
	   *  - button ✓
	   *  - buttons ✓
	   *  - region ✓
	   */
	  try {
	    var event = new window.MouseEvent('event', { bubbles: true, cancelable: true });
	  } catch (error) {
	    var MouseEventOriginal = window.MouseEvent || window.Event;
	    var MouseEvent = function(eventName, params) {
	      params = params || {};
	      var event = document.createEvent('MouseEvent');

	      // https://msdn.microsoft.com/en-us/library/ff975292(v=vs.85).aspx
	      event.initMouseEvent(
	        eventName,
	        (params.bubbles === void 0) ? false : params.bubbles,
	        (params.cancelable === void 0) ? false : params.cancelable,
	        (params.view === void 0) ? window : params.view,
	        (params.detail === void 0) ? 0 : params.detail,
	        (params.screenX === void 0) ? 0 : params.screenX,
	        (params.screenY === void 0) ? 0 : params.screenY,
	        (params.clientX === void 0) ? 0 : params.clientX,
	        (params.clientY === void 0) ? 0 : params.clientY,
	        (params.ctrlKey === void 0) ? false : params.ctrlKey,
	        (params.altKey === void 0) ? false : params.altKey,
	        (params.shiftKey === void 0) ? false : params.shiftKey,
	        (params.metaKey === void 0) ? false : params.metaKey,
	        (params.button === void 0) ? 0 : params.button,
	        (params.relatedTarget === void 0) ? null : params.relatedTarget
	      );

	      event.buttons = (params.buttons === void 0) ? 0 : params.buttons;
	      event.region  = (params.region === void 0) ? null : params.region;

	      ApplyThisPrototype(event, this);

	      return event;
	    };
	    MouseEvent.prototype = MouseEventOriginal.prototype;
	    window.MouseEvent = MouseEvent;
	  }
	})(require('./ApplyThisPrototype.js'));
	},{"./ApplyThisPrototype.js":4}],10:[function(require,module,exports){
	(function(ApplyThisPrototype) {
	  /**
	   * Polyfill PointerEvent
	   *  - pointerId ✓
	   *  - width ✓
	   *  - height ✓
	   *  - pressure ✓
	   *  - tangentialPressure ✓
	   *  - tiltX ✓
	   *  - tiltY ✓
	   *  - twist ✓
	   *  - pointerType ✓
	   *  - isPrimary ✓
	   */
	  try {
	    var event = new window.PointerEvent('event', { bubbles: true, cancelable: true });
	  } catch (error) {
	    var PointerEventOriginal = window.PointerEvent || window.Event;
	    var PointerEvent = function(eventName, params) {
	      params = params || {};
	      var event = document.createEvent('PointerEvent');

	      // https://msdn.microsoft.com/en-us/library/jj192039(v=vs.85).aspx
	      event.initPointerEvent(
	        eventName,
	        (params.bubbles === void 0) ? false : params.bubbles,
	        (params.cancelable === void 0) ? false : params.cancelable,
	        (params.view === void 0) ? window : params.view,
	        (params.detail === void 0) ? 0 : params.detail,
	        (params.screenX === void 0) ? 0 : params.screenX,
	        (params.screenY === void 0) ? 0 : params.screenY,
	        (params.clientX === void 0) ? 0 : params.clientX,
	        (params.clientY === void 0) ? 0 : params.clientY,
	        (params.ctrlKey === void 0) ? false : params.ctrlKey,
	        (params.altKey === void 0) ? false : params.altKey,
	        (params.shiftKey === void 0) ? false : params.shiftKey,
	        (params.metaKey === void 0) ? false : params.metaKey,
	        (params.button === void 0) ? 0 : params.button,
	        (params.relatedTarget === void 0) ? null : params.relatedTarget,

	        (params.offsetX  === void 0) ? 0 : params.offsetX,
	        (params.offsetY  === void 0) ? 0 : params.offsetY,
	        (params.width === void 0) ? 1 : params.width,
	        (params.height === void 0) ? 1 : params.height,
	        (params.pressure === void 0) ? 0 : params.pressure,
	        (params.twist === void 0) ? 0 : params.twist,
	        (params.tiltX === void 0) ? 0 : params.tiltX,
	        (params.tiltY === void 0) ? 0 : params.tiltY,
	        (params.pointerId === void 0) ? 0 : params.pointerId,
	        (params.pointerType === void 0) ? '' : params.pointerType,
	        (params.hwTimestamp === void 0) ? 0 : params.hwTimestamp,
	        (params.isPrimary === void 0) ? false : params.isPrimary
	      );

	      event.tangentialPressure = (params.tangentialPressure === void 0) ? 0 : params.tangentialPressure;

	      ApplyThisPrototype(event, this);

	      return event;
	    };

	    PointerEvent.prototype = PointerEventOriginal.prototype;

	    var rotationDescriptor = Object.getOwnPropertyDescriptor(PointerEvent.prototype, 'rotation');
	    if (rotationDescriptor) {
	      Object.defineProperty(PointerEvent.prototype, 'twist', rotationDescriptor);
	    }

	    window.PointerEvent = PointerEvent;
	  }
	})(require('./ApplyThisPrototype.js'));
	},{"./ApplyThisPrototype.js":4}],11:[function(require,module,exports){
	require('./Event.js');
	require('./CustomEvent.js');
	require('./MouseEvent.js');
	require('./KeyboardEvent.js');
	require('./FocusEvent.js');
	require('./PointerEvent.js');
	},{"./CustomEvent.js":5,"./Event.js":6,"./FocusEvent.js":7,"./KeyboardEvent.js":8,"./MouseEvent.js":9,"./PointerEvent.js":10}],12:[function(require,module,exports){
	require('./constructors/index.js');
	require('./ListenerOptions.js');
	require('./ListenerEventTypes.js');

	},{"./ListenerEventTypes.js":2,"./ListenerOptions.js":3,"./constructors/index.js":11}]},{},[12]);

	if (!Element.prototype.matches) {
	    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	if (!Element.prototype.closest) {
	    Element.prototype.closest = function (s) {
	        var el = this;

	        do {
	            if (el.matches(s)) return el;
	            el = el.parentElement || el.parentNode;
	        } while (el !== null && el.nodeType === 1);
	        return null;
	    };
	}

	/*
	 * classList.js: Cross-browser full element.classList implementation.
	 * 1.1.20170427
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: Dedicated to the public domain.
	 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
	 */

	/*global self, document, DOMException */

	/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

	if ("document" in window.self) {

	// Full polyfill for browsers with no classList support
	// Including IE < Edge missing SVGElement.classList
	if (!("classList" in document.createElement("_")) 
		|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

	(function (view) {

	if (!('Element' in view)) return;

	var
		  classListProp = "classList"
		, protoProp = "prototype"
		, elemCtrProto = view.Element[protoProp]
		, objCtr = Object
		, strTrim = String[protoProp].trim || function () {
			return this.replace(/^\s+|\s+$/g, "");
		}
		, arrIndexOf = Array[protoProp].indexOf || function (item) {
			var
				  i = 0
				, len = this.length
			;
			for (; i < len; i++) {
				if (i in this && this[i] === item) {
					return i;
				}
			}
			return -1;
		}
		// Vendors: please allow content code to instantiate DOMExceptions
		, DOMEx = function (type, message) {
			this.name = type;
			this.code = DOMException[type];
			this.message = message;
		}
		, checkTokenAndGetIndex = function (classList, token) {
			if (token === "") {
				throw new DOMEx(
					  "SYNTAX_ERR"
					, "An invalid or illegal string was specified"
				);
			}
			if (/\s/.test(token)) {
				throw new DOMEx(
					  "INVALID_CHARACTER_ERR"
					, "String contains an invalid character"
				);
			}
			return arrIndexOf.call(classList, token);
		}
		, ClassList = function (elem) {
			var
				  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
				, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
				, i = 0
				, len = classes.length
			;
			for (; i < len; i++) {
				this.push(classes[i]);
			}
			this._updateClassName = function () {
				elem.setAttribute("class", this.toString());
			};
		}
		, classListProto = ClassList[protoProp] = []
		, classListGetter = function () {
			return new ClassList(this);
		}
	;
	// Most DOMException implementations don't allow calling DOMException's toString()
	// on non-DOMExceptions. Error's toString() is sufficient here.
	DOMEx[protoProp] = Error[protoProp];
	classListProto.item = function (i) {
		return this[i] || null;
	};
	classListProto.contains = function (token) {
		token += "";
		return checkTokenAndGetIndex(this, token) !== -1;
	};
	classListProto.add = function () {
		var
			  tokens = arguments
			, i = 0
			, l = tokens.length
			, token
			, updated = false
		;
		do {
			token = tokens[i] + "";
			if (checkTokenAndGetIndex(this, token) === -1) {
				this.push(token);
				updated = true;
			}
		}
		while (++i < l);

		if (updated) {
			this._updateClassName();
		}
	};
	classListProto.remove = function () {
		var
			  tokens = arguments
			, i = 0
			, l = tokens.length
			, token
			, updated = false
			, index
		;
		do {
			token = tokens[i] + "";
			index = checkTokenAndGetIndex(this, token);
			while (index !== -1) {
				this.splice(index, 1);
				updated = true;
				index = checkTokenAndGetIndex(this, token);
			}
		}
		while (++i < l);

		if (updated) {
			this._updateClassName();
		}
	};
	classListProto.toggle = function (token, force) {
		token += "";

		var
			  result = this.contains(token)
			, method = result ?
				force !== true && "remove"
			:
				force !== false && "add"
		;

		if (method) {
			this[method](token);
		}

		if (force === true || force === false) {
			return force;
		} else {
			return !result;
		}
	};
	classListProto.toString = function () {
		return this.join(" ");
	};

	if (objCtr.defineProperty) {
		var classListPropDesc = {
			  get: classListGetter
			, enumerable: true
			, configurable: true
		};
		try {
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		} catch (ex) { // IE 8 doesn't support enumerable:true
			// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
			// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
			if (ex.number === undefined || ex.number === -0x7FF5EC54) {
				classListPropDesc.enumerable = false;
				objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
			}
		}
	} else if (objCtr[protoProp].__defineGetter__) {
		elemCtrProto.__defineGetter__(classListProp, classListGetter);
	}

	}(window.self));

	}

	// There is full or partial native classList support, so just check if we need
	// to normalize the add/remove and toggle APIs.

	(function () {

		var testElement = document.createElement("_");

		testElement.classList.add("c1", "c2");

		// Polyfill for IE 10/11 and Firefox <26, where classList.add and
		// classList.remove exist but support only one argument at a time.
		if (!testElement.classList.contains("c2")) {
			var createMethod = function(method) {
				var original = DOMTokenList.prototype[method];

				DOMTokenList.prototype[method] = function(token) {
					var i, len = arguments.length;

					for (i = 0; i < len; i++) {
						token = arguments[i];
						original.call(this, token);
					}
				};
			};
			createMethod('add');
			createMethod('remove');
		}

		testElement.classList.toggle("c3", false);

		// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
		// support the second argument.
		if (testElement.classList.contains("c3")) {
			var _toggle = DOMTokenList.prototype.toggle;

			DOMTokenList.prototype.toggle = function(token, force) {
				if (1 in arguments && !this.contains(token) === !force) {
					return force;
				} else {
					return _toggle.call(this, token);
				}
			};

		}

		testElement = null;
	}());

	}

	/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();

	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}

	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}

	var supportsMicroTasks = isBrowser && window.Promise;

	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}

	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}

	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}

	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }

	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }

	  // Firefox want us to check `-x` and `-y` variations as well

	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;

	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }

	  return getScrollParent(getParentNode(element));
	}

	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}

	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}

	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }

	  var noOffsetParent = isIE(10) ? document.body : null;

	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }

	  var nodeName = offsetParent && offsetParent.nodeName;

	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }

	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }

	  return offsetParent;
	}

	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;

	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}

	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }

	  return node;
	}

	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }

	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;

	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;

	  // Both nodes are inside #document

	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }

	    return getOffsetParent(commonAncestorContainer);
	  }

	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}

	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;

	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }

	  return element[upperSide];
	}

	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}

	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */

	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}

	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}

	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);

	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}

	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();





	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	};

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}

	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};

	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}

	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };

	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;

	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;

	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');

	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }

	  return getClientRect(result);
	}

	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);

	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;

	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);

	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;

	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }

	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }

	  return offsets;
	}

	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);

	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };

	  return getClientRect(offset);
	}

	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}

	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */

	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}

	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	  // NOTE: 1 DOM access here

	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }

	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;

	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }

	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

	  return boundaries;
	}

	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;

	  return width * height;
	}

	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }

	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };

	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });

	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });

	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

	  var variation = placement.split('-')[1];

	  return computedPlacement + (variation ? '-' + variation : '');
	}

	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}

	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}

	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}

	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];

	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);

	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };

	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }

	  return popperOffsets;
	}

	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }

	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}

	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }

	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}

	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);

	      data = fn(data, modifier);
	    }
	  });

	  return data;
	}

	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }

	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };

	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;

	  data.positionFixed = this.options.positionFixed;

	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

	  // run the modifiers
	  data = runModifiers(this.modifiers, data);

	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}

	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}

	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}

	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;

	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }

	  this.disableEventListeners();

	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}

	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}

	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });

	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}

	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;

	  return state;
	}

	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}

	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);

	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });

	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}

	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}

	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}

	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}

	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);

	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);

	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }

	  return data;
	}

	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

	  popper.setAttribute('x-placement', placement);

	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

	  return options;
	}

	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;

	  var noRound = function noRound(v) {
	    return v;
	  };

	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);

	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;

	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}

	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;

	  // Remove this legacy support in Popper.js v2

	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);

	  // Styles
	  var styles = {
	    position: popper.position
	  };

	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';

	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');

	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }

	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };

	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

	  return data;
	}

	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });

	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });

	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;

	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }

	  var arrowElement = options.element;

	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);

	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }

	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;

	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];

	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //

	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);

	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

	  return data;
	}

	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}

	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);

	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}

	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }

	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }

	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';

	  var flipOrder = [];

	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }

	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }

	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);

	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;

	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;

	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }

	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }

	      data.placement = placement + (variation ? '-' + variation : '');

	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;

	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';

	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }

	  return data;
	}

	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];

	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }

	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }

	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}

	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];

	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });

	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));

	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }

	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });

	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;

	  var basePlacement = placement.split('-')[0];

	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }

	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }

	  data.popper = popper;
	  return data;
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }

	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];

	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';

	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;

	  options.boundaries = boundaries;

	  var order = options.priority;
	  var popper = data.offsets.popper;

	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };

	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });

	  data.offsets.popper = popper;

	  return data;
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];

	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;

	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';

	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };

	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }

	  return data;
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }

	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;

	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }

	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }

	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }

	  return data;
	}

	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;

	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);

	  return data;
	}

	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */

	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },

	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },

	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },

	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },

	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },

	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },

	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },

	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },

	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },

	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};

	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */

	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',

	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,

	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,

	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,

	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},

	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},

	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};

	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */

	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */

	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;

	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);

	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };

	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));

	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);

	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };

	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;

	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });

	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });

	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });

	    // fire the first update to position the popper in the right place
	    this.update();

	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }

	    this.state.eventsEnabled = eventsEnabled;
	  }

	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs


	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }

	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */


	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */

	  }]);
	  return Popper;
	}();

	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */


	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;

	/*!
	  * Bootstrap v5.0.0-alpha1 (https://getbootstrap.com/)
	  * Copyright 2011-2020 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
	  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	  */

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}

	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v5.0.0-alpha1): util/index.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	var MAX_UID = 1000000;
	var MILLISECONDS_MULTIPLIER = 1000;
	var TRANSITION_END = 'transitionend'; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

	var toType = function toType(obj) {
	  if (obj === null || obj === undefined) {
	    return "" + obj;
	  }

	  return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
	};
	/**
	 * --------------------------------------------------------------------------
	 * Public Util Api
	 * --------------------------------------------------------------------------
	 */


	var getUID = function getUID(prefix) {
	  do {
	    prefix += Math.floor(Math.random() * MAX_UID);
	  } while (document.getElementById(prefix));

	  return prefix;
	};

	var getSelector = function getSelector(element) {
	  var selector = element.getAttribute('data-target');

	  if (!selector || selector === '#') {
	    var hrefAttr = element.getAttribute('href');
	    selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null;
	  }

	  return selector;
	};

	var getSelectorFromElement = function getSelectorFromElement(element) {
	  var selector = getSelector(element);

	  if (selector) {
	    return document.querySelector(selector) ? selector : null;
	  }

	  return null;
	};

	var getElementFromSelector = function getElementFromSelector(element) {
	  var selector = getSelector(element);
	  return selector ? document.querySelector(selector) : null;
	};

	var getTransitionDurationFromElement = function getTransitionDurationFromElement(element) {
	  if (!element) {
	    return 0;
	  } // Get transition-duration of the element


	  var _window$getComputedSt = window.getComputedStyle(element),
	      transitionDuration = _window$getComputedSt.transitionDuration,
	      transitionDelay = _window$getComputedSt.transitionDelay;

	  var floatTransitionDuration = parseFloat(transitionDuration);
	  var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

	  if (!floatTransitionDuration && !floatTransitionDelay) {
	    return 0;
	  } // If multiple durations are defined, take the first


	  transitionDuration = transitionDuration.split(',')[0];
	  transitionDelay = transitionDelay.split(',')[0];
	  return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
	};

	var triggerTransitionEnd = function triggerTransitionEnd(element) {
	  element.dispatchEvent(new Event(TRANSITION_END));
	};

	var isElement = function isElement(obj) {
	  return (obj[0] || obj).nodeType;
	};

	var emulateTransitionEnd = function emulateTransitionEnd(element, duration) {
	  var called = false;
	  var durationPadding = 5;
	  var emulatedDuration = duration + durationPadding;

	  function listener() {
	    called = true;
	    element.removeEventListener(TRANSITION_END, listener);
	  }

	  element.addEventListener(TRANSITION_END, listener);
	  setTimeout(function () {
	    if (!called) {
	      triggerTransitionEnd(element);
	    }
	  }, emulatedDuration);
	};

	var typeCheckConfig = function typeCheckConfig(componentName, config, configTypes) {
	  Object.keys(configTypes).forEach(function (property) {
	    var expectedTypes = configTypes[property];
	    var value = config[property];
	    var valueType = value && isElement(value) ? 'element' : toType(value);

	    if (!new RegExp(expectedTypes).test(valueType)) {
	      throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
	    }
	  });
	};

	var isVisible = function isVisible(element) {
	  if (!element) {
	    return false;
	  }

	  if (element.style && element.parentNode && element.parentNode.style) {
	    var elementStyle = getComputedStyle(element);
	    var parentNodeStyle = getComputedStyle(element.parentNode);
	    return elementStyle.display !== 'none' && parentNodeStyle.display !== 'none' && elementStyle.visibility !== 'hidden';
	  }

	  return false;
	};

	var findShadowRoot = function findShadowRoot(element) {
	  if (!document.documentElement.attachShadow) {
	    return null;
	  } // Can find the shadow root otherwise it'll return the document


	  if (typeof element.getRootNode === 'function') {
	    var root = element.getRootNode();
	    return root instanceof ShadowRoot ? root : null;
	  }

	  if (element instanceof ShadowRoot) {
	    return element;
	  } // when we don't find a shadow root


	  if (!element.parentNode) {
	    return null;
	  }

	  return findShadowRoot(element.parentNode);
	};

	var noop = function noop() {
	  return function () {};
	};

	var reflow = function reflow(element) {
	  return element.offsetHeight;
	};

	var getjQuery = function getjQuery() {
	  var _window = window,
	      jQuery = _window.jQuery;

	  if (jQuery && !document.body.hasAttribute('data-no-jquery')) {
	    return jQuery;
	  }

	  return null;
	};

	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v5.0.0-alpha1): dom/data.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	 * --------------------------------------------------------------------------
	 */

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	var mapData = function () {
	  var storeData = {};
	  var id = 1;
	  return {
	    set: function set(element, key, data) {
	      if (typeof element.key === 'undefined') {
	        element.key = {
	          key: key,
	          id: id
	        };
	        id++;
	      }

	      storeData[element.key.id] = data;
	    },
	    get: function get(element, key) {
	      if (!element || typeof element.key === 'undefined') {
	        return null;
	      }

	      var keyProperties = element.key;

	      if (keyProperties.key === key) {
	        return storeData[keyProperties.id];
	      }

	      return null;
	    },
	    delete: function _delete(element, key) {
	      if (typeof element.key === 'undefined') {
	        return;
	      }

	      var keyProperties = element.key;

	      if (keyProperties.key === key) {
	        delete storeData[keyProperties.id];
	        delete element.key;
	      }
	    }
	  };
	}();

	var Data = {
	  setData: function setData(instance, key, data) {
	    mapData.set(instance, key, data);
	  },
	  getData: function getData(instance, key) {
	    return mapData.get(instance, key);
	  },
	  removeData: function removeData(instance, key) {
	    mapData.delete(instance, key);
	  }
	};

	/* istanbul ignore file */
	var find$1 = Element.prototype.querySelectorAll;
	var findOne = Element.prototype.querySelector; // MSEdge resets defaultPrevented flag upon dispatchEvent call if at least one listener is attached

	var defaultPreventedPreservedOnDispatch = function () {
	  var e = new CustomEvent('Bootstrap', {
	    cancelable: true
	  });
	  var element = document.createElement('div');
	  element.addEventListener('Bootstrap', function () {
	    return null;
	  });
	  e.preventDefault();
	  element.dispatchEvent(e);
	  return e.defaultPrevented;
	}();

	var scopeSelectorRegex = /:scope\b/;

	var supportScopeQuery = function () {
	  var element = document.createElement('div');

	  try {
	    element.querySelectorAll(':scope *');
	  } catch (_) {
	    return false;
	  }

	  return true;
	}();

	if (!supportScopeQuery) {
	  find$1 = function find(selector) {
	    if (!scopeSelectorRegex.test(selector)) {
	      return this.querySelectorAll(selector);
	    }

	    var hasId = Boolean(this.id);

	    if (!hasId) {
	      this.id = getUID('scope');
	    }

	    var nodeList = null;

	    try {
	      selector = selector.replace(scopeSelectorRegex, "#" + this.id);
	      nodeList = this.querySelectorAll(selector);
	    } finally {
	      if (!hasId) {
	        this.removeAttribute('id');
	      }
	    }

	    return nodeList;
	  };

	  findOne = function findOne(selector) {
	    if (!scopeSelectorRegex.test(selector)) {
	      return this.querySelector(selector);
	    }

	    var matches = find$1.call(this, selector);

	    if (typeof matches[0] !== 'undefined') {
	      return matches[0];
	    }

	    return null;
	  };
	}

	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v5.0.0-alpha1): dom/event-handler.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var $ = getjQuery();
	var namespaceRegex = /[^.]*(?=\..*)\.|.*/;
	var stripNameRegex = /\..*/;
	var stripUidRegex = /::\d+$/;
	var eventRegistry = {}; // Events storage

	var uidEvent = 1;
	var customEvents = {
	  mouseenter: 'mouseover',
	  mouseleave: 'mouseout'
	};
	var nativeEvents = ['click', 'dblclick', 'mouseup', 'mousedown', 'contextmenu', 'mousewheel', 'DOMMouseScroll', 'mouseover', 'mouseout', 'mousemove', 'selectstart', 'selectend', 'keydown', 'keypress', 'keyup', 'orientationchange', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel', 'gesturestart', 'gesturechange', 'gestureend', 'focus', 'blur', 'change', 'reset', 'select', 'submit', 'focusin', 'focusout', 'load', 'unload', 'beforeunload', 'resize', 'move', 'DOMContentLoaded', 'readystatechange', 'error', 'abort', 'scroll'];
	/**
	 * ------------------------------------------------------------------------
	 * Private methods
	 * ------------------------------------------------------------------------
	 */

	function getUidEvent(element, uid) {
	  return uid && uid + "::" + uidEvent++ || element.uidEvent || uidEvent++;
	}

	function getEvent(element) {
	  var uid = getUidEvent(element);
	  element.uidEvent = uid;
	  eventRegistry[uid] = eventRegistry[uid] || {};
	  return eventRegistry[uid];
	}

	function bootstrapHandler(element, fn) {
	  return function handler(event) {
	    if (handler.oneOff) {
	      EventHandler.off(element, event.type, fn);
	    }

	    return fn.apply(element, [event]);
	  };
	}

	function bootstrapDelegationHandler(element, selector, fn) {
	  return function handler(event) {
	    var domElements = element.querySelectorAll(selector);

	    for (var target = event.target; target && target !== this; target = target.parentNode) {
	      for (var i = domElements.length; i--;) {
	        if (domElements[i] === target) {
	          if (handler.oneOff) {
	            EventHandler.off(element, event.type, fn);
	          }

	          return fn.apply(target, [event]);
	        }
	      }
	    } // To please ESLint


	    return null;
	  };
	}

	function findHandler(events, handler, delegationSelector) {
	  if (delegationSelector === void 0) {
	    delegationSelector = null;
	  }

	  var uidEventList = Object.keys(events);

	  for (var i = 0, len = uidEventList.length; i < len; i++) {
	    var event = events[uidEventList[i]];

	    if (event.originalHandler === handler && event.delegationSelector === delegationSelector) {
	      return event;
	    }
	  }

	  return null;
	}

	function normalizeParams(originalTypeEvent, handler, delegationFn) {
	  var delegation = typeof handler === 'string';
	  var originalHandler = delegation ? delegationFn : handler; // allow to get the native events from namespaced events ('click.bs.button' --> 'click')

	  var typeEvent = originalTypeEvent.replace(stripNameRegex, '');
	  var custom = customEvents[typeEvent];

	  if (custom) {
	    typeEvent = custom;
	  }

	  var isNative = nativeEvents.indexOf(typeEvent) > -1;

	  if (!isNative) {
	    typeEvent = originalTypeEvent;
	  }

	  return [delegation, originalHandler, typeEvent];
	}

	function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
	  if (typeof originalTypeEvent !== 'string' || !element) {
	    return;
	  }

	  if (!handler) {
	    handler = delegationFn;
	    delegationFn = null;
	  }

	  var _normalizeParams = normalizeParams(originalTypeEvent, handler, delegationFn),
	      delegation = _normalizeParams[0],
	      originalHandler = _normalizeParams[1],
	      typeEvent = _normalizeParams[2];

	  var events = getEvent(element);
	  var handlers = events[typeEvent] || (events[typeEvent] = {});
	  var previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);

	  if (previousFn) {
	    previousFn.oneOff = previousFn.oneOff && oneOff;
	    return;
	  }

	  var uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ''));
	  var fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
	  fn.delegationSelector = delegation ? handler : null;
	  fn.originalHandler = originalHandler;
	  fn.oneOff = oneOff;
	  fn.uidEvent = uid;
	  handlers[uid] = fn;
	  element.addEventListener(typeEvent, fn, delegation);
	}

	function removeHandler(element, events, typeEvent, handler, delegationSelector) {
	  var fn = findHandler(events[typeEvent], handler, delegationSelector);

	  if (!fn) {
	    return;
	  }

	  element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
	  delete events[typeEvent][fn.uidEvent];
	}

	function removeNamespacedHandlers(element, events, typeEvent, namespace) {
	  var storeElementEvent = events[typeEvent] || {};
	  Object.keys(storeElementEvent).forEach(function (handlerKey) {
	    if (handlerKey.indexOf(namespace) > -1) {
	      var event = storeElementEvent[handlerKey];
	      removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
	    }
	  });
	}

	var EventHandler = {
	  on: function on(element, event, handler, delegationFn) {
	    addHandler(element, event, handler, delegationFn, false);
	  },
	  one: function one(element, event, handler, delegationFn) {
	    addHandler(element, event, handler, delegationFn, true);
	  },
	  off: function off(element, originalTypeEvent, handler, delegationFn) {
	    if (typeof originalTypeEvent !== 'string' || !element) {
	      return;
	    }

	    var _normalizeParams2 = normalizeParams(originalTypeEvent, handler, delegationFn),
	        delegation = _normalizeParams2[0],
	        originalHandler = _normalizeParams2[1],
	        typeEvent = _normalizeParams2[2];

	    var inNamespace = typeEvent !== originalTypeEvent;
	    var events = getEvent(element);
	    var isNamespace = originalTypeEvent.charAt(0) === '.';

	    if (typeof originalHandler !== 'undefined') {
	      // Simplest case: handler is passed, remove that listener ONLY.
	      if (!events || !events[typeEvent]) {
	        return;
	      }

	      removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
	      return;
	    }

	    if (isNamespace) {
	      Object.keys(events).forEach(function (elementEvent) {
	        removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
	      });
	    }

	    var storeElementEvent = events[typeEvent] || {};
	    Object.keys(storeElementEvent).forEach(function (keyHandlers) {
	      var handlerKey = keyHandlers.replace(stripUidRegex, '');

	      if (!inNamespace || originalTypeEvent.indexOf(handlerKey) > -1) {
	        var event = storeElementEvent[keyHandlers];
	        removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
	      }
	    });
	  },
	  trigger: function trigger(element, event, args) {
	    if (typeof event !== 'string' || !element) {
	      return null;
	    }

	    var typeEvent = event.replace(stripNameRegex, '');
	    var inNamespace = event !== typeEvent;
	    var isNative = nativeEvents.indexOf(typeEvent) > -1;
	    var jQueryEvent;
	    var bubbles = true;
	    var nativeDispatch = true;
	    var defaultPrevented = false;
	    var evt = null;

	    if (inNamespace && $) {
	      jQueryEvent = $.Event(event, args);
	      $(element).trigger(jQueryEvent);
	      bubbles = !jQueryEvent.isPropagationStopped();
	      nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
	      defaultPrevented = jQueryEvent.isDefaultPrevented();
	    }

	    if (isNative) {
	      evt = document.createEvent('HTMLEvents');
	      evt.initEvent(typeEvent, bubbles, true);
	    } else {
	      evt = new CustomEvent(event, {
	        bubbles: bubbles,
	        cancelable: true
	      });
	    } // merge custom informations in our event


	    if (typeof args !== 'undefined') {
	      Object.keys(args).forEach(function (key) {
	        Object.defineProperty(evt, key, {
	          get: function get() {
	            return args[key];
	          }
	        });
	      });
	    }

	    if (defaultPrevented) {
	      evt.preventDefault();

	      if (!defaultPreventedPreservedOnDispatch) {
	        Object.defineProperty(evt, 'defaultPrevented', {
	          get: function get() {
	            return true;
	          }
	        });
	      }
	    }

	    if (nativeDispatch) {
	      element.dispatchEvent(evt);
	    }

	    if (evt.defaultPrevented && typeof jQueryEvent !== 'undefined') {
	      jQueryEvent.preventDefault();
	    }

	    return evt;
	  }
	};

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'alert';
	var VERSION = '5.0.0-alpha1';
	var DATA_KEY = 'bs.alert';
	var EVENT_KEY = "." + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var SELECTOR_DISMISS = '[data-dismiss="alert"]';
	var EVENT_CLOSE = "close" + EVENT_KEY;
	var EVENT_CLOSED = "closed" + EVENT_KEY;
	var EVENT_CLICK_DATA_API = "click" + EVENT_KEY + DATA_API_KEY;
	var CLASSNAME_ALERT = 'alert';
	var CLASSNAME_FADE = 'fade';
	var CLASSNAME_SHOW = 'show';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Alert = /*#__PURE__*/function () {
	  function Alert(element) {
	    this._element = element;

	    if (this._element) {
	      Data.setData(element, DATA_KEY, this);
	    }
	  } // Getters


	  var _proto = Alert.prototype;

	  // Public
	  _proto.close = function close(element) {
	    var rootElement = this._element;

	    if (element) {
	      rootElement = this._getRootElement(element);
	    }

	    var customEvent = this._triggerCloseEvent(rootElement);

	    if (customEvent === null || customEvent.defaultPrevented) {
	      return;
	    }

	    this._removeElement(rootElement);
	  };

	  _proto.dispose = function dispose() {
	    Data.removeData(this._element, DATA_KEY);
	    this._element = null;
	  } // Private
	  ;

	  _proto._getRootElement = function _getRootElement(element) {
	    return getElementFromSelector(element) || element.closest("." + CLASSNAME_ALERT);
	  };

	  _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
	    return EventHandler.trigger(element, EVENT_CLOSE);
	  };

	  _proto._removeElement = function _removeElement(element) {
	    var _this = this;

	    element.classList.remove(CLASSNAME_SHOW);

	    if (!element.classList.contains(CLASSNAME_FADE)) {
	      this._destroyElement(element);

	      return;
	    }

	    var transitionDuration = getTransitionDurationFromElement(element);
	    EventHandler.one(element, TRANSITION_END, function () {
	      return _this._destroyElement(element);
	    });
	    emulateTransitionEnd(element, transitionDuration);
	  };

	  _proto._destroyElement = function _destroyElement(element) {
	    if (element.parentNode) {
	      element.parentNode.removeChild(element);
	    }

	    EventHandler.trigger(element, EVENT_CLOSED);
	  } // Static
	  ;

	  Alert.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY);

	      if (!data) {
	        data = new Alert(this);
	      }

	      if (config === 'close') {
	        data[config](this);
	      }
	    });
	  };

	  Alert.handleDismiss = function handleDismiss(alertInstance) {
	    return function (event) {
	      if (event) {
	        event.preventDefault();
	      }

	      alertInstance.close(this);
	    };
	  };

	  Alert.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY);
	  };

	  _createClass(Alert, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION;
	    }
	  }]);

	  return Alert;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DISMISS, Alert.handleDismiss(new Alert()));
	var $$1 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .alert to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$1) {
	  var JQUERY_NO_CONFLICT = $$1.fn[NAME];
	  $$1.fn[NAME] = Alert.jQueryInterface;
	  $$1.fn[NAME].Constructor = Alert;

	  $$1.fn[NAME].noConflict = function () {
	    $$1.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Alert.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$1 = 'button';
	var VERSION$1 = '5.0.0-alpha1';
	var DATA_KEY$1 = 'bs.button';
	var EVENT_KEY$1 = "." + DATA_KEY$1;
	var DATA_API_KEY$1 = '.data-api';
	var CLASS_NAME_ACTIVE = 'active';
	var SELECTOR_DATA_TOGGLE = '[data-toggle="button"]';
	var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$1 + DATA_API_KEY$1;
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Button = /*#__PURE__*/function () {
	  function Button(element) {
	    this._element = element;
	    Data.setData(element, DATA_KEY$1, this);
	  } // Getters


	  var _proto = Button.prototype;

	  // Public
	  _proto.toggle = function toggle() {
	    // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
	    this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE));
	  };

	  _proto.dispose = function dispose() {
	    Data.removeData(this._element, DATA_KEY$1);
	    this._element = null;
	  } // Static
	  ;

	  Button.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY$1);

	      if (!data) {
	        data = new Button(this);
	      }

	      if (config === 'toggle') {
	        data[config]();
	      }
	    });
	  };

	  Button.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$1);
	  };

	  _createClass(Button, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$1;
	    }
	  }]);

	  return Button;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE, function (event) {
	  event.preventDefault();
	  var button = event.target.closest(SELECTOR_DATA_TOGGLE);
	  var data = Data.getData(button, DATA_KEY$1);

	  if (!data) {
	    data = new Button(button);
	  }

	  data.toggle();
	});
	var $$2 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .button to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$2) {
	  var JQUERY_NO_CONFLICT$1 = $$2.fn[NAME$1];
	  $$2.fn[NAME$1] = Button.jQueryInterface;
	  $$2.fn[NAME$1].Constructor = Button;

	  $$2.fn[NAME$1].noConflict = function () {
	    $$2.fn[NAME$1] = JQUERY_NO_CONFLICT$1;
	    return Button.jQueryInterface;
	  };
	}

	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v5.0.0-alpha1): dom/manipulator.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	function normalizeData(val) {
	  if (val === 'true') {
	    return true;
	  }

	  if (val === 'false') {
	    return false;
	  }

	  if (val === Number(val).toString()) {
	    return Number(val);
	  }

	  if (val === '' || val === 'null') {
	    return null;
	  }

	  return val;
	}

	function normalizeDataKey(key) {
	  return key.replace(/[A-Z]/g, function (chr) {
	    return "-" + chr.toLowerCase();
	  });
	}

	var Manipulator = {
	  setDataAttribute: function setDataAttribute(element, key, value) {
	    element.setAttribute("data-" + normalizeDataKey(key), value);
	  },
	  removeDataAttribute: function removeDataAttribute(element, key) {
	    element.removeAttribute("data-" + normalizeDataKey(key));
	  },
	  getDataAttributes: function getDataAttributes(element) {
	    if (!element) {
	      return {};
	    }

	    var attributes = _objectSpread2({}, element.dataset);

	    Object.keys(attributes).forEach(function (key) {
	      attributes[key] = normalizeData(attributes[key]);
	    });
	    return attributes;
	  },
	  getDataAttribute: function getDataAttribute(element, key) {
	    return normalizeData(element.getAttribute("data-" + normalizeDataKey(key)));
	  },
	  offset: function offset(element) {
	    var rect = element.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  },
	  position: function position(element) {
	    return {
	      top: element.offsetTop,
	      left: element.offsetLeft
	    };
	  },
	  toggleClass: function toggleClass(element, className) {
	    if (!element) {
	      return;
	    }

	    if (element.classList.contains(className)) {
	      element.classList.remove(className);
	    } else {
	      element.classList.add(className);
	    }
	  }
	};

	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v5.0.0-alpha1): dom/selector-engine.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NODE_TEXT = 3;
	var SelectorEngine = {
	  matches: function matches(element, selector) {
	    return element.matches(selector);
	  },
	  find: function find$1$1(selector, element) {
	    var _ref;

	    if (element === void 0) {
	      element = document.documentElement;
	    }

	    return (_ref = []).concat.apply(_ref, find$1.call(element, selector));
	  },
	  findOne: function findOne$1(selector, element) {
	    if (element === void 0) {
	      element = document.documentElement;
	    }

	    return findOne.call(element, selector);
	  },
	  children: function children(element, selector) {
	    var _ref2;

	    var children = (_ref2 = []).concat.apply(_ref2, element.children);

	    return children.filter(function (child) {
	      return child.matches(selector);
	    });
	  },
	  parents: function parents(element, selector) {
	    var parents = [];
	    var ancestor = element.parentNode;

	    while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT) {
	      if (this.matches(ancestor, selector)) {
	        parents.push(ancestor);
	      }

	      ancestor = ancestor.parentNode;
	    }

	    return parents;
	  },
	  prev: function prev(element, selector) {
	    var previous = element.previousElementSibling;

	    while (previous) {
	      if (previous.matches(selector)) {
	        return [previous];
	      }

	      previous = previous.previousElementSibling;
	    }

	    return [];
	  },
	  next: function next(element, selector) {
	    var next = element.nextElementSibling;

	    while (next) {
	      if (this.matches(next, selector)) {
	        return [next];
	      }

	      next = next.nextElementSibling;
	    }

	    return [];
	  }
	};

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$2 = 'carousel';
	var VERSION$2 = '5.0.0-alpha1';
	var DATA_KEY$2 = 'bs.carousel';
	var EVENT_KEY$2 = "." + DATA_KEY$2;
	var DATA_API_KEY$2 = '.data-api';
	var ARROW_LEFT_KEY = 'ArrowLeft';
	var ARROW_RIGHT_KEY = 'ArrowRight';
	var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

	var SWIPE_THRESHOLD = 40;
	var Default = {
	  interval: 5000,
	  keyboard: true,
	  slide: false,
	  pause: 'hover',
	  wrap: true,
	  touch: true
	};
	var DefaultType = {
	  interval: '(number|boolean)',
	  keyboard: 'boolean',
	  slide: '(boolean|string)',
	  pause: '(string|boolean)',
	  wrap: 'boolean',
	  touch: 'boolean'
	};
	var DIRECTION_NEXT = 'next';
	var DIRECTION_PREV = 'prev';
	var DIRECTION_LEFT = 'left';
	var DIRECTION_RIGHT = 'right';
	var EVENT_SLIDE = "slide" + EVENT_KEY$2;
	var EVENT_SLID = "slid" + EVENT_KEY$2;
	var EVENT_KEYDOWN = "keydown" + EVENT_KEY$2;
	var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$2;
	var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$2;
	var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$2;
	var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$2;
	var EVENT_TOUCHEND = "touchend" + EVENT_KEY$2;
	var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$2;
	var EVENT_POINTERUP = "pointerup" + EVENT_KEY$2;
	var EVENT_DRAG_START = "dragstart" + EVENT_KEY$2;
	var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$2;
	var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$2 + DATA_API_KEY$2;
	var CLASS_NAME_CAROUSEL = 'carousel';
	var CLASS_NAME_ACTIVE$1 = 'active';
	var CLASS_NAME_SLIDE = 'slide';
	var CLASS_NAME_RIGHT = 'carousel-item-right';
	var CLASS_NAME_LEFT = 'carousel-item-left';
	var CLASS_NAME_NEXT = 'carousel-item-next';
	var CLASS_NAME_PREV = 'carousel-item-prev';
	var CLASS_NAME_POINTER_EVENT = 'pointer-event';
	var SELECTOR_ACTIVE = '.active';
	var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
	var SELECTOR_ITEM = '.carousel-item';
	var SELECTOR_ITEM_IMG = '.carousel-item img';
	var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
	var SELECTOR_INDICATORS = '.carousel-indicators';
	var SELECTOR_DATA_SLIDE = '[data-slide], [data-slide-to]';
	var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
	var PointerType = {
	  TOUCH: 'touch',
	  PEN: 'pen'
	};
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Carousel = /*#__PURE__*/function () {
	  function Carousel(element, config) {
	    this._items = null;
	    this._interval = null;
	    this._activeElement = null;
	    this._isPaused = false;
	    this._isSliding = false;
	    this.touchTimeout = null;
	    this.touchStartX = 0;
	    this.touchDeltaX = 0;
	    this._config = this._getConfig(config);
	    this._element = element;
	    this._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, this._element);
	    this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
	    this._pointerEvent = Boolean(window.PointerEvent);

	    this._addEventListeners();

	    Data.setData(element, DATA_KEY$2, this);
	  } // Getters


	  var _proto = Carousel.prototype;

	  // Public
	  _proto.next = function next() {
	    if (!this._isSliding) {
	      this._slide(DIRECTION_NEXT);
	    }
	  };

	  _proto.nextWhenVisible = function nextWhenVisible() {
	    // Don't call next when the page isn't visible
	    // or the carousel or its parent isn't visible
	    if (!document.hidden && isVisible(this._element)) {
	      this.next();
	    }
	  };

	  _proto.prev = function prev() {
	    if (!this._isSliding) {
	      this._slide(DIRECTION_PREV);
	    }
	  };

	  _proto.pause = function pause(event) {
	    if (!event) {
	      this._isPaused = true;
	    }

	    if (SelectorEngine.findOne(SELECTOR_NEXT_PREV, this._element)) {
	      triggerTransitionEnd(this._element);
	      this.cycle(true);
	    }

	    clearInterval(this._interval);
	    this._interval = null;
	  };

	  _proto.cycle = function cycle(event) {
	    if (!event) {
	      this._isPaused = false;
	    }

	    if (this._interval) {
	      clearInterval(this._interval);
	      this._interval = null;
	    }

	    if (this._config && this._config.interval && !this._isPaused) {
	      this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
	    }
	  };

	  _proto.to = function to(index) {
	    var _this = this;

	    this._activeElement = SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

	    var activeIndex = this._getItemIndex(this._activeElement);

	    if (index > this._items.length - 1 || index < 0) {
	      return;
	    }

	    if (this._isSliding) {
	      EventHandler.one(this._element, EVENT_SLID, function () {
	        return _this.to(index);
	      });
	      return;
	    }

	    if (activeIndex === index) {
	      this.pause();
	      this.cycle();
	      return;
	    }

	    var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;

	    this._slide(direction, this._items[index]);
	  };

	  _proto.dispose = function dispose() {
	    EventHandler.off(this._element, EVENT_KEY$2);
	    Data.removeData(this._element, DATA_KEY$2);
	    this._items = null;
	    this._config = null;
	    this._element = null;
	    this._interval = null;
	    this._isPaused = null;
	    this._isSliding = null;
	    this._activeElement = null;
	    this._indicatorsElement = null;
	  } // Private
	  ;

	  _proto._getConfig = function _getConfig(config) {
	    config = _objectSpread2(_objectSpread2({}, Default), config);
	    typeCheckConfig(NAME$2, config, DefaultType);
	    return config;
	  };

	  _proto._handleSwipe = function _handleSwipe() {
	    var absDeltax = Math.abs(this.touchDeltaX);

	    if (absDeltax <= SWIPE_THRESHOLD) {
	      return;
	    }

	    var direction = absDeltax / this.touchDeltaX;
	    this.touchDeltaX = 0; // swipe left

	    if (direction > 0) {
	      this.prev();
	    } // swipe right


	    if (direction < 0) {
	      this.next();
	    }
	  };

	  _proto._addEventListeners = function _addEventListeners() {
	    var _this2 = this;

	    if (this._config.keyboard) {
	      EventHandler.on(this._element, EVENT_KEYDOWN, function (event) {
	        return _this2._keydown(event);
	      });
	    }

	    if (this._config.pause === 'hover') {
	      EventHandler.on(this._element, EVENT_MOUSEENTER, function (event) {
	        return _this2.pause(event);
	      });
	      EventHandler.on(this._element, EVENT_MOUSELEAVE, function (event) {
	        return _this2.cycle(event);
	      });
	    }

	    if (this._config.touch && this._touchSupported) {
	      this._addTouchEventListeners();
	    }
	  };

	  _proto._addTouchEventListeners = function _addTouchEventListeners() {
	    var _this3 = this;

	    var start = function start(event) {
	      if (_this3._pointerEvent && PointerType[event.pointerType.toUpperCase()]) {
	        _this3.touchStartX = event.clientX;
	      } else if (!_this3._pointerEvent) {
	        _this3.touchStartX = event.touches[0].clientX;
	      }
	    };

	    var move = function move(event) {
	      // ensure swiping with one touch and not pinching
	      if (event.touches && event.touches.length > 1) {
	        _this3.touchDeltaX = 0;
	      } else {
	        _this3.touchDeltaX = event.touches[0].clientX - _this3.touchStartX;
	      }
	    };

	    var end = function end(event) {
	      if (_this3._pointerEvent && PointerType[event.pointerType.toUpperCase()]) {
	        _this3.touchDeltaX = event.clientX - _this3.touchStartX;
	      }

	      _this3._handleSwipe();

	      if (_this3._config.pause === 'hover') {
	        // If it's a touch-enabled device, mouseenter/leave are fired as
	        // part of the mouse compatibility events on first tap - the carousel
	        // would stop cycling until user tapped out of it;
	        // here, we listen for touchend, explicitly pause the carousel
	        // (as if it's the second time we tap on it, mouseenter compat event
	        // is NOT fired) and after a timeout (to allow for mouse compatibility
	        // events to fire) we explicitly restart cycling
	        _this3.pause();

	        if (_this3.touchTimeout) {
	          clearTimeout(_this3.touchTimeout);
	        }

	        _this3.touchTimeout = setTimeout(function (event) {
	          return _this3.cycle(event);
	        }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
	      }
	    };

	    SelectorEngine.find(SELECTOR_ITEM_IMG, this._element).forEach(function (itemImg) {
	      EventHandler.on(itemImg, EVENT_DRAG_START, function (e) {
	        return e.preventDefault();
	      });
	    });

	    if (this._pointerEvent) {
	      EventHandler.on(this._element, EVENT_POINTERDOWN, function (event) {
	        return start(event);
	      });
	      EventHandler.on(this._element, EVENT_POINTERUP, function (event) {
	        return end(event);
	      });

	      this._element.classList.add(CLASS_NAME_POINTER_EVENT);
	    } else {
	      EventHandler.on(this._element, EVENT_TOUCHSTART, function (event) {
	        return start(event);
	      });
	      EventHandler.on(this._element, EVENT_TOUCHMOVE, function (event) {
	        return move(event);
	      });
	      EventHandler.on(this._element, EVENT_TOUCHEND, function (event) {
	        return end(event);
	      });
	    }
	  };

	  _proto._keydown = function _keydown(event) {
	    if (/input|textarea/i.test(event.target.tagName)) {
	      return;
	    }

	    switch (event.key) {
	      case ARROW_LEFT_KEY:
	        event.preventDefault();
	        this.prev();
	        break;

	      case ARROW_RIGHT_KEY:
	        event.preventDefault();
	        this.next();
	        break;
	    }
	  };

	  _proto._getItemIndex = function _getItemIndex(element) {
	    this._items = element && element.parentNode ? SelectorEngine.find(SELECTOR_ITEM, element.parentNode) : [];
	    return this._items.indexOf(element);
	  };

	  _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
	    var isNextDirection = direction === DIRECTION_NEXT;
	    var isPrevDirection = direction === DIRECTION_PREV;

	    var activeIndex = this._getItemIndex(activeElement);

	    var lastItemIndex = this._items.length - 1;
	    var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

	    if (isGoingToWrap && !this._config.wrap) {
	      return activeElement;
	    }

	    var delta = direction === DIRECTION_PREV ? -1 : 1;
	    var itemIndex = (activeIndex + delta) % this._items.length;
	    return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
	  };

	  _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
	    var targetIndex = this._getItemIndex(relatedTarget);

	    var fromIndex = this._getItemIndex(SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element));

	    return EventHandler.trigger(this._element, EVENT_SLIDE, {
	      relatedTarget: relatedTarget,
	      direction: eventDirectionName,
	      from: fromIndex,
	      to: targetIndex
	    });
	  };

	  _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
	    if (this._indicatorsElement) {
	      var indicators = SelectorEngine.find(SELECTOR_ACTIVE, this._indicatorsElement);

	      for (var i = 0; i < indicators.length; i++) {
	        indicators[i].classList.remove(CLASS_NAME_ACTIVE$1);
	      }

	      var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

	      if (nextIndicator) {
	        nextIndicator.classList.add(CLASS_NAME_ACTIVE$1);
	      }
	    }
	  };

	  _proto._slide = function _slide(direction, element) {
	    var _this4 = this;

	    var activeElement = SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

	    var activeElementIndex = this._getItemIndex(activeElement);

	    var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

	    var nextElementIndex = this._getItemIndex(nextElement);

	    var isCycling = Boolean(this._interval);
	    var directionalClassName;
	    var orderClassName;
	    var eventDirectionName;

	    if (direction === DIRECTION_NEXT) {
	      directionalClassName = CLASS_NAME_LEFT;
	      orderClassName = CLASS_NAME_NEXT;
	      eventDirectionName = DIRECTION_LEFT;
	    } else {
	      directionalClassName = CLASS_NAME_RIGHT;
	      orderClassName = CLASS_NAME_PREV;
	      eventDirectionName = DIRECTION_RIGHT;
	    }

	    if (nextElement && nextElement.classList.contains(CLASS_NAME_ACTIVE$1)) {
	      this._isSliding = false;
	      return;
	    }

	    var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

	    if (slideEvent.defaultPrevented) {
	      return;
	    }

	    if (!activeElement || !nextElement) {
	      // Some weirdness is happening, so we bail
	      return;
	    }

	    this._isSliding = true;

	    if (isCycling) {
	      this.pause();
	    }

	    this._setActiveIndicatorElement(nextElement);

	    if (this._element.classList.contains(CLASS_NAME_SLIDE)) {
	      nextElement.classList.add(orderClassName);
	      reflow(nextElement);
	      activeElement.classList.add(directionalClassName);
	      nextElement.classList.add(directionalClassName);
	      var nextElementInterval = parseInt(nextElement.getAttribute('data-interval'), 10);

	      if (nextElementInterval) {
	        this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
	        this._config.interval = nextElementInterval;
	      } else {
	        this._config.interval = this._config.defaultInterval || this._config.interval;
	      }

	      var transitionDuration = getTransitionDurationFromElement(activeElement);
	      EventHandler.one(activeElement, TRANSITION_END, function () {
	        nextElement.classList.remove(directionalClassName, orderClassName);
	        nextElement.classList.add(CLASS_NAME_ACTIVE$1);
	        activeElement.classList.remove(CLASS_NAME_ACTIVE$1, orderClassName, directionalClassName);
	        _this4._isSliding = false;
	        setTimeout(function () {
	          EventHandler.trigger(_this4._element, EVENT_SLID, {
	            relatedTarget: nextElement,
	            direction: eventDirectionName,
	            from: activeElementIndex,
	            to: nextElementIndex
	          });
	        }, 0);
	      });
	      emulateTransitionEnd(activeElement, transitionDuration);
	    } else {
	      activeElement.classList.remove(CLASS_NAME_ACTIVE$1);
	      nextElement.classList.add(CLASS_NAME_ACTIVE$1);
	      this._isSliding = false;
	      EventHandler.trigger(this._element, EVENT_SLID, {
	        relatedTarget: nextElement,
	        direction: eventDirectionName,
	        from: activeElementIndex,
	        to: nextElementIndex
	      });
	    }

	    if (isCycling) {
	      this.cycle();
	    }
	  } // Static
	  ;

	  Carousel.carouselInterface = function carouselInterface(element, config) {
	    var data = Data.getData(element, DATA_KEY$2);

	    var _config = _objectSpread2(_objectSpread2({}, Default), Manipulator.getDataAttributes(element));

	    if (typeof config === 'object') {
	      _config = _objectSpread2(_objectSpread2({}, _config), config);
	    }

	    var action = typeof config === 'string' ? config : _config.slide;

	    if (!data) {
	      data = new Carousel(element, _config);
	    }

	    if (typeof config === 'number') {
	      data.to(config);
	    } else if (typeof action === 'string') {
	      if (typeof data[action] === 'undefined') {
	        throw new TypeError("No method named \"" + action + "\"");
	      }

	      data[action]();
	    } else if (_config.interval && _config.ride) {
	      data.pause();
	      data.cycle();
	    }
	  };

	  Carousel.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      Carousel.carouselInterface(this, config);
	    });
	  };

	  Carousel.dataApiClickHandler = function dataApiClickHandler(event) {
	    var target = getElementFromSelector(this);

	    if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) {
	      return;
	    }

	    var config = _objectSpread2(_objectSpread2({}, Manipulator.getDataAttributes(target)), Manipulator.getDataAttributes(this));

	    var slideIndex = this.getAttribute('data-slide-to');

	    if (slideIndex) {
	      config.interval = false;
	    }

	    Carousel.carouselInterface(target, config);

	    if (slideIndex) {
	      Data.getData(target, DATA_KEY$2).to(slideIndex);
	    }

	    event.preventDefault();
	  };

	  Carousel.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$2);
	  };

	  _createClass(Carousel, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$2;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default;
	    }
	  }]);

	  return Carousel;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_SLIDE, Carousel.dataApiClickHandler);
	EventHandler.on(window, EVENT_LOAD_DATA_API, function () {
	  var carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);

	  for (var i = 0, len = carousels.length; i < len; i++) {
	    Carousel.carouselInterface(carousels[i], Data.getData(carousels[i], DATA_KEY$2));
	  }
	});
	var $$3 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .carousel to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$3) {
	  var JQUERY_NO_CONFLICT$2 = $$3.fn[NAME$2];
	  $$3.fn[NAME$2] = Carousel.jQueryInterface;
	  $$3.fn[NAME$2].Constructor = Carousel;

	  $$3.fn[NAME$2].noConflict = function () {
	    $$3.fn[NAME$2] = JQUERY_NO_CONFLICT$2;
	    return Carousel.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$3 = 'collapse';
	var VERSION$3 = '5.0.0-alpha1';
	var DATA_KEY$3 = 'bs.collapse';
	var EVENT_KEY$3 = "." + DATA_KEY$3;
	var DATA_API_KEY$3 = '.data-api';
	var Default$1 = {
	  toggle: true,
	  parent: ''
	};
	var DefaultType$1 = {
	  toggle: 'boolean',
	  parent: '(string|element)'
	};
	var EVENT_SHOW = "show" + EVENT_KEY$3;
	var EVENT_SHOWN = "shown" + EVENT_KEY$3;
	var EVENT_HIDE = "hide" + EVENT_KEY$3;
	var EVENT_HIDDEN = "hidden" + EVENT_KEY$3;
	var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$3 + DATA_API_KEY$3;
	var CLASS_NAME_SHOW = 'show';
	var CLASS_NAME_COLLAPSE = 'collapse';
	var CLASS_NAME_COLLAPSING = 'collapsing';
	var CLASS_NAME_COLLAPSED = 'collapsed';
	var WIDTH = 'width';
	var HEIGHT = 'height';
	var SELECTOR_ACTIVES = '.show, .collapsing';
	var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="collapse"]';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Collapse = /*#__PURE__*/function () {
	  function Collapse(element, config) {
	    this._isTransitioning = false;
	    this._element = element;
	    this._config = this._getConfig(config);
	    this._triggerArray = SelectorEngine.find(SELECTOR_DATA_TOGGLE$1 + "[href=\"#" + element.id + "\"]," + (SELECTOR_DATA_TOGGLE$1 + "[data-target=\"#" + element.id + "\"]"));
	    var toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$1);

	    for (var i = 0, len = toggleList.length; i < len; i++) {
	      var elem = toggleList[i];
	      var selector = getSelectorFromElement(elem);
	      var filterElement = SelectorEngine.find(selector).filter(function (foundElem) {
	        return foundElem === element;
	      });

	      if (selector !== null && filterElement.length) {
	        this._selector = selector;

	        this._triggerArray.push(elem);
	      }
	    }

	    this._parent = this._config.parent ? this._getParent() : null;

	    if (!this._config.parent) {
	      this._addAriaAndCollapsedClass(this._element, this._triggerArray);
	    }

	    if (this._config.toggle) {
	      this.toggle();
	    }

	    Data.setData(element, DATA_KEY$3, this);
	  } // Getters


	  var _proto = Collapse.prototype;

	  // Public
	  _proto.toggle = function toggle() {
	    if (this._element.classList.contains(CLASS_NAME_SHOW)) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };

	  _proto.show = function show() {
	    var _this = this;

	    if (this._isTransitioning || this._element.classList.contains(CLASS_NAME_SHOW)) {
	      return;
	    }

	    var actives;
	    var activesData;

	    if (this._parent) {
	      actives = SelectorEngine.find(SELECTOR_ACTIVES, this._parent).filter(function (elem) {
	        if (typeof _this._config.parent === 'string') {
	          return elem.getAttribute('data-parent') === _this._config.parent;
	        }

	        return elem.classList.contains(CLASS_NAME_COLLAPSE);
	      });

	      if (actives.length === 0) {
	        actives = null;
	      }
	    }

	    var container = SelectorEngine.findOne(this._selector);

	    if (actives) {
	      var tempActiveData = actives.filter(function (elem) {
	        return container !== elem;
	      });
	      activesData = tempActiveData[0] ? Data.getData(tempActiveData[0], DATA_KEY$3) : null;

	      if (activesData && activesData._isTransitioning) {
	        return;
	      }
	    }

	    var startEvent = EventHandler.trigger(this._element, EVENT_SHOW);

	    if (startEvent.defaultPrevented) {
	      return;
	    }

	    if (actives) {
	      actives.forEach(function (elemActive) {
	        if (container !== elemActive) {
	          Collapse.collapseInterface(elemActive, 'hide');
	        }

	        if (!activesData) {
	          Data.setData(elemActive, DATA_KEY$3, null);
	        }
	      });
	    }

	    var dimension = this._getDimension();

	    this._element.classList.remove(CLASS_NAME_COLLAPSE);

	    this._element.classList.add(CLASS_NAME_COLLAPSING);

	    this._element.style[dimension] = 0;

	    if (this._triggerArray.length) {
	      this._triggerArray.forEach(function (element) {
	        element.classList.remove(CLASS_NAME_COLLAPSED);
	        element.setAttribute('aria-expanded', true);
	      });
	    }

	    this.setTransitioning(true);

	    var complete = function complete() {
	      _this._element.classList.remove(CLASS_NAME_COLLAPSING);

	      _this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);

	      _this._element.style[dimension] = '';

	      _this.setTransitioning(false);

	      EventHandler.trigger(_this._element, EVENT_SHOWN);
	    };

	    var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
	    var scrollSize = "scroll" + capitalizedDimension;
	    var transitionDuration = getTransitionDurationFromElement(this._element);
	    EventHandler.one(this._element, TRANSITION_END, complete);
	    emulateTransitionEnd(this._element, transitionDuration);
	    this._element.style[dimension] = this._element[scrollSize] + "px";
	  };

	  _proto.hide = function hide() {
	    var _this2 = this;

	    if (this._isTransitioning || !this._element.classList.contains(CLASS_NAME_SHOW)) {
	      return;
	    }

	    var startEvent = EventHandler.trigger(this._element, EVENT_HIDE);

	    if (startEvent.defaultPrevented) {
	      return;
	    }

	    var dimension = this._getDimension();

	    this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
	    reflow(this._element);

	    this._element.classList.add(CLASS_NAME_COLLAPSING);

	    this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);

	    var triggerArrayLength = this._triggerArray.length;

	    if (triggerArrayLength > 0) {
	      for (var i = 0; i < triggerArrayLength; i++) {
	        var trigger = this._triggerArray[i];
	        var elem = getElementFromSelector(trigger);

	        if (elem && !elem.classList.contains(CLASS_NAME_SHOW)) {
	          trigger.classList.add(CLASS_NAME_COLLAPSED);
	          trigger.setAttribute('aria-expanded', false);
	        }
	      }
	    }

	    this.setTransitioning(true);

	    var complete = function complete() {
	      _this2.setTransitioning(false);

	      _this2._element.classList.remove(CLASS_NAME_COLLAPSING);

	      _this2._element.classList.add(CLASS_NAME_COLLAPSE);

	      EventHandler.trigger(_this2._element, EVENT_HIDDEN);
	    };

	    this._element.style[dimension] = '';
	    var transitionDuration = getTransitionDurationFromElement(this._element);
	    EventHandler.one(this._element, TRANSITION_END, complete);
	    emulateTransitionEnd(this._element, transitionDuration);
	  };

	  _proto.setTransitioning = function setTransitioning(isTransitioning) {
	    this._isTransitioning = isTransitioning;
	  };

	  _proto.dispose = function dispose() {
	    Data.removeData(this._element, DATA_KEY$3);
	    this._config = null;
	    this._parent = null;
	    this._element = null;
	    this._triggerArray = null;
	    this._isTransitioning = null;
	  } // Private
	  ;

	  _proto._getConfig = function _getConfig(config) {
	    config = _objectSpread2(_objectSpread2({}, Default$1), config);
	    config.toggle = Boolean(config.toggle); // Coerce string values

	    typeCheckConfig(NAME$3, config, DefaultType$1);
	    return config;
	  };

	  _proto._getDimension = function _getDimension() {
	    var hasWidth = this._element.classList.contains(WIDTH);

	    return hasWidth ? WIDTH : HEIGHT;
	  };

	  _proto._getParent = function _getParent() {
	    var _this3 = this;

	    var parent = this._config.parent;

	    if (isElement(parent)) {
	      // it's a jQuery object
	      if (typeof parent.jquery !== 'undefined' || typeof parent[0] !== 'undefined') {
	        parent = parent[0];
	      }
	    } else {
	      parent = SelectorEngine.findOne(parent);
	    }

	    var selector = SELECTOR_DATA_TOGGLE$1 + "[data-parent=\"" + parent + "\"]";
	    SelectorEngine.find(selector, parent).forEach(function (element) {
	      var selected = getElementFromSelector(element);

	      _this3._addAriaAndCollapsedClass(selected, [element]);
	    });
	    return parent;
	  };

	  _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
	    if (element) {
	      var isOpen = element.classList.contains(CLASS_NAME_SHOW);

	      if (triggerArray.length) {
	        triggerArray.forEach(function (elem) {
	          if (isOpen) {
	            elem.classList.remove(CLASS_NAME_COLLAPSED);
	          } else {
	            elem.classList.add(CLASS_NAME_COLLAPSED);
	          }

	          elem.setAttribute('aria-expanded', isOpen);
	        });
	      }
	    }
	  } // Static
	  ;

	  Collapse.collapseInterface = function collapseInterface(element, config) {
	    var data = Data.getData(element, DATA_KEY$3);

	    var _config = _objectSpread2(_objectSpread2(_objectSpread2({}, Default$1), Manipulator.getDataAttributes(element)), typeof config === 'object' && config ? config : {});

	    if (!data && _config.toggle && typeof config === 'string' && /show|hide/.test(config)) {
	      _config.toggle = false;
	    }

	    if (!data) {
	      data = new Collapse(element, _config);
	    }

	    if (typeof config === 'string') {
	      if (typeof data[config] === 'undefined') {
	        throw new TypeError("No method named \"" + config + "\"");
	      }

	      data[config]();
	    }
	  };

	  Collapse.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      Collapse.collapseInterface(this, config);
	    });
	  };

	  Collapse.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$3);
	  };

	  _createClass(Collapse, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$3;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default$1;
	    }
	  }]);

	  return Collapse;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$1, function (event) {
	  // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
	  if (event.target.tagName === 'A') {
	    event.preventDefault();
	  }

	  var triggerData = Manipulator.getDataAttributes(this);
	  var selector = getSelectorFromElement(this);
	  var selectorElements = SelectorEngine.find(selector);
	  selectorElements.forEach(function (element) {
	    var data = Data.getData(element, DATA_KEY$3);
	    var config;

	    if (data) {
	      // update parent attribute
	      if (data._parent === null && typeof triggerData.parent === 'string') {
	        data._config.parent = triggerData.parent;
	        data._parent = data._getParent();
	      }

	      config = 'toggle';
	    } else {
	      config = triggerData;
	    }

	    Collapse.collapseInterface(element, config);
	  });
	});
	var $$4 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .collapse to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$4) {
	  var JQUERY_NO_CONFLICT$3 = $$4.fn[NAME$3];
	  $$4.fn[NAME$3] = Collapse.jQueryInterface;
	  $$4.fn[NAME$3].Constructor = Collapse;

	  $$4.fn[NAME$3].noConflict = function () {
	    $$4.fn[NAME$3] = JQUERY_NO_CONFLICT$3;
	    return Collapse.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$4 = 'dropdown';
	var VERSION$4 = '5.0.0-alpha1';
	var DATA_KEY$4 = 'bs.dropdown';
	var EVENT_KEY$4 = "." + DATA_KEY$4;
	var DATA_API_KEY$4 = '.data-api';
	var ESCAPE_KEY = 'Escape';
	var SPACE_KEY = 'Space';
	var TAB_KEY = 'Tab';
	var ARROW_UP_KEY = 'ArrowUp';
	var ARROW_DOWN_KEY = 'ArrowDown';
	var RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button

	var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEY + "|" + ARROW_DOWN_KEY + "|" + ESCAPE_KEY);
	var EVENT_HIDE$1 = "hide" + EVENT_KEY$4;
	var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$4;
	var EVENT_SHOW$1 = "show" + EVENT_KEY$4;
	var EVENT_SHOWN$1 = "shown" + EVENT_KEY$4;
	var EVENT_CLICK = "click" + EVENT_KEY$4;
	var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$4 + DATA_API_KEY$4;
	var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$4 + DATA_API_KEY$4;
	var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$4 + DATA_API_KEY$4;
	var CLASS_NAME_DISABLED = 'disabled';
	var CLASS_NAME_SHOW$1 = 'show';
	var CLASS_NAME_DROPUP = 'dropup';
	var CLASS_NAME_DROPRIGHT = 'dropright';
	var CLASS_NAME_DROPLEFT = 'dropleft';
	var CLASS_NAME_MENURIGHT = 'dropdown-menu-right';
	var CLASS_NAME_NAVBAR = 'navbar';
	var CLASS_NAME_POSITION_STATIC = 'position-static';
	var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
	var SELECTOR_FORM_CHILD = '.dropdown form';
	var SELECTOR_MENU = '.dropdown-menu';
	var SELECTOR_NAVBAR_NAV = '.navbar-nav';
	var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
	var PLACEMENT_TOP = 'top-start';
	var PLACEMENT_TOPEND = 'top-end';
	var PLACEMENT_BOTTOM = 'bottom-start';
	var PLACEMENT_BOTTOMEND = 'bottom-end';
	var PLACEMENT_RIGHT = 'right-start';
	var PLACEMENT_LEFT = 'left-start';
	var Default$2 = {
	  offset: 0,
	  flip: true,
	  boundary: 'scrollParent',
	  reference: 'toggle',
	  display: 'dynamic',
	  popperConfig: null
	};
	var DefaultType$2 = {
	  offset: '(number|string|function)',
	  flip: 'boolean',
	  boundary: '(string|element)',
	  reference: '(string|element)',
	  display: 'string',
	  popperConfig: '(null|object)'
	};
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Dropdown = /*#__PURE__*/function () {
	  function Dropdown(element, config) {
	    this._element = element;
	    this._popper = null;
	    this._config = this._getConfig(config);
	    this._menu = this._getMenuElement();
	    this._inNavbar = this._detectNavbar();

	    this._addEventListeners();

	    Data.setData(element, DATA_KEY$4, this);
	  } // Getters


	  var _proto = Dropdown.prototype;

	  // Public
	  _proto.toggle = function toggle() {
	    if (this._element.disabled || this._element.classList.contains(CLASS_NAME_DISABLED)) {
	      return;
	    }

	    var isActive = this._element.classList.contains(CLASS_NAME_SHOW$1);

	    Dropdown.clearMenus();

	    if (isActive) {
	      return;
	    }

	    this.show();
	  };

	  _proto.show = function show() {
	    if (this._element.disabled || this._element.classList.contains(CLASS_NAME_DISABLED) || this._menu.classList.contains(CLASS_NAME_SHOW$1)) {
	      return;
	    }

	    var parent = Dropdown.getParentFromElement(this._element);
	    var relatedTarget = {
	      relatedTarget: this._element
	    };
	    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$1, relatedTarget);

	    if (showEvent.defaultPrevented) {
	      return;
	    } // Disable totally Popper.js for Dropdown in Navbar


	    if (!this._inNavbar) {
	      if (typeof Popper === 'undefined') {
	        throw new TypeError('Bootstrap\'s dropdowns require Popper.js (https://popper.js.org)');
	      }

	      var referenceElement = this._element;

	      if (this._config.reference === 'parent') {
	        referenceElement = parent;
	      } else if (isElement(this._config.reference)) {
	        referenceElement = this._config.reference; // Check if it's jQuery element

	        if (typeof this._config.reference.jquery !== 'undefined') {
	          referenceElement = this._config.reference[0];
	        }
	      } // If boundary is not `scrollParent`, then set position to `static`
	      // to allow the menu to "escape" the scroll parent's boundaries
	      // https://github.com/twbs/bootstrap/issues/24251


	      if (this._config.boundary !== 'scrollParent') {
	        parent.classList.add(CLASS_NAME_POSITION_STATIC);
	      }

	      this._popper = new Popper(referenceElement, this._menu, this._getPopperConfig());
	    } // If this is a touch-enabled device we add extra
	    // empty mouseover listeners to the body's immediate children;
	    // only needed because of broken event delegation on iOS
	    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


	    if ('ontouchstart' in document.documentElement && !parent.closest(SELECTOR_NAVBAR_NAV)) {
	      var _ref;

	      (_ref = []).concat.apply(_ref, document.body.children).forEach(function (elem) {
	        return EventHandler.on(elem, 'mouseover', null, noop());
	      });
	    }

	    this._element.focus();

	    this._element.setAttribute('aria-expanded', true);

	    Manipulator.toggleClass(this._menu, CLASS_NAME_SHOW$1);
	    Manipulator.toggleClass(this._element, CLASS_NAME_SHOW$1);
	    EventHandler.trigger(parent, EVENT_SHOWN$1, relatedTarget);
	  };

	  _proto.hide = function hide() {
	    if (this._element.disabled || this._element.classList.contains(CLASS_NAME_DISABLED) || !this._menu.classList.contains(CLASS_NAME_SHOW$1)) {
	      return;
	    }

	    var parent = Dropdown.getParentFromElement(this._element);
	    var relatedTarget = {
	      relatedTarget: this._element
	    };
	    var hideEvent = EventHandler.trigger(parent, EVENT_HIDE$1, relatedTarget);

	    if (hideEvent.defaultPrevented) {
	      return;
	    }

	    if (this._popper) {
	      this._popper.destroy();
	    }

	    Manipulator.toggleClass(this._menu, CLASS_NAME_SHOW$1);
	    Manipulator.toggleClass(this._element, CLASS_NAME_SHOW$1);
	    EventHandler.trigger(parent, EVENT_HIDDEN$1, relatedTarget);
	  };

	  _proto.dispose = function dispose() {
	    Data.removeData(this._element, DATA_KEY$4);
	    EventHandler.off(this._element, EVENT_KEY$4);
	    this._element = null;
	    this._menu = null;

	    if (this._popper) {
	      this._popper.destroy();

	      this._popper = null;
	    }
	  };

	  _proto.update = function update() {
	    this._inNavbar = this._detectNavbar();

	    if (this._popper) {
	      this._popper.scheduleUpdate();
	    }
	  } // Private
	  ;

	  _proto._addEventListeners = function _addEventListeners() {
	    var _this = this;

	    EventHandler.on(this._element, EVENT_CLICK, function (event) {
	      event.preventDefault();
	      event.stopPropagation();

	      _this.toggle();
	    });
	  };

	  _proto._getConfig = function _getConfig(config) {
	    config = _objectSpread2(_objectSpread2(_objectSpread2({}, this.constructor.Default), Manipulator.getDataAttributes(this._element)), config);
	    typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
	    return config;
	  };

	  _proto._getMenuElement = function _getMenuElement() {
	    return SelectorEngine.next(this._element, SELECTOR_MENU)[0];
	  };

	  _proto._getPlacement = function _getPlacement() {
	    var parentDropdown = this._element.parentNode;
	    var placement = PLACEMENT_BOTTOM; // Handle dropup

	    if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) {
	      placement = PLACEMENT_TOP;

	      if (this._menu.classList.contains(CLASS_NAME_MENURIGHT)) {
	        placement = PLACEMENT_TOPEND;
	      }
	    } else if (parentDropdown.classList.contains(CLASS_NAME_DROPRIGHT)) {
	      placement = PLACEMENT_RIGHT;
	    } else if (parentDropdown.classList.contains(CLASS_NAME_DROPLEFT)) {
	      placement = PLACEMENT_LEFT;
	    } else if (this._menu.classList.contains(CLASS_NAME_MENURIGHT)) {
	      placement = PLACEMENT_BOTTOMEND;
	    }

	    return placement;
	  };

	  _proto._detectNavbar = function _detectNavbar() {
	    return Boolean(this._element.closest("." + CLASS_NAME_NAVBAR));
	  };

	  _proto._getOffset = function _getOffset() {
	    var _this2 = this;

	    var offset = {};

	    if (typeof this._config.offset === 'function') {
	      offset.fn = function (data) {
	        data.offsets = _objectSpread2(_objectSpread2({}, data.offsets), _this2._config.offset(data.offsets, _this2._element) || {});
	        return data;
	      };
	    } else {
	      offset.offset = this._config.offset;
	    }

	    return offset;
	  };

	  _proto._getPopperConfig = function _getPopperConfig() {
	    var popperConfig = {
	      placement: this._getPlacement(),
	      modifiers: {
	        offset: this._getOffset(),
	        flip: {
	          enabled: this._config.flip
	        },
	        preventOverflow: {
	          boundariesElement: this._config.boundary
	        }
	      }
	    }; // Disable Popper.js if we have a static display

	    if (this._config.display === 'static') {
	      popperConfig.modifiers.applyStyle = {
	        enabled: false
	      };
	    }

	    return _objectSpread2(_objectSpread2({}, popperConfig), this._config.popperConfig);
	  } // Static
	  ;

	  Dropdown.dropdownInterface = function dropdownInterface(element, config) {
	    var data = Data.getData(element, DATA_KEY$4);

	    var _config = typeof config === 'object' ? config : null;

	    if (!data) {
	      data = new Dropdown(element, _config);
	    }

	    if (typeof config === 'string') {
	      if (typeof data[config] === 'undefined') {
	        throw new TypeError("No method named \"" + config + "\"");
	      }

	      data[config]();
	    }
	  };

	  Dropdown.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      Dropdown.dropdownInterface(this, config);
	    });
	  };

	  Dropdown.clearMenus = function clearMenus(event) {
	    if (event && (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY)) {
	      return;
	    }

	    var toggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE$2);

	    for (var i = 0, len = toggles.length; i < len; i++) {
	      var parent = Dropdown.getParentFromElement(toggles[i]);
	      var context = Data.getData(toggles[i], DATA_KEY$4);
	      var relatedTarget = {
	        relatedTarget: toggles[i]
	      };

	      if (event && event.type === 'click') {
	        relatedTarget.clickEvent = event;
	      }

	      if (!context) {
	        continue;
	      }

	      var dropdownMenu = context._menu;

	      if (!toggles[i].classList.contains(CLASS_NAME_SHOW$1)) {
	        continue;
	      }

	      if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.key === TAB_KEY) && dropdownMenu.contains(event.target)) {
	        continue;
	      }

	      var hideEvent = EventHandler.trigger(parent, EVENT_HIDE$1, relatedTarget);

	      if (hideEvent.defaultPrevented) {
	        continue;
	      } // If this is a touch-enabled device we remove the extra
	      // empty mouseover listeners we added for iOS support


	      if ('ontouchstart' in document.documentElement) {
	        var _ref2;

	        (_ref2 = []).concat.apply(_ref2, document.body.children).forEach(function (elem) {
	          return EventHandler.off(elem, 'mouseover', null, noop());
	        });
	      }

	      toggles[i].setAttribute('aria-expanded', 'false');

	      if (context._popper) {
	        context._popper.destroy();
	      }

	      dropdownMenu.classList.remove(CLASS_NAME_SHOW$1);
	      toggles[i].classList.remove(CLASS_NAME_SHOW$1);
	      EventHandler.trigger(parent, EVENT_HIDDEN$1, relatedTarget);
	    }
	  };

	  Dropdown.getParentFromElement = function getParentFromElement(element) {
	    return getElementFromSelector(element) || element.parentNode;
	  };

	  Dropdown.dataApiKeydownHandler = function dataApiKeydownHandler(event) {
	    // If not input/textarea:
	    //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
	    // If input/textarea:
	    //  - If space key => not a dropdown command
	    //  - If key is other than escape
	    //    - If key is not up or down => not a dropdown command
	    //    - If trigger inside the menu => not a dropdown command
	    if (/input|textarea/i.test(event.target.tagName) ? event.key === SPACE_KEY || event.key !== ESCAPE_KEY && (event.key !== ARROW_DOWN_KEY && event.key !== ARROW_UP_KEY || event.target.closest(SELECTOR_MENU)) : !REGEXP_KEYDOWN.test(event.key)) {
	      return;
	    }

	    event.preventDefault();
	    event.stopPropagation();

	    if (this.disabled || this.classList.contains(CLASS_NAME_DISABLED)) {
	      return;
	    }

	    var parent = Dropdown.getParentFromElement(this);
	    var isActive = this.classList.contains(CLASS_NAME_SHOW$1);

	    if (event.key === ESCAPE_KEY) {
	      var button = this.matches(SELECTOR_DATA_TOGGLE$2) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$2)[0];
	      button.focus();
	      Dropdown.clearMenus();
	      return;
	    }

	    if (!isActive || event.key === SPACE_KEY) {
	      Dropdown.clearMenus();
	      return;
	    }

	    var items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, parent).filter(isVisible);

	    if (!items.length) {
	      return;
	    }

	    var index = items.indexOf(event.target);

	    if (event.key === ARROW_UP_KEY && index > 0) {
	      // Up
	      index--;
	    }

	    if (event.key === ARROW_DOWN_KEY && index < items.length - 1) {
	      // Down
	      index++;
	    } // index is -1 if the first keydown is an ArrowUp


	    index = index === -1 ? 0 : index;
	    items[index].focus();
	  };

	  Dropdown.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$4);
	  };

	  _createClass(Dropdown, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$4;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default$2;
	    }
	  }, {
	    key: "DefaultType",
	    get: function get() {
	      return DefaultType$2;
	    }
	  }]);

	  return Dropdown;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown.dataApiKeydownHandler);
	EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
	EventHandler.on(document, EVENT_CLICK_DATA_API$4, Dropdown.clearMenus);
	EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
	EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$2, function (event) {
	  event.preventDefault();
	  event.stopPropagation();
	  Dropdown.dropdownInterface(this, 'toggle');
	});
	EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_FORM_CHILD, function (e) {
	  return e.stopPropagation();
	});
	var $$5 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .dropdown to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$5) {
	  var JQUERY_NO_CONFLICT$4 = $$5.fn[NAME$4];
	  $$5.fn[NAME$4] = Dropdown.jQueryInterface;
	  $$5.fn[NAME$4].Constructor = Dropdown;

	  $$5.fn[NAME$4].noConflict = function () {
	    $$5.fn[NAME$4] = JQUERY_NO_CONFLICT$4;
	    return Dropdown.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$5 = 'modal';
	var VERSION$5 = '5.0.0-alpha1';
	var DATA_KEY$5 = 'bs.modal';
	var EVENT_KEY$5 = "." + DATA_KEY$5;
	var DATA_API_KEY$5 = '.data-api';
	var ESCAPE_KEY$1 = 'Escape';
	var Default$3 = {
	  backdrop: true,
	  keyboard: true,
	  focus: true,
	  show: true
	};
	var DefaultType$3 = {
	  backdrop: '(boolean|string)',
	  keyboard: 'boolean',
	  focus: 'boolean',
	  show: 'boolean'
	};
	var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
	var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
	var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
	var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
	var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
	var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
	var EVENT_RESIZE = "resize" + EVENT_KEY$5;
	var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY$5;
	var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
	var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
	var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
	var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$5 + DATA_API_KEY$5;
	var CLASS_NAME_SCROLLBAR_MEASURER = 'modal-scrollbar-measure';
	var CLASS_NAME_BACKDROP = 'modal-backdrop';
	var CLASS_NAME_OPEN = 'modal-open';
	var CLASS_NAME_FADE = 'fade';
	var CLASS_NAME_SHOW$2 = 'show';
	var CLASS_NAME_STATIC = 'modal-static';
	var SELECTOR_DIALOG = '.modal-dialog';
	var SELECTOR_MODAL_BODY = '.modal-body';
	var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="modal"]';
	var SELECTOR_DATA_DISMISS = '[data-dismiss="modal"]';
	var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
	var SELECTOR_STICKY_CONTENT = '.sticky-top';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Modal = /*#__PURE__*/function () {
	  function Modal(element, config) {
	    this._config = this._getConfig(config);
	    this._element = element;
	    this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, element);
	    this._backdrop = null;
	    this._isShown = false;
	    this._isBodyOverflowing = false;
	    this._ignoreBackdropClick = false;
	    this._isTransitioning = false;
	    this._scrollbarWidth = 0;
	    Data.setData(element, DATA_KEY$5, this);
	  } // Getters


	  var _proto = Modal.prototype;

	  // Public
	  _proto.toggle = function toggle(relatedTarget) {
	    return this._isShown ? this.hide() : this.show(relatedTarget);
	  };

	  _proto.show = function show(relatedTarget) {
	    var _this = this;

	    if (this._isShown || this._isTransitioning) {
	      return;
	    }

	    if (this._element.classList.contains(CLASS_NAME_FADE)) {
	      this._isTransitioning = true;
	    }

	    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$2, {
	      relatedTarget: relatedTarget
	    });

	    if (this._isShown || showEvent.defaultPrevented) {
	      return;
	    }

	    this._isShown = true;

	    this._checkScrollbar();

	    this._setScrollbar();

	    this._adjustDialog();

	    this._setEscapeEvent();

	    this._setResizeEvent();

	    EventHandler.on(this._element, EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function (event) {
	      return _this.hide(event);
	    });
	    EventHandler.on(this._dialog, EVENT_MOUSEDOWN_DISMISS, function () {
	      EventHandler.one(_this._element, EVENT_MOUSEUP_DISMISS, function (event) {
	        if (event.target === _this._element) {
	          _this._ignoreBackdropClick = true;
	        }
	      });
	    });

	    this._showBackdrop(function () {
	      return _this._showElement(relatedTarget);
	    });
	  };

	  _proto.hide = function hide(event) {
	    var _this2 = this;

	    if (event) {
	      event.preventDefault();
	    }

	    if (!this._isShown || this._isTransitioning) {
	      return;
	    }

	    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$2);

	    if (hideEvent.defaultPrevented) {
	      return;
	    }

	    this._isShown = false;

	    var transition = this._element.classList.contains(CLASS_NAME_FADE);

	    if (transition) {
	      this._isTransitioning = true;
	    }

	    this._setEscapeEvent();

	    this._setResizeEvent();

	    EventHandler.off(document, EVENT_FOCUSIN);

	    this._element.classList.remove(CLASS_NAME_SHOW$2);

	    EventHandler.off(this._element, EVENT_CLICK_DISMISS);
	    EventHandler.off(this._dialog, EVENT_MOUSEDOWN_DISMISS);

	    if (transition) {
	      var transitionDuration = getTransitionDurationFromElement(this._element);
	      EventHandler.one(this._element, TRANSITION_END, function (event) {
	        return _this2._hideModal(event);
	      });
	      emulateTransitionEnd(this._element, transitionDuration);
	    } else {
	      this._hideModal();
	    }
	  };

	  _proto.dispose = function dispose() {
	    [window, this._element, this._dialog].forEach(function (htmlElement) {
	      return EventHandler.off(htmlElement, EVENT_KEY$5);
	    });
	    /**
	     * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
	     * Do not move `document` in `htmlElements` array
	     * It will remove `EVENT_CLICK_DATA_API` event that should remain
	     */

	    EventHandler.off(document, EVENT_FOCUSIN);
	    Data.removeData(this._element, DATA_KEY$5);
	    this._config = null;
	    this._element = null;
	    this._dialog = null;
	    this._backdrop = null;
	    this._isShown = null;
	    this._isBodyOverflowing = null;
	    this._ignoreBackdropClick = null;
	    this._isTransitioning = null;
	    this._scrollbarWidth = null;
	  };

	  _proto.handleUpdate = function handleUpdate() {
	    this._adjustDialog();
	  } // Private
	  ;

	  _proto._getConfig = function _getConfig(config) {
	    config = _objectSpread2(_objectSpread2({}, Default$3), config);
	    typeCheckConfig(NAME$5, config, DefaultType$3);
	    return config;
	  };

	  _proto._showElement = function _showElement(relatedTarget) {
	    var _this3 = this;

	    var transition = this._element.classList.contains(CLASS_NAME_FADE);

	    var modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);

	    if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
	      // Don't move modal's DOM position
	      document.body.appendChild(this._element);
	    }

	    this._element.style.display = 'block';

	    this._element.removeAttribute('aria-hidden');

	    this._element.setAttribute('aria-modal', true);

	    this._element.setAttribute('role', 'dialog');

	    this._element.scrollTop = 0;

	    if (modalBody) {
	      modalBody.scrollTop = 0;
	    }

	    if (transition) {
	      reflow(this._element);
	    }

	    this._element.classList.add(CLASS_NAME_SHOW$2);

	    if (this._config.focus) {
	      this._enforceFocus();
	    }

	    var transitionComplete = function transitionComplete() {
	      if (_this3._config.focus) {
	        _this3._element.focus();
	      }

	      _this3._isTransitioning = false;
	      EventHandler.trigger(_this3._element, EVENT_SHOWN$2, {
	        relatedTarget: relatedTarget
	      });
	    };

	    if (transition) {
	      var transitionDuration = getTransitionDurationFromElement(this._dialog);
	      EventHandler.one(this._dialog, TRANSITION_END, transitionComplete);
	      emulateTransitionEnd(this._dialog, transitionDuration);
	    } else {
	      transitionComplete();
	    }
	  };

	  _proto._enforceFocus = function _enforceFocus() {
	    var _this4 = this;

	    EventHandler.off(document, EVENT_FOCUSIN); // guard against infinite focus loop

	    EventHandler.on(document, EVENT_FOCUSIN, function (event) {
	      if (document !== event.target && _this4._element !== event.target && !_this4._element.contains(event.target)) {
	        _this4._element.focus();
	      }
	    });
	  };

	  _proto._setEscapeEvent = function _setEscapeEvent() {
	    var _this5 = this;

	    if (this._isShown) {
	      EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, function (event) {
	        if (_this5._config.keyboard && event.key === ESCAPE_KEY$1) {
	          event.preventDefault();

	          _this5.hide();
	        } else if (!_this5._config.keyboard && event.key === ESCAPE_KEY$1) {
	          _this5._triggerBackdropTransition();
	        }
	      });
	    } else {
	      EventHandler.off(this._element, EVENT_KEYDOWN_DISMISS);
	    }
	  };

	  _proto._setResizeEvent = function _setResizeEvent() {
	    var _this6 = this;

	    if (this._isShown) {
	      EventHandler.on(window, EVENT_RESIZE, function () {
	        return _this6._adjustDialog();
	      });
	    } else {
	      EventHandler.off(window, EVENT_RESIZE);
	    }
	  };

	  _proto._hideModal = function _hideModal() {
	    var _this7 = this;

	    this._element.style.display = 'none';

	    this._element.setAttribute('aria-hidden', true);

	    this._element.removeAttribute('aria-modal');

	    this._element.removeAttribute('role');

	    this._isTransitioning = false;

	    this._showBackdrop(function () {
	      document.body.classList.remove(CLASS_NAME_OPEN);

	      _this7._resetAdjustments();

	      _this7._resetScrollbar();

	      EventHandler.trigger(_this7._element, EVENT_HIDDEN$2);
	    });
	  };

	  _proto._removeBackdrop = function _removeBackdrop() {
	    this._backdrop.parentNode.removeChild(this._backdrop);

	    this._backdrop = null;
	  };

	  _proto._showBackdrop = function _showBackdrop(callback) {
	    var _this8 = this;

	    var animate = this._element.classList.contains(CLASS_NAME_FADE) ? CLASS_NAME_FADE : '';

	    if (this._isShown && this._config.backdrop) {
	      this._backdrop = document.createElement('div');
	      this._backdrop.className = CLASS_NAME_BACKDROP;

	      if (animate) {
	        this._backdrop.classList.add(animate);
	      }

	      document.body.appendChild(this._backdrop);
	      EventHandler.on(this._element, EVENT_CLICK_DISMISS, function (event) {
	        if (_this8._ignoreBackdropClick) {
	          _this8._ignoreBackdropClick = false;
	          return;
	        }

	        if (event.target !== event.currentTarget) {
	          return;
	        }

	        _this8._triggerBackdropTransition();
	      });

	      if (animate) {
	        reflow(this._backdrop);
	      }

	      this._backdrop.classList.add(CLASS_NAME_SHOW$2);

	      if (!animate) {
	        callback();
	        return;
	      }

	      var backdropTransitionDuration = getTransitionDurationFromElement(this._backdrop);
	      EventHandler.one(this._backdrop, TRANSITION_END, callback);
	      emulateTransitionEnd(this._backdrop, backdropTransitionDuration);
	    } else if (!this._isShown && this._backdrop) {
	      this._backdrop.classList.remove(CLASS_NAME_SHOW$2);

	      var callbackRemove = function callbackRemove() {
	        _this8._removeBackdrop();

	        callback();
	      };

	      if (this._element.classList.contains(CLASS_NAME_FADE)) {
	        var _backdropTransitionDuration = getTransitionDurationFromElement(this._backdrop);

	        EventHandler.one(this._backdrop, TRANSITION_END, callbackRemove);
	        emulateTransitionEnd(this._backdrop, _backdropTransitionDuration);
	      } else {
	        callbackRemove();
	      }
	    } else {
	      callback();
	    }
	  };

	  _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
	    var _this9 = this;

	    if (this._config.backdrop === 'static') {
	      var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);

	      if (hideEvent.defaultPrevented) {
	        return;
	      }

	      this._element.classList.add(CLASS_NAME_STATIC);

	      var modalTransitionDuration = getTransitionDurationFromElement(this._element);
	      EventHandler.one(this._element, TRANSITION_END, function () {
	        _this9._element.classList.remove(CLASS_NAME_STATIC);
	      });
	      emulateTransitionEnd(this._element, modalTransitionDuration);

	      this._element.focus();
	    } else {
	      this.hide();
	    }
	  } // ----------------------------------------------------------------------
	  // the following methods are used to handle overflowing modals
	  // ----------------------------------------------------------------------
	  ;

	  _proto._adjustDialog = function _adjustDialog() {
	    var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

	    if (!this._isBodyOverflowing && isModalOverflowing) {
	      this._element.style.paddingLeft = this._scrollbarWidth + "px";
	    }

	    if (this._isBodyOverflowing && !isModalOverflowing) {
	      this._element.style.paddingRight = this._scrollbarWidth + "px";
	    }
	  };

	  _proto._resetAdjustments = function _resetAdjustments() {
	    this._element.style.paddingLeft = '';
	    this._element.style.paddingRight = '';
	  };

	  _proto._checkScrollbar = function _checkScrollbar() {
	    var rect = document.body.getBoundingClientRect();
	    this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
	    this._scrollbarWidth = this._getScrollbarWidth();
	  };

	  _proto._setScrollbar = function _setScrollbar() {
	    var _this10 = this;

	    if (this._isBodyOverflowing) {
	      // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
	      //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
	      // Adjust fixed content padding
	      SelectorEngine.find(SELECTOR_FIXED_CONTENT).forEach(function (element) {
	        var actualPadding = element.style.paddingRight;
	        var calculatedPadding = window.getComputedStyle(element)['padding-right'];
	        Manipulator.setDataAttribute(element, 'padding-right', actualPadding);
	        element.style.paddingRight = parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px";
	      }); // Adjust sticky content margin

	      SelectorEngine.find(SELECTOR_STICKY_CONTENT).forEach(function (element) {
	        var actualMargin = element.style.marginRight;
	        var calculatedMargin = window.getComputedStyle(element)['margin-right'];
	        Manipulator.setDataAttribute(element, 'margin-right', actualMargin);
	        element.style.marginRight = parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px";
	      }); // Adjust body padding

	      var actualPadding = document.body.style.paddingRight;
	      var calculatedPadding = window.getComputedStyle(document.body)['padding-right'];
	      Manipulator.setDataAttribute(document.body, 'padding-right', actualPadding);
	      document.body.style.paddingRight = parseFloat(calculatedPadding) + this._scrollbarWidth + "px";
	    }

	    document.body.classList.add(CLASS_NAME_OPEN);
	  };

	  _proto._resetScrollbar = function _resetScrollbar() {
	    // Restore fixed content padding
	    SelectorEngine.find(SELECTOR_FIXED_CONTENT).forEach(function (element) {
	      var padding = Manipulator.getDataAttribute(element, 'padding-right');

	      if (typeof padding !== 'undefined') {
	        Manipulator.removeDataAttribute(element, 'padding-right');
	        element.style.paddingRight = padding;
	      }
	    }); // Restore sticky content and navbar-toggler margin

	    SelectorEngine.find("" + SELECTOR_STICKY_CONTENT).forEach(function (element) {
	      var margin = Manipulator.getDataAttribute(element, 'margin-right');

	      if (typeof margin !== 'undefined') {
	        Manipulator.removeDataAttribute(element, 'margin-right');
	        element.style.marginRight = margin;
	      }
	    }); // Restore body padding

	    var padding = Manipulator.getDataAttribute(document.body, 'padding-right');

	    if (typeof padding === 'undefined') {
	      document.body.style.paddingRight = '';
	    } else {
	      Manipulator.removeDataAttribute(document.body, 'padding-right');
	      document.body.style.paddingRight = padding;
	    }
	  };

	  _proto._getScrollbarWidth = function _getScrollbarWidth() {
	    // thx d.walsh
	    var scrollDiv = document.createElement('div');
	    scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
	    document.body.appendChild(scrollDiv);
	    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	    document.body.removeChild(scrollDiv);
	    return scrollbarWidth;
	  } // Static
	  ;

	  Modal.jQueryInterface = function jQueryInterface(config, relatedTarget) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY$5);

	      var _config = _objectSpread2(_objectSpread2(_objectSpread2({}, Default$3), Manipulator.getDataAttributes(this)), typeof config === 'object' && config ? config : {});

	      if (!data) {
	        data = new Modal(this, _config);
	      }

	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError("No method named \"" + config + "\"");
	        }

	        data[config](relatedTarget);
	      } else if (_config.show) {
	        data.show(relatedTarget);
	      }
	    });
	  };

	  Modal.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$5);
	  };

	  _createClass(Modal, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$5;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default$3;
	    }
	  }]);

	  return Modal;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE$3, function (event) {
	  var _this11 = this;

	  var target = getElementFromSelector(this);

	  if (this.tagName === 'A' || this.tagName === 'AREA') {
	    event.preventDefault();
	  }

	  EventHandler.one(target, EVENT_SHOW$2, function (showEvent) {
	    if (showEvent.defaultPrevented) {
	      // only register focus restorer if modal will actually get shown
	      return;
	    }

	    EventHandler.one(target, EVENT_HIDDEN$2, function () {
	      if (isVisible(_this11)) {
	        _this11.focus();
	      }
	    });
	  });
	  var data = Data.getData(target, DATA_KEY$5);

	  if (!data) {
	    var config = _objectSpread2(_objectSpread2({}, Manipulator.getDataAttributes(target)), Manipulator.getDataAttributes(this));

	    data = new Modal(target, config);
	  }

	  data.show(this);
	});
	var $$6 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .modal to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$6) {
	  var JQUERY_NO_CONFLICT$5 = $$6.fn[NAME$5];
	  $$6.fn[NAME$5] = Modal.jQueryInterface;
	  $$6.fn[NAME$5].Constructor = Modal;

	  $$6.fn[NAME$5].noConflict = function () {
	    $$6.fn[NAME$5] = JQUERY_NO_CONFLICT$5;
	    return Modal.jQueryInterface;
	  };
	}

	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v5.0.0-alpha1): util/sanitizer.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
	var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
	/**
	 * A pattern that recognizes a commonly useful subset of URLs that are safe.
	 *
	 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	 */

	var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/gi;
	/**
	 * A pattern that matches safe data URLs. Only matches image, video and audio types.
	 *
	 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	 */

	var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;

	var allowedAttribute = function allowedAttribute(attr, allowedAttributeList) {
	  var attrName = attr.nodeName.toLowerCase();

	  if (allowedAttributeList.indexOf(attrName) !== -1) {
	    if (uriAttrs.indexOf(attrName) !== -1) {
	      return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
	    }

	    return true;
	  }

	  var regExp = allowedAttributeList.filter(function (attrRegex) {
	    return attrRegex instanceof RegExp;
	  }); // Check if a regular expression validates the attribute.

	  for (var i = 0, len = regExp.length; i < len; i++) {
	    if (attrName.match(regExp[i])) {
	      return true;
	    }
	  }

	  return false;
	};

	var DefaultWhitelist = {
	  // Global attributes allowed on any supplied element below.
	  '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	  a: ['target', 'href', 'title', 'rel'],
	  area: [],
	  b: [],
	  br: [],
	  col: [],
	  code: [],
	  div: [],
	  em: [],
	  hr: [],
	  h1: [],
	  h2: [],
	  h3: [],
	  h4: [],
	  h5: [],
	  h6: [],
	  i: [],
	  img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
	  li: [],
	  ol: [],
	  p: [],
	  pre: [],
	  s: [],
	  small: [],
	  span: [],
	  sub: [],
	  sup: [],
	  strong: [],
	  u: [],
	  ul: []
	};
	function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	  var _ref;

	  if (!unsafeHtml.length) {
	    return unsafeHtml;
	  }

	  if (sanitizeFn && typeof sanitizeFn === 'function') {
	    return sanitizeFn(unsafeHtml);
	  }

	  var domParser = new window.DOMParser();
	  var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
	  var whitelistKeys = Object.keys(whiteList);

	  var elements = (_ref = []).concat.apply(_ref, createdDocument.body.querySelectorAll('*'));

	  var _loop = function _loop(i, len) {
	    var _ref2;

	    var el = elements[i];
	    var elName = el.nodeName.toLowerCase();

	    if (whitelistKeys.indexOf(elName) === -1) {
	      el.parentNode.removeChild(el);
	      return "continue";
	    }

	    var attributeList = (_ref2 = []).concat.apply(_ref2, el.attributes);

	    var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
	    attributeList.forEach(function (attr) {
	      if (!allowedAttribute(attr, whitelistedAttributes)) {
	        el.removeAttribute(attr.nodeName);
	      }
	    });
	  };

	  for (var i = 0, len = elements.length; i < len; i++) {
	    var _ret = _loop(i);

	    if (_ret === "continue") continue;
	  }

	  return createdDocument.body.innerHTML;
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$6 = 'tooltip';
	var VERSION$6 = '5.0.0-alpha1';
	var DATA_KEY$6 = 'bs.tooltip';
	var EVENT_KEY$6 = "." + DATA_KEY$6;
	var CLASS_PREFIX = 'bs-tooltip';
	var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
	var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
	var DefaultType$4 = {
	  animation: 'boolean',
	  template: 'string',
	  title: '(string|element|function)',
	  trigger: 'string',
	  delay: '(number|object)',
	  html: 'boolean',
	  selector: '(string|boolean)',
	  placement: '(string|function)',
	  offset: '(number|string|function)',
	  container: '(string|element|boolean)',
	  fallbackPlacement: '(string|array)',
	  boundary: '(string|element)',
	  sanitize: 'boolean',
	  sanitizeFn: '(null|function)',
	  whiteList: 'object',
	  popperConfig: '(null|object)'
	};
	var AttachmentMap = {
	  AUTO: 'auto',
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	var Default$4 = {
	  animation: true,
	  template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-arrow"></div>' + '<div class="tooltip-inner"></div></div>',
	  trigger: 'hover focus',
	  title: '',
	  delay: 0,
	  html: false,
	  selector: false,
	  placement: 'top',
	  offset: 0,
	  container: false,
	  fallbackPlacement: 'flip',
	  boundary: 'scrollParent',
	  sanitize: true,
	  sanitizeFn: null,
	  whiteList: DefaultWhitelist,
	  popperConfig: null
	};
	var Event$1 = {
	  HIDE: "hide" + EVENT_KEY$6,
	  HIDDEN: "hidden" + EVENT_KEY$6,
	  SHOW: "show" + EVENT_KEY$6,
	  SHOWN: "shown" + EVENT_KEY$6,
	  INSERTED: "inserted" + EVENT_KEY$6,
	  CLICK: "click" + EVENT_KEY$6,
	  FOCUSIN: "focusin" + EVENT_KEY$6,
	  FOCUSOUT: "focusout" + EVENT_KEY$6,
	  MOUSEENTER: "mouseenter" + EVENT_KEY$6,
	  MOUSELEAVE: "mouseleave" + EVENT_KEY$6
	};
	var CLASS_NAME_FADE$1 = 'fade';
	var CLASS_NAME_MODAL = 'modal';
	var CLASS_NAME_SHOW$3 = 'show';
	var HOVER_STATE_SHOW = 'show';
	var HOVER_STATE_OUT = 'out';
	var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
	var TRIGGER_HOVER = 'hover';
	var TRIGGER_FOCUS = 'focus';
	var TRIGGER_CLICK = 'click';
	var TRIGGER_MANUAL = 'manual';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Tooltip = /*#__PURE__*/function () {
	  function Tooltip(element, config) {
	    if (typeof Popper === 'undefined') {
	      throw new TypeError('Bootstrap\'s tooltips require Popper.js (https://popper.js.org)');
	    } // private


	    this._isEnabled = true;
	    this._timeout = 0;
	    this._hoverState = '';
	    this._activeTrigger = {};
	    this._popper = null; // Protected

	    this.element = element;
	    this.config = this._getConfig(config);
	    this.tip = null;

	    this._setListeners();

	    Data.setData(element, this.constructor.DATA_KEY, this);
	  } // Getters


	  var _proto = Tooltip.prototype;

	  // Public
	  _proto.enable = function enable() {
	    this._isEnabled = true;
	  };

	  _proto.disable = function disable() {
	    this._isEnabled = false;
	  };

	  _proto.toggleEnabled = function toggleEnabled() {
	    this._isEnabled = !this._isEnabled;
	  };

	  _proto.toggle = function toggle(event) {
	    if (!this._isEnabled) {
	      return;
	    }

	    if (event) {
	      var dataKey = this.constructor.DATA_KEY;
	      var context = Data.getData(event.target, dataKey);

	      if (!context) {
	        context = new this.constructor(event.target, this._getDelegateConfig());
	        Data.setData(event.target, dataKey, context);
	      }

	      context._activeTrigger.click = !context._activeTrigger.click;

	      if (context._isWithActiveTrigger()) {
	        context._enter(null, context);
	      } else {
	        context._leave(null, context);
	      }
	    } else {
	      if (this.getTipElement().classList.contains(CLASS_NAME_SHOW$3)) {
	        this._leave(null, this);

	        return;
	      }

	      this._enter(null, this);
	    }
	  };

	  _proto.dispose = function dispose() {
	    clearTimeout(this._timeout);
	    Data.removeData(this.element, this.constructor.DATA_KEY);
	    EventHandler.off(this.element, this.constructor.EVENT_KEY);
	    EventHandler.off(this.element.closest("." + CLASS_NAME_MODAL), 'hide.bs.modal', this._hideModalHandler);

	    if (this.tip) {
	      this.tip.parentNode.removeChild(this.tip);
	    }

	    this._isEnabled = null;
	    this._timeout = null;
	    this._hoverState = null;
	    this._activeTrigger = null;

	    if (this._popper) {
	      this._popper.destroy();
	    }

	    this._popper = null;
	    this.element = null;
	    this.config = null;
	    this.tip = null;
	  };

	  _proto.show = function show() {
	    var _this = this;

	    if (this.element.style.display === 'none') {
	      throw new Error('Please use show on visible elements');
	    }

	    if (this.isWithContent() && this._isEnabled) {
	      var showEvent = EventHandler.trigger(this.element, this.constructor.Event.SHOW);
	      var shadowRoot = findShadowRoot(this.element);
	      var isInTheDom = shadowRoot === null ? this.element.ownerDocument.documentElement.contains(this.element) : shadowRoot.contains(this.element);

	      if (showEvent.defaultPrevented || !isInTheDom) {
	        return;
	      }

	      var tip = this.getTipElement();
	      var tipId = getUID(this.constructor.NAME);
	      tip.setAttribute('id', tipId);
	      this.element.setAttribute('aria-describedby', tipId);
	      this.setContent();

	      if (this.config.animation) {
	        tip.classList.add(CLASS_NAME_FADE$1);
	      }

	      var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

	      var attachment = this._getAttachment(placement);

	      this._addAttachmentClass(attachment);

	      var container = this._getContainer();

	      Data.setData(tip, this.constructor.DATA_KEY, this);

	      if (!this.element.ownerDocument.documentElement.contains(this.tip)) {
	        container.appendChild(tip);
	      }

	      EventHandler.trigger(this.element, this.constructor.Event.INSERTED);
	      this._popper = new Popper(this.element, tip, this._getPopperConfig(attachment));
	      tip.classList.add(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we add extra
	      // empty mouseover listeners to the body's immediate children;
	      // only needed because of broken event delegation on iOS
	      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

	      if ('ontouchstart' in document.documentElement) {
	        var _ref;

	        (_ref = []).concat.apply(_ref, document.body.children).forEach(function (element) {
	          EventHandler.on(element, 'mouseover', noop());
	        });
	      }

	      var complete = function complete() {
	        if (_this.config.animation) {
	          _this._fixTransition();
	        }

	        var prevHoverState = _this._hoverState;
	        _this._hoverState = null;
	        EventHandler.trigger(_this.element, _this.constructor.Event.SHOWN);

	        if (prevHoverState === HOVER_STATE_OUT) {
	          _this._leave(null, _this);
	        }
	      };

	      if (this.tip.classList.contains(CLASS_NAME_FADE$1)) {
	        var transitionDuration = getTransitionDurationFromElement(this.tip);
	        EventHandler.one(this.tip, TRANSITION_END, complete);
	        emulateTransitionEnd(this.tip, transitionDuration);
	      } else {
	        complete();
	      }
	    }
	  };

	  _proto.hide = function hide() {
	    var _this2 = this;

	    var tip = this.getTipElement();

	    var complete = function complete() {
	      if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) {
	        tip.parentNode.removeChild(tip);
	      }

	      _this2._cleanTipClass();

	      _this2.element.removeAttribute('aria-describedby');

	      EventHandler.trigger(_this2.element, _this2.constructor.Event.HIDDEN);

	      _this2._popper.destroy();
	    };

	    var hideEvent = EventHandler.trigger(this.element, this.constructor.Event.HIDE);

	    if (hideEvent.defaultPrevented) {
	      return;
	    }

	    tip.classList.remove(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
	    // empty mouseover listeners we added for iOS support

	    if ('ontouchstart' in document.documentElement) {
	      var _ref2;

	      (_ref2 = []).concat.apply(_ref2, document.body.children).forEach(function (element) {
	        return EventHandler.off(element, 'mouseover', noop);
	      });
	    }

	    this._activeTrigger[TRIGGER_CLICK] = false;
	    this._activeTrigger[TRIGGER_FOCUS] = false;
	    this._activeTrigger[TRIGGER_HOVER] = false;

	    if (this.tip.classList.contains(CLASS_NAME_FADE$1)) {
	      var transitionDuration = getTransitionDurationFromElement(tip);
	      EventHandler.one(tip, TRANSITION_END, complete);
	      emulateTransitionEnd(tip, transitionDuration);
	    } else {
	      complete();
	    }

	    this._hoverState = '';
	  };

	  _proto.update = function update() {
	    if (this._popper !== null) {
	      this._popper.scheduleUpdate();
	    }
	  } // Protected
	  ;

	  _proto.isWithContent = function isWithContent() {
	    return Boolean(this.getTitle());
	  };

	  _proto.getTipElement = function getTipElement() {
	    if (this.tip) {
	      return this.tip;
	    }

	    var element = document.createElement('div');
	    element.innerHTML = this.config.template;
	    this.tip = element.children[0];
	    return this.tip;
	  };

	  _proto.setContent = function setContent() {
	    var tip = this.getTipElement();
	    this.setElementContent(SelectorEngine.findOne(SELECTOR_TOOLTIP_INNER, tip), this.getTitle());
	    tip.classList.remove(CLASS_NAME_FADE$1, CLASS_NAME_SHOW$3);
	  };

	  _proto.setElementContent = function setElementContent(element, content) {
	    if (element === null) {
	      return;
	    }

	    if (typeof content === 'object' && isElement(content)) {
	      if (content.jquery) {
	        content = content[0];
	      } // content is a DOM node or a jQuery


	      if (this.config.html) {
	        if (content.parentNode !== element) {
	          element.innerHTML = '';
	          element.appendChild(content);
	        }
	      } else {
	        element.textContent = content.textContent;
	      }

	      return;
	    }

	    if (this.config.html) {
	      if (this.config.sanitize) {
	        content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
	      }

	      element.innerHTML = content;
	    } else {
	      element.textContent = content;
	    }
	  };

	  _proto.getTitle = function getTitle() {
	    var title = this.element.getAttribute('data-original-title');

	    if (!title) {
	      title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
	    }

	    return title;
	  } // Private
	  ;

	  _proto._getPopperConfig = function _getPopperConfig(attachment) {
	    var _this3 = this;

	    var defaultBsConfig = {
	      placement: attachment,
	      modifiers: {
	        offset: this._getOffset(),
	        flip: {
	          behavior: this.config.fallbackPlacement
	        },
	        arrow: {
	          element: "." + this.constructor.NAME + "-arrow"
	        },
	        preventOverflow: {
	          boundariesElement: this.config.boundary
	        }
	      },
	      onCreate: function onCreate(data) {
	        if (data.originalPlacement !== data.placement) {
	          _this3._handlePopperPlacementChange(data);
	        }
	      },
	      onUpdate: function onUpdate(data) {
	        return _this3._handlePopperPlacementChange(data);
	      }
	    };
	    return _objectSpread2(_objectSpread2({}, defaultBsConfig), this.config.popperConfig);
	  };

	  _proto._addAttachmentClass = function _addAttachmentClass(attachment) {
	    this.getTipElement().classList.add(CLASS_PREFIX + "-" + attachment);
	  };

	  _proto._getOffset = function _getOffset() {
	    var _this4 = this;

	    var offset = {};

	    if (typeof this.config.offset === 'function') {
	      offset.fn = function (data) {
	        data.offsets = _objectSpread2(_objectSpread2({}, data.offsets), _this4.config.offset(data.offsets, _this4.element) || {});
	        return data;
	      };
	    } else {
	      offset.offset = this.config.offset;
	    }

	    return offset;
	  };

	  _proto._getContainer = function _getContainer() {
	    if (this.config.container === false) {
	      return document.body;
	    }

	    if (isElement(this.config.container)) {
	      return this.config.container;
	    }

	    return SelectorEngine.findOne(this.config.container);
	  };

	  _proto._getAttachment = function _getAttachment(placement) {
	    return AttachmentMap[placement.toUpperCase()];
	  };

	  _proto._setListeners = function _setListeners() {
	    var _this5 = this;

	    var triggers = this.config.trigger.split(' ');
	    triggers.forEach(function (trigger) {
	      if (trigger === 'click') {
	        EventHandler.on(_this5.element, _this5.constructor.Event.CLICK, _this5.config.selector, function (event) {
	          return _this5.toggle(event);
	        });
	      } else if (trigger !== TRIGGER_MANUAL) {
	        var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
	        var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
	        EventHandler.on(_this5.element, eventIn, _this5.config.selector, function (event) {
	          return _this5._enter(event);
	        });
	        EventHandler.on(_this5.element, eventOut, _this5.config.selector, function (event) {
	          return _this5._leave(event);
	        });
	      }
	    });

	    this._hideModalHandler = function () {
	      if (_this5.element) {
	        _this5.hide();
	      }
	    };

	    EventHandler.on(this.element.closest("." + CLASS_NAME_MODAL), 'hide.bs.modal', this._hideModalHandler);

	    if (this.config.selector) {
	      this.config = _objectSpread2(_objectSpread2({}, this.config), {}, {
	        trigger: 'manual',
	        selector: ''
	      });
	    } else {
	      this._fixTitle();
	    }
	  };

	  _proto._fixTitle = function _fixTitle() {
	    var titleType = typeof this.element.getAttribute('data-original-title');

	    if (this.element.getAttribute('title') || titleType !== 'string') {
	      this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
	      this.element.setAttribute('title', '');
	    }
	  };

	  _proto._enter = function _enter(event, context) {
	    var dataKey = this.constructor.DATA_KEY;
	    context = context || Data.getData(event.target, dataKey);

	    if (!context) {
	      context = new this.constructor(event.target, this._getDelegateConfig());
	      Data.setData(event.target, dataKey, context);
	    }

	    if (event) {
	      context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
	    }

	    if (context.getTipElement().classList.contains(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
	      context._hoverState = HOVER_STATE_SHOW;
	      return;
	    }

	    clearTimeout(context._timeout);
	    context._hoverState = HOVER_STATE_SHOW;

	    if (!context.config.delay || !context.config.delay.show) {
	      context.show();
	      return;
	    }

	    context._timeout = setTimeout(function () {
	      if (context._hoverState === HOVER_STATE_SHOW) {
	        context.show();
	      }
	    }, context.config.delay.show);
	  };

	  _proto._leave = function _leave(event, context) {
	    var dataKey = this.constructor.DATA_KEY;
	    context = context || Data.getData(event.target, dataKey);

	    if (!context) {
	      context = new this.constructor(event.target, this._getDelegateConfig());
	      Data.setData(event.target, dataKey, context);
	    }

	    if (event) {
	      context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
	    }

	    if (context._isWithActiveTrigger()) {
	      return;
	    }

	    clearTimeout(context._timeout);
	    context._hoverState = HOVER_STATE_OUT;

	    if (!context.config.delay || !context.config.delay.hide) {
	      context.hide();
	      return;
	    }

	    context._timeout = setTimeout(function () {
	      if (context._hoverState === HOVER_STATE_OUT) {
	        context.hide();
	      }
	    }, context.config.delay.hide);
	  };

	  _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
	    for (var trigger in this._activeTrigger) {
	      if (this._activeTrigger[trigger]) {
	        return true;
	      }
	    }

	    return false;
	  };

	  _proto._getConfig = function _getConfig(config) {
	    var dataAttributes = Manipulator.getDataAttributes(this.element);
	    Object.keys(dataAttributes).forEach(function (dataAttr) {
	      if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
	        delete dataAttributes[dataAttr];
	      }
	    });

	    if (config && typeof config.container === 'object' && config.container.jquery) {
	      config.container = config.container[0];
	    }

	    config = _objectSpread2(_objectSpread2(_objectSpread2({}, this.constructor.Default), dataAttributes), typeof config === 'object' && config ? config : {});

	    if (typeof config.delay === 'number') {
	      config.delay = {
	        show: config.delay,
	        hide: config.delay
	      };
	    }

	    if (typeof config.title === 'number') {
	      config.title = config.title.toString();
	    }

	    if (typeof config.content === 'number') {
	      config.content = config.content.toString();
	    }

	    typeCheckConfig(NAME$6, config, this.constructor.DefaultType);

	    if (config.sanitize) {
	      config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
	    }

	    return config;
	  };

	  _proto._getDelegateConfig = function _getDelegateConfig() {
	    var config = {};

	    if (this.config) {
	      for (var key in this.config) {
	        if (this.constructor.Default[key] !== this.config[key]) {
	          config[key] = this.config[key];
	        }
	      }
	    }

	    return config;
	  };

	  _proto._cleanTipClass = function _cleanTipClass() {
	    var tip = this.getTipElement();
	    var tabClass = tip.getAttribute('class').match(BSCLS_PREFIX_REGEX);

	    if (tabClass !== null && tabClass.length > 0) {
	      tabClass.map(function (token) {
	        return token.trim();
	      }).forEach(function (tClass) {
	        return tip.classList.remove(tClass);
	      });
	    }
	  };

	  _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
	    var popperInstance = popperData.instance;
	    this.tip = popperInstance.popper;

	    this._cleanTipClass();

	    this._addAttachmentClass(this._getAttachment(popperData.placement));
	  };

	  _proto._fixTransition = function _fixTransition() {
	    var tip = this.getTipElement();
	    var initConfigAnimation = this.config.animation;

	    if (tip.getAttribute('x-placement') !== null) {
	      return;
	    }

	    tip.classList.remove(CLASS_NAME_FADE$1);
	    this.config.animation = false;
	    this.hide();
	    this.show();
	    this.config.animation = initConfigAnimation;
	  } // Static
	  ;

	  Tooltip.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY$6);

	      var _config = typeof config === 'object' && config;

	      if (!data && /dispose|hide/.test(config)) {
	        return;
	      }

	      if (!data) {
	        data = new Tooltip(this, _config);
	      }

	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError("No method named \"" + config + "\"");
	        }

	        data[config]();
	      }
	    });
	  };

	  Tooltip.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$6);
	  };

	  _createClass(Tooltip, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$6;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default$4;
	    }
	  }, {
	    key: "NAME",
	    get: function get() {
	      return NAME$6;
	    }
	  }, {
	    key: "DATA_KEY",
	    get: function get() {
	      return DATA_KEY$6;
	    }
	  }, {
	    key: "Event",
	    get: function get() {
	      return Event$1;
	    }
	  }, {
	    key: "EVENT_KEY",
	    get: function get() {
	      return EVENT_KEY$6;
	    }
	  }, {
	    key: "DefaultType",
	    get: function get() {
	      return DefaultType$4;
	    }
	  }]);

	  return Tooltip;
	}();

	var $$7 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .tooltip to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$7) {
	  var JQUERY_NO_CONFLICT$6 = $$7.fn[NAME$6];
	  $$7.fn[NAME$6] = Tooltip.jQueryInterface;
	  $$7.fn[NAME$6].Constructor = Tooltip;

	  $$7.fn[NAME$6].noConflict = function () {
	    $$7.fn[NAME$6] = JQUERY_NO_CONFLICT$6;
	    return Tooltip.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$7 = 'popover';
	var VERSION$7 = '5.0.0-alpha1';
	var DATA_KEY$7 = 'bs.popover';
	var EVENT_KEY$7 = "." + DATA_KEY$7;
	var CLASS_PREFIX$1 = 'bs-popover';
	var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');

	var Default$5 = _objectSpread2(_objectSpread2({}, Tooltip.Default), {}, {
	  placement: 'right',
	  trigger: 'click',
	  content: '',
	  template: '<div class="popover" role="tooltip">' + '<div class="popover-arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
	});

	var DefaultType$5 = _objectSpread2(_objectSpread2({}, Tooltip.DefaultType), {}, {
	  content: '(string|element|function)'
	});

	var Event$2 = {
	  HIDE: "hide" + EVENT_KEY$7,
	  HIDDEN: "hidden" + EVENT_KEY$7,
	  SHOW: "show" + EVENT_KEY$7,
	  SHOWN: "shown" + EVENT_KEY$7,
	  INSERTED: "inserted" + EVENT_KEY$7,
	  CLICK: "click" + EVENT_KEY$7,
	  FOCUSIN: "focusin" + EVENT_KEY$7,
	  FOCUSOUT: "focusout" + EVENT_KEY$7,
	  MOUSEENTER: "mouseenter" + EVENT_KEY$7,
	  MOUSELEAVE: "mouseleave" + EVENT_KEY$7
	};
	var CLASS_NAME_FADE$2 = 'fade';
	var CLASS_NAME_SHOW$4 = 'show';
	var SELECTOR_TITLE = '.popover-header';
	var SELECTOR_CONTENT = '.popover-body';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Popover = /*#__PURE__*/function (_Tooltip) {
	  _inheritsLoose(Popover, _Tooltip);

	  function Popover() {
	    return _Tooltip.apply(this, arguments) || this;
	  }

	  var _proto = Popover.prototype;

	  // Overrides
	  _proto.isWithContent = function isWithContent() {
	    return this.getTitle() || this._getContent();
	  };

	  _proto.setContent = function setContent() {
	    var tip = this.getTipElement(); // we use append for html objects to maintain js events

	    this.setElementContent(SelectorEngine.findOne(SELECTOR_TITLE, tip), this.getTitle());

	    var content = this._getContent();

	    if (typeof content === 'function') {
	      content = content.call(this.element);
	    }

	    this.setElementContent(SelectorEngine.findOne(SELECTOR_CONTENT, tip), content);
	    tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$4);
	  };

	  _proto._addAttachmentClass = function _addAttachmentClass(attachment) {
	    this.getTipElement().classList.add(CLASS_PREFIX$1 + "-" + attachment);
	  } // Private
	  ;

	  _proto._getContent = function _getContent() {
	    return this.element.getAttribute('data-content') || this.config.content;
	  };

	  _proto._cleanTipClass = function _cleanTipClass() {
	    var tip = this.getTipElement();
	    var tabClass = tip.getAttribute('class').match(BSCLS_PREFIX_REGEX$1);

	    if (tabClass !== null && tabClass.length > 0) {
	      tabClass.map(function (token) {
	        return token.trim();
	      }).forEach(function (tClass) {
	        return tip.classList.remove(tClass);
	      });
	    }
	  } // Static
	  ;

	  Popover.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY$7);

	      var _config = typeof config === 'object' ? config : null;

	      if (!data && /dispose|hide/.test(config)) {
	        return;
	      }

	      if (!data) {
	        data = new Popover(this, _config);
	        Data.setData(this, DATA_KEY$7, data);
	      }

	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError("No method named \"" + config + "\"");
	        }

	        data[config]();
	      }
	    });
	  };

	  Popover.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$7);
	  };

	  _createClass(Popover, null, [{
	    key: "VERSION",
	    // Getters
	    get: function get() {
	      return VERSION$7;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default$5;
	    }
	  }, {
	    key: "NAME",
	    get: function get() {
	      return NAME$7;
	    }
	  }, {
	    key: "DATA_KEY",
	    get: function get() {
	      return DATA_KEY$7;
	    }
	  }, {
	    key: "Event",
	    get: function get() {
	      return Event$2;
	    }
	  }, {
	    key: "EVENT_KEY",
	    get: function get() {
	      return EVENT_KEY$7;
	    }
	  }, {
	    key: "DefaultType",
	    get: function get() {
	      return DefaultType$5;
	    }
	  }]);

	  return Popover;
	}(Tooltip);

	var $$8 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	/* istanbul ignore if */

	if ($$8) {
	  var JQUERY_NO_CONFLICT$7 = $$8.fn[NAME$7];
	  $$8.fn[NAME$7] = Popover.jQueryInterface;
	  $$8.fn[NAME$7].Constructor = Popover;

	  $$8.fn[NAME$7].noConflict = function () {
	    $$8.fn[NAME$7] = JQUERY_NO_CONFLICT$7;
	    return Popover.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$8 = 'scrollspy';
	var VERSION$8 = '5.0.0-alpha1';
	var DATA_KEY$8 = 'bs.scrollspy';
	var EVENT_KEY$8 = "." + DATA_KEY$8;
	var DATA_API_KEY$6 = '.data-api';
	var Default$6 = {
	  offset: 10,
	  method: 'auto',
	  target: ''
	};
	var DefaultType$6 = {
	  offset: 'number',
	  method: 'string',
	  target: '(string|element)'
	};
	var EVENT_ACTIVATE = "activate" + EVENT_KEY$8;
	var EVENT_SCROLL = "scroll" + EVENT_KEY$8;
	var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$6;
	var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
	var CLASS_NAME_ACTIVE$2 = 'active';
	var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
	var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
	var SELECTOR_NAV_LINKS = '.nav-link';
	var SELECTOR_NAV_ITEMS = '.nav-item';
	var SELECTOR_LIST_ITEMS = '.list-group-item';
	var SELECTOR_DROPDOWN = '.dropdown';
	var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
	var METHOD_OFFSET = 'offset';
	var METHOD_POSITION = 'position';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var ScrollSpy = /*#__PURE__*/function () {
	  function ScrollSpy(element, config) {
	    var _this = this;

	    this._element = element;
	    this._scrollElement = element.tagName === 'BODY' ? window : element;
	    this._config = this._getConfig(config);
	    this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " ." + CLASS_NAME_DROPDOWN_ITEM);
	    this._offsets = [];
	    this._targets = [];
	    this._activeTarget = null;
	    this._scrollHeight = 0;
	    EventHandler.on(this._scrollElement, EVENT_SCROLL, function (event) {
	      return _this._process(event);
	    });
	    this.refresh();

	    this._process();

	    Data.setData(element, DATA_KEY$8, this);
	  } // Getters


	  var _proto = ScrollSpy.prototype;

	  // Public
	  _proto.refresh = function refresh() {
	    var _this2 = this;

	    var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
	    var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
	    var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
	    this._offsets = [];
	    this._targets = [];
	    this._scrollHeight = this._getScrollHeight();
	    var targets = SelectorEngine.find(this._selector);
	    targets.map(function (element) {
	      var target;
	      var targetSelector = getSelectorFromElement(element);

	      if (targetSelector) {
	        target = SelectorEngine.findOne(targetSelector);
	      }

	      if (target) {
	        var targetBCR = target.getBoundingClientRect();

	        if (targetBCR.width || targetBCR.height) {
	          return [Manipulator[offsetMethod](target).top + offsetBase, targetSelector];
	        }
	      }

	      return null;
	    }).filter(function (item) {
	      return item;
	    }).sort(function (a, b) {
	      return a[0] - b[0];
	    }).forEach(function (item) {
	      _this2._offsets.push(item[0]);

	      _this2._targets.push(item[1]);
	    });
	  };

	  _proto.dispose = function dispose() {
	    Data.removeData(this._element, DATA_KEY$8);
	    EventHandler.off(this._scrollElement, EVENT_KEY$8);
	    this._element = null;
	    this._scrollElement = null;
	    this._config = null;
	    this._selector = null;
	    this._offsets = null;
	    this._targets = null;
	    this._activeTarget = null;
	    this._scrollHeight = null;
	  } // Private
	  ;

	  _proto._getConfig = function _getConfig(config) {
	    config = _objectSpread2(_objectSpread2({}, Default$6), typeof config === 'object' && config ? config : {});

	    if (typeof config.target !== 'string' && isElement(config.target)) {
	      var id = config.target.id;

	      if (!id) {
	        id = getUID(NAME$8);
	        config.target.id = id;
	      }

	      config.target = "#" + id;
	    }

	    typeCheckConfig(NAME$8, config, DefaultType$6);
	    return config;
	  };

	  _proto._getScrollTop = function _getScrollTop() {
	    return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
	  };

	  _proto._getScrollHeight = function _getScrollHeight() {
	    return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
	  };

	  _proto._getOffsetHeight = function _getOffsetHeight() {
	    return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
	  };

	  _proto._process = function _process() {
	    var scrollTop = this._getScrollTop() + this._config.offset;

	    var scrollHeight = this._getScrollHeight();

	    var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

	    if (this._scrollHeight !== scrollHeight) {
	      this.refresh();
	    }

	    if (scrollTop >= maxScroll) {
	      var target = this._targets[this._targets.length - 1];

	      if (this._activeTarget !== target) {
	        this._activate(target);
	      }

	      return;
	    }

	    if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
	      this._activeTarget = null;

	      this._clear();

	      return;
	    }

	    for (var i = this._offsets.length; i--;) {
	      var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

	      if (isActiveTarget) {
	        this._activate(this._targets[i]);
	      }
	    }
	  };

	  _proto._activate = function _activate(target) {
	    this._activeTarget = target;

	    this._clear();

	    var queries = this._selector.split(',').map(function (selector) {
	      return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
	    });

	    var link = SelectorEngine.findOne(queries.join(','));

	    if (link.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
	      SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE, link.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE$2);
	      link.classList.add(CLASS_NAME_ACTIVE$2);
	    } else {
	      // Set triggered link as active
	      link.classList.add(CLASS_NAME_ACTIVE$2);
	      SelectorEngine.parents(link, SELECTOR_NAV_LIST_GROUP).forEach(function (listGroup) {
	        // Set triggered links parents as active
	        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
	        SelectorEngine.prev(listGroup, SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).forEach(function (item) {
	          return item.classList.add(CLASS_NAME_ACTIVE$2);
	        }); // Handle special case when .nav-link is inside .nav-item

	        SelectorEngine.prev(listGroup, SELECTOR_NAV_ITEMS).forEach(function (navItem) {
	          SelectorEngine.children(navItem, SELECTOR_NAV_LINKS).forEach(function (item) {
	            return item.classList.add(CLASS_NAME_ACTIVE$2);
	          });
	        });
	      });
	    }

	    EventHandler.trigger(this._scrollElement, EVENT_ACTIVATE, {
	      relatedTarget: target
	    });
	  };

	  _proto._clear = function _clear() {
	    SelectorEngine.find(this._selector).filter(function (node) {
	      return node.classList.contains(CLASS_NAME_ACTIVE$2);
	    }).forEach(function (node) {
	      return node.classList.remove(CLASS_NAME_ACTIVE$2);
	    });
	  } // Static
	  ;

	  ScrollSpy.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY$8);

	      var _config = typeof config === 'object' && config;

	      if (!data) {
	        data = new ScrollSpy(this, _config);
	      }

	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError("No method named \"" + config + "\"");
	        }

	        data[config]();
	      }
	    });
	  };

	  ScrollSpy.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$8);
	  };

	  _createClass(ScrollSpy, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$8;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default$6;
	    }
	  }]);

	  return ScrollSpy;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(window, EVENT_LOAD_DATA_API$1, function () {
	  SelectorEngine.find(SELECTOR_DATA_SPY).forEach(function (spy) {
	    return new ScrollSpy(spy, Manipulator.getDataAttributes(spy));
	  });
	});
	var $$9 = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	/* istanbul ignore if */

	if ($$9) {
	  var JQUERY_NO_CONFLICT$8 = $$9.fn[NAME$8];
	  $$9.fn[NAME$8] = ScrollSpy.jQueryInterface;
	  $$9.fn[NAME$8].Constructor = ScrollSpy;

	  $$9.fn[NAME$8].noConflict = function () {
	    $$9.fn[NAME$8] = JQUERY_NO_CONFLICT$8;
	    return ScrollSpy.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$9 = 'tab';
	var VERSION$9 = '5.0.0-alpha1';
	var DATA_KEY$9 = 'bs.tab';
	var EVENT_KEY$9 = "." + DATA_KEY$9;
	var DATA_API_KEY$7 = '.data-api';
	var EVENT_HIDE$3 = "hide" + EVENT_KEY$9;
	var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$9;
	var EVENT_SHOW$3 = "show" + EVENT_KEY$9;
	var EVENT_SHOWN$3 = "shown" + EVENT_KEY$9;
	var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$9 + DATA_API_KEY$7;
	var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
	var CLASS_NAME_ACTIVE$3 = 'active';
	var CLASS_NAME_DISABLED$1 = 'disabled';
	var CLASS_NAME_FADE$3 = 'fade';
	var CLASS_NAME_SHOW$5 = 'show';
	var SELECTOR_DROPDOWN$1 = '.dropdown';
	var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
	var SELECTOR_ACTIVE$1 = '.active';
	var SELECTOR_ACTIVE_UL = ':scope > li > .active';
	var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
	var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
	var SELECTOR_DROPDOWN_ACTIVE_CHILD = ':scope > .dropdown-menu .active';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Tab = /*#__PURE__*/function () {
	  function Tab(element) {
	    this._element = element;
	    Data.setData(this._element, DATA_KEY$9, this);
	  } // Getters


	  var _proto = Tab.prototype;

	  // Public
	  _proto.show = function show() {
	    var _this = this;

	    if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(CLASS_NAME_ACTIVE$3) || this._element.classList.contains(CLASS_NAME_DISABLED$1)) {
	      return;
	    }

	    var previous;
	    var target = getElementFromSelector(this._element);

	    var listElement = this._element.closest(SELECTOR_NAV_LIST_GROUP$1);

	    if (listElement) {
	      var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE$1;
	      previous = SelectorEngine.find(itemSelector, listElement);
	      previous = previous[previous.length - 1];
	    }

	    var hideEvent = null;

	    if (previous) {
	      hideEvent = EventHandler.trigger(previous, EVENT_HIDE$3, {
	        relatedTarget: this._element
	      });
	    }

	    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
	      relatedTarget: previous
	    });

	    if (showEvent.defaultPrevented || hideEvent !== null && hideEvent.defaultPrevented) {
	      return;
	    }

	    this._activate(this._element, listElement);

	    var complete = function complete() {
	      EventHandler.trigger(previous, EVENT_HIDDEN$3, {
	        relatedTarget: _this._element
	      });
	      EventHandler.trigger(_this._element, EVENT_SHOWN$3, {
	        relatedTarget: previous
	      });
	    };

	    if (target) {
	      this._activate(target, target.parentNode, complete);
	    } else {
	      complete();
	    }
	  };

	  _proto.dispose = function dispose() {
	    Data.removeData(this._element, DATA_KEY$9);
	    this._element = null;
	  } // Private
	  ;

	  _proto._activate = function _activate(element, container, callback) {
	    var _this2 = this;

	    var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? SelectorEngine.find(SELECTOR_ACTIVE_UL, container) : SelectorEngine.children(container, SELECTOR_ACTIVE$1);
	    var active = activeElements[0];
	    var isTransitioning = callback && active && active.classList.contains(CLASS_NAME_FADE$3);

	    var complete = function complete() {
	      return _this2._transitionComplete(element, active, callback);
	    };

	    if (active && isTransitioning) {
	      var transitionDuration = getTransitionDurationFromElement(active);
	      active.classList.remove(CLASS_NAME_SHOW$5);
	      EventHandler.one(active, TRANSITION_END, complete);
	      emulateTransitionEnd(active, transitionDuration);
	    } else {
	      complete();
	    }
	  };

	  _proto._transitionComplete = function _transitionComplete(element, active, callback) {
	    if (active) {
	      active.classList.remove(CLASS_NAME_ACTIVE$3);
	      var dropdownChild = SelectorEngine.findOne(SELECTOR_DROPDOWN_ACTIVE_CHILD, active.parentNode);

	      if (dropdownChild) {
	        dropdownChild.classList.remove(CLASS_NAME_ACTIVE$3);
	      }

	      if (active.getAttribute('role') === 'tab') {
	        active.setAttribute('aria-selected', false);
	      }
	    }

	    element.classList.add(CLASS_NAME_ACTIVE$3);

	    if (element.getAttribute('role') === 'tab') {
	      element.setAttribute('aria-selected', true);
	    }

	    reflow(element);

	    if (element.classList.contains(CLASS_NAME_FADE$3)) {
	      element.classList.add(CLASS_NAME_SHOW$5);
	    }

	    if (element.parentNode && element.parentNode.classList.contains(CLASS_NAME_DROPDOWN_MENU)) {
	      var dropdownElement = element.closest(SELECTOR_DROPDOWN$1);

	      if (dropdownElement) {
	        SelectorEngine.find(SELECTOR_DROPDOWN_TOGGLE$1).forEach(function (dropdown) {
	          return dropdown.classList.add(CLASS_NAME_ACTIVE$3);
	        });
	      }

	      element.setAttribute('aria-expanded', true);
	    }

	    if (callback) {
	      callback();
	    }
	  } // Static
	  ;

	  Tab.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY$9) || new Tab(this);

	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError("No method named \"" + config + "\"");
	        }

	        data[config]();
	      }
	    });
	  };

	  Tab.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$9);
	  };

	  _createClass(Tab, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$9;
	    }
	  }]);

	  return Tab;
	}();
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */


	EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$4, function (event) {
	  event.preventDefault();
	  var data = Data.getData(this, DATA_KEY$9) || new Tab(this);
	  data.show();
	});
	var $$a = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .tab to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$a) {
	  var JQUERY_NO_CONFLICT$9 = $$a.fn[NAME$9];
	  $$a.fn[NAME$9] = Tab.jQueryInterface;
	  $$a.fn[NAME$9].Constructor = Tab;

	  $$a.fn[NAME$9].noConflict = function () {
	    $$a.fn[NAME$9] = JQUERY_NO_CONFLICT$9;
	    return Tab.jQueryInterface;
	  };
	}

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME$a = 'toast';
	var VERSION$a = '5.0.0-alpha1';
	var DATA_KEY$a = 'bs.toast';
	var EVENT_KEY$a = "." + DATA_KEY$a;
	var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$a;
	var EVENT_HIDE$4 = "hide" + EVENT_KEY$a;
	var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$a;
	var EVENT_SHOW$4 = "show" + EVENT_KEY$a;
	var EVENT_SHOWN$4 = "shown" + EVENT_KEY$a;
	var CLASS_NAME_FADE$4 = 'fade';
	var CLASS_NAME_HIDE = 'hide';
	var CLASS_NAME_SHOW$6 = 'show';
	var CLASS_NAME_SHOWING = 'showing';
	var DefaultType$7 = {
	  animation: 'boolean',
	  autohide: 'boolean',
	  delay: 'number'
	};
	var Default$7 = {
	  animation: true,
	  autohide: true,
	  delay: 500
	};
	var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="toast"]';
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Toast = /*#__PURE__*/function () {
	  function Toast(element, config) {
	    this._element = element;
	    this._config = this._getConfig(config);
	    this._timeout = null;

	    this._setListeners();

	    Data.setData(element, DATA_KEY$a, this);
	  } // Getters


	  var _proto = Toast.prototype;

	  // Public
	  _proto.show = function show() {
	    var _this = this;

	    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4);

	    if (showEvent.defaultPrevented) {
	      return;
	    }

	    if (this._config.animation) {
	      this._element.classList.add(CLASS_NAME_FADE$4);
	    }

	    var complete = function complete() {
	      _this._element.classList.remove(CLASS_NAME_SHOWING);

	      _this._element.classList.add(CLASS_NAME_SHOW$6);

	      EventHandler.trigger(_this._element, EVENT_SHOWN$4);

	      if (_this._config.autohide) {
	        _this._timeout = setTimeout(function () {
	          _this.hide();
	        }, _this._config.delay);
	      }
	    };

	    this._element.classList.remove(CLASS_NAME_HIDE);

	    reflow(this._element);

	    this._element.classList.add(CLASS_NAME_SHOWING);

	    if (this._config.animation) {
	      var transitionDuration = getTransitionDurationFromElement(this._element);
	      EventHandler.one(this._element, TRANSITION_END, complete);
	      emulateTransitionEnd(this._element, transitionDuration);
	    } else {
	      complete();
	    }
	  };

	  _proto.hide = function hide() {
	    var _this2 = this;

	    if (!this._element.classList.contains(CLASS_NAME_SHOW$6)) {
	      return;
	    }

	    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);

	    if (hideEvent.defaultPrevented) {
	      return;
	    }

	    var complete = function complete() {
	      _this2._element.classList.add(CLASS_NAME_HIDE);

	      EventHandler.trigger(_this2._element, EVENT_HIDDEN$4);
	    };

	    this._element.classList.remove(CLASS_NAME_SHOW$6);

	    if (this._config.animation) {
	      var transitionDuration = getTransitionDurationFromElement(this._element);
	      EventHandler.one(this._element, TRANSITION_END, complete);
	      emulateTransitionEnd(this._element, transitionDuration);
	    } else {
	      complete();
	    }
	  };

	  _proto.dispose = function dispose() {
	    clearTimeout(this._timeout);
	    this._timeout = null;

	    if (this._element.classList.contains(CLASS_NAME_SHOW$6)) {
	      this._element.classList.remove(CLASS_NAME_SHOW$6);
	    }

	    EventHandler.off(this._element, EVENT_CLICK_DISMISS$1);
	    Data.removeData(this._element, DATA_KEY$a);
	    this._element = null;
	    this._config = null;
	  } // Private
	  ;

	  _proto._getConfig = function _getConfig(config) {
	    config = _objectSpread2(_objectSpread2(_objectSpread2({}, Default$7), Manipulator.getDataAttributes(this._element)), typeof config === 'object' && config ? config : {});
	    typeCheckConfig(NAME$a, config, this.constructor.DefaultType);
	    return config;
	  };

	  _proto._setListeners = function _setListeners() {
	    var _this3 = this;

	    EventHandler.on(this._element, EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function () {
	      return _this3.hide();
	    });
	  } // Static
	  ;

	  Toast.jQueryInterface = function jQueryInterface(config) {
	    return this.each(function () {
	      var data = Data.getData(this, DATA_KEY$a);

	      var _config = typeof config === 'object' && config;

	      if (!data) {
	        data = new Toast(this, _config);
	      }

	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError("No method named \"" + config + "\"");
	        }

	        data[config](this);
	      }
	    });
	  };

	  Toast.getInstance = function getInstance(element) {
	    return Data.getData(element, DATA_KEY$a);
	  };

	  _createClass(Toast, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$a;
	    }
	  }, {
	    key: "DefaultType",
	    get: function get() {
	      return DefaultType$7;
	    }
	  }, {
	    key: "Default",
	    get: function get() {
	      return Default$7;
	    }
	  }]);

	  return Toast;
	}();

	var $$b = getjQuery();
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 *  add .toast to jQuery only if jQuery is present
	 */

	/* istanbul ignore if */

	if ($$b) {
	  var JQUERY_NO_CONFLICT$a = $$b.fn[NAME$a];
	  $$b.fn[NAME$a] = Toast.jQueryInterface;
	  $$b.fn[NAME$a].Constructor = Toast;

	  $$b.fn[NAME$a].noConflict = function () {
	    $$b.fn[NAME$a] = JQUERY_NO_CONFLICT$a;
	    return Toast.jQueryInterface;
	  };
	}

	/**
	 * When content is loaded, we query all bootstrap dropdowns with
	 * the data-dropdown-push="#id|.class" attribute to listen to their
	 * shown and hidden events.
	 *
	 * See here: https://v5.getbootstrap.com/docs/5.0/components/dropdowns/#events
	 */
	(function () {
	  document.addEventListener("DOMContentLoaded", function () {
	    Array.prototype.slice.call(document.querySelectorAll(".dropdown[data-dropdown-push]")).forEach(function (element) {
	      element.addEventListener("shown.bs.dropdown", function () {
	        var dropdownMenu = this.querySelectorAll(".dropdown-menu");
	        var height = dropdownMenu.length ? dropdownMenu[0].getBoundingClientRect().height : 0;

	        if (height) {
	          Array.prototype.slice.call(document.querySelectorAll(element.dataset.dropdownPush)).forEach(function (toPushElement) {
	            toPushElement.style.transform = "translate3d(0, " + height + "px, 0)";
	          });
	        }
	      });
	      element.addEventListener("hidden.bs.dropdown", function () {
	        Array.prototype.slice.call(document.querySelectorAll(element.dataset.dropdownPush)).forEach(function (toPushElement) {
	          toPushElement.style.transform = "translateY(0px)";
	        });
	      });
	    });
	  });
	})();

	var bsCustomFileInput = createCommonjsModule(function (module, exports) {
	/*!
	 * bsCustomFileInput v1.3.4 (https://github.com/Johann-S/bs-custom-file-input)
	 * Copyright 2018 - 2020 Johann-S <johann.servoire@gmail.com>
	 * Licensed under MIT (https://github.com/Johann-S/bs-custom-file-input/blob/master/LICENSE)
	 */
	(function (global, factory) {
	   module.exports = factory() ;
	}(commonjsGlobal, (function () {
	  var Selector = {
	    CUSTOMFILE: '.custom-file input[type="file"]',
	    CUSTOMFILELABEL: '.custom-file-label',
	    FORM: 'form',
	    INPUT: 'input'
	  };

	  var textNodeType = 3;

	  var getDefaultText = function getDefaultText(input) {
	    var defaultText = '';
	    var label = input.parentNode.querySelector(Selector.CUSTOMFILELABEL);

	    if (label) {
	      defaultText = label.textContent;
	    }

	    return defaultText;
	  };

	  var findFirstChildNode = function findFirstChildNode(element) {
	    if (element.childNodes.length > 0) {
	      var childNodes = [].slice.call(element.childNodes);

	      for (var i = 0; i < childNodes.length; i++) {
	        var node = childNodes[i];

	        if (node.nodeType !== textNodeType) {
	          return node;
	        }
	      }
	    }

	    return element;
	  };

	  var restoreDefaultText = function restoreDefaultText(input) {
	    var defaultText = input.bsCustomFileInput.defaultText;
	    var label = input.parentNode.querySelector(Selector.CUSTOMFILELABEL);

	    if (label) {
	      var element = findFirstChildNode(label);
	      element.textContent = defaultText;
	    }
	  };

	  var fileApi = !!window.File;
	  var FAKE_PATH = 'fakepath';
	  var FAKE_PATH_SEPARATOR = '\\';

	  var getSelectedFiles = function getSelectedFiles(input) {
	    if (input.hasAttribute('multiple') && fileApi) {
	      return [].slice.call(input.files).map(function (file) {
	        return file.name;
	      }).join(', ');
	    }

	    if (input.value.indexOf(FAKE_PATH) !== -1) {
	      var splittedValue = input.value.split(FAKE_PATH_SEPARATOR);
	      return splittedValue[splittedValue.length - 1];
	    }

	    return input.value;
	  };

	  function handleInputChange() {
	    var label = this.parentNode.querySelector(Selector.CUSTOMFILELABEL);

	    if (label) {
	      var element = findFirstChildNode(label);
	      var inputValue = getSelectedFiles(this);

	      if (inputValue.length) {
	        element.textContent = inputValue;
	      } else {
	        restoreDefaultText(this);
	      }
	    }
	  }

	  function handleFormReset() {
	    var customFileList = [].slice.call(this.querySelectorAll(Selector.INPUT)).filter(function (input) {
	      return !!input.bsCustomFileInput;
	    });

	    for (var i = 0, len = customFileList.length; i < len; i++) {
	      restoreDefaultText(customFileList[i]);
	    }
	  }

	  var customProperty = 'bsCustomFileInput';
	  var Event = {
	    FORMRESET: 'reset',
	    INPUTCHANGE: 'change'
	  };
	  var bsCustomFileInput = {
	    init: function init(inputSelector, formSelector) {
	      if (inputSelector === void 0) {
	        inputSelector = Selector.CUSTOMFILE;
	      }

	      if (formSelector === void 0) {
	        formSelector = Selector.FORM;
	      }

	      var customFileInputList = [].slice.call(document.querySelectorAll(inputSelector));
	      var formList = [].slice.call(document.querySelectorAll(formSelector));

	      for (var i = 0, len = customFileInputList.length; i < len; i++) {
	        var input = customFileInputList[i];
	        Object.defineProperty(input, customProperty, {
	          value: {
	            defaultText: getDefaultText(input)
	          },
	          writable: true
	        });
	        handleInputChange.call(input);
	        input.addEventListener(Event.INPUTCHANGE, handleInputChange);
	      }

	      for (var _i = 0, _len = formList.length; _i < _len; _i++) {
	        formList[_i].addEventListener(Event.FORMRESET, handleFormReset);

	        Object.defineProperty(formList[_i], customProperty, {
	          value: true,
	          writable: true
	        });
	      }
	    },
	    destroy: function destroy() {
	      var formList = [].slice.call(document.querySelectorAll(Selector.FORM)).filter(function (form) {
	        return !!form.bsCustomFileInput;
	      });
	      var customFileInputList = [].slice.call(document.querySelectorAll(Selector.INPUT)).filter(function (input) {
	        return !!input.bsCustomFileInput;
	      });

	      for (var i = 0, len = customFileInputList.length; i < len; i++) {
	        var input = customFileInputList[i];
	        restoreDefaultText(input);
	        input[customProperty] = undefined;
	        input.removeEventListener(Event.INPUTCHANGE, handleInputChange);
	      }

	      for (var _i2 = 0, _len2 = formList.length; _i2 < _len2; _i2++) {
	        formList[_i2].removeEventListener(Event.FORMRESET, handleFormReset);

	        formList[_i2][customProperty] = undefined;
	      }
	    }
	  };

	  return bsCustomFileInput;

	})));

	});

	/**
	 *
	 * See here: https://github.com/Johann-S/bs-custom-file-input
	 */

	(function () {
	  document.addEventListener("DOMContentLoaded", function () {
	    bsCustomFileInput.init();
	  });
	})();

	function _defineProperties$1(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass$1(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties$1(Constructor, staticProps);
	  return Constructor;
	}

	function _defineProperty$1(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	function ownKeys$1(object, enumerableOnly) {
	  var keys = Object.keys(object);

	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    if (enumerableOnly) symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    });
	    keys.push.apply(keys, symbols);
	  }

	  return keys;
	}

	function _objectSpread2$1(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};

	    if (i % 2) {
	      ownKeys$1(Object(source), true).forEach(function (key) {
	        _defineProperty$1(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys$1(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }

	  return target;
	}

	/**
	 *
	 * --------------------------------------------------------------------------
	 * WKO InHouse (v0.1.0): lazy-svg-sprite.js
	 * Licensed under MITT
	 * --------------------------------------------------------------------------
	 */

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	var VERSION$b = "0.1.0";
	var DATA_ATTR = "data-lazy-svg-sprite";
	var Selector = {
	  DATA_LAZY: "[" + DATA_ATTR + "]"
	};
	/**
	 * We should lazy load the svg sprite only if we add a div with data attributes
	 * Like bootstrap we can use this data attributes as an API if we want to lazy load a svg sprite
	 *
	 * Developer Experience
	 *
	 *  <div data-lazy-svg-sprite="/docs/{{ .Site.Params.docs_version }}/dist/assets/icons/wko/sprite.symbol.svg"></div>
	 *
	 */

	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var LazySVGSprite = /*#__PURE__*/function () {
	  function LazySVGSprite(svgUrl) {
	    this.svgUrl = svgUrl;
	  }

	  var _proto = LazySVGSprite.prototype;

	  _proto.load = function load() {
	    var _this = this;

	    var ajax = new XMLHttpRequest();
	    ajax.open("GET", this.svgUrl, true);
	    ajax.send();
	    ajax.addEventListener("load", function () {
	      var response = ajax.responseText;

	      if (response.match(/<\s*script/)) {
	        console.error("Error: Response from " + _this.svgUrl + " uses a <script> tag. Not inserted into DOM");
	      } else if (ajax.status === 200) {
	        var div = document.createElement("div");
	        div.setAttribute("style", "display: none !important;");
	        div.innerHTML = response;
	        document.body.insertBefore(div, document.body.childNodes[0]);
	      } else {
	        console.error("Error fetching " + _this.svgUrl + ": " + response);
	      }
	    });
	  };

	  _createClass$1(LazySVGSprite, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$b;
	    }
	  }]);

	  return LazySVGSprite;
	}();
	document.addEventListener("DOMContentLoaded", function () {
	  var lazySVGSprites = Array.prototype.slice.call(document.querySelectorAll(Selector.DATA_LAZY)).map(function (element) {
	    var svgUrl = element.getAttribute(DATA_ATTR);
	    return new LazySVGSprite(svgUrl);
	  });
	  lazySVGSprites.forEach(function (lazy) {
	    return lazy.load();
	  });
	});

	var flatpickr = createCommonjsModule(function (module, exports) {
	/* flatpickr v4.6.6, @license MIT */
	(function (global, factory) {
	     module.exports = factory() ;
	}(commonjsGlobal, (function () {
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation.

	    Permission to use, copy, modify, and/or distribute this software for any
	    purpose with or without fee is hereby granted.

	    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	    PERFORMANCE OF THIS SOFTWARE.
	    ***************************************************************************** */

	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };

	    function __spreadArrays() {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    }

	    var HOOKS = [
	        "onChange",
	        "onClose",
	        "onDayCreate",
	        "onDestroy",
	        "onKeyDown",
	        "onMonthChange",
	        "onOpen",
	        "onParseConfig",
	        "onReady",
	        "onValueUpdate",
	        "onYearChange",
	        "onPreCalendarPosition",
	    ];
	    var defaults = {
	        _disable: [],
	        _enable: [],
	        allowInput: false,
	        allowInvalidPreload: false,
	        altFormat: "F j, Y",
	        altInput: false,
	        altInputClass: "form-control input",
	        animate: typeof window === "object" &&
	            window.navigator.userAgent.indexOf("MSIE") === -1,
	        ariaDateFormat: "F j, Y",
	        autoFillDefaultTime: true,
	        clickOpens: true,
	        closeOnSelect: true,
	        conjunction: ", ",
	        dateFormat: "Y-m-d",
	        defaultHour: 12,
	        defaultMinute: 0,
	        defaultSeconds: 0,
	        disable: [],
	        disableMobile: false,
	        enable: [],
	        enableSeconds: false,
	        enableTime: false,
	        errorHandler: function (err) {
	            return typeof console !== "undefined" && console.warn(err);
	        },
	        getWeek: function (givenDate) {
	            var date = new Date(givenDate.getTime());
	            date.setHours(0, 0, 0, 0);
	            // Thursday in current week decides the year.
	            date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
	            // January 4 is always in week 1.
	            var week1 = new Date(date.getFullYear(), 0, 4);
	            // Adjust to Thursday in week 1 and count number of weeks from date to week1.
	            return (1 +
	                Math.round(((date.getTime() - week1.getTime()) / 86400000 -
	                    3 +
	                    ((week1.getDay() + 6) % 7)) /
	                    7));
	        },
	        hourIncrement: 1,
	        ignoredFocusElements: [],
	        inline: false,
	        locale: "default",
	        minuteIncrement: 5,
	        mode: "single",
	        monthSelectorType: "dropdown",
	        nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
	        noCalendar: false,
	        now: new Date(),
	        onChange: [],
	        onClose: [],
	        onDayCreate: [],
	        onDestroy: [],
	        onKeyDown: [],
	        onMonthChange: [],
	        onOpen: [],
	        onParseConfig: [],
	        onReady: [],
	        onValueUpdate: [],
	        onYearChange: [],
	        onPreCalendarPosition: [],
	        plugins: [],
	        position: "auto",
	        positionElement: undefined,
	        prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
	        shorthandCurrentMonth: false,
	        showMonths: 1,
	        static: false,
	        time_24hr: false,
	        weekNumbers: false,
	        wrap: false,
	    };

	    var english = {
	        weekdays: {
	            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	            longhand: [
	                "Sunday",
	                "Monday",
	                "Tuesday",
	                "Wednesday",
	                "Thursday",
	                "Friday",
	                "Saturday",
	            ],
	        },
	        months: {
	            shorthand: [
	                "Jan",
	                "Feb",
	                "Mar",
	                "Apr",
	                "May",
	                "Jun",
	                "Jul",
	                "Aug",
	                "Sep",
	                "Oct",
	                "Nov",
	                "Dec",
	            ],
	            longhand: [
	                "January",
	                "February",
	                "March",
	                "April",
	                "May",
	                "June",
	                "July",
	                "August",
	                "September",
	                "October",
	                "November",
	                "December",
	            ],
	        },
	        daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	        firstDayOfWeek: 0,
	        ordinal: function (nth) {
	            var s = nth % 100;
	            if (s > 3 && s < 21)
	                return "th";
	            switch (s % 10) {
	                case 1:
	                    return "st";
	                case 2:
	                    return "nd";
	                case 3:
	                    return "rd";
	                default:
	                    return "th";
	            }
	        },
	        rangeSeparator: " to ",
	        weekAbbreviation: "Wk",
	        scrollTitle: "Scroll to increment",
	        toggleTitle: "Click to toggle",
	        amPM: ["AM", "PM"],
	        yearAriaLabel: "Year",
	        monthAriaLabel: "Month",
	        hourAriaLabel: "Hour",
	        minuteAriaLabel: "Minute",
	        time_24hr: false,
	    };

	    var pad = function (number, length) {
	        if (length === void 0) { length = 2; }
	        return ("000" + number).slice(length * -1);
	    };
	    var int = function (bool) { return (bool === true ? 1 : 0); };
	    /* istanbul ignore next */
	    function debounce(func, wait, immediate) {
	        if (immediate === void 0) { immediate = false; }
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            timeout !== null && clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                timeout = null;
	                if (!immediate)
	                    func.apply(context, args);
	            }, wait);
	            if (immediate && !timeout)
	                func.apply(context, args);
	        };
	    }
	    var arrayify = function (obj) {
	        return obj instanceof Array ? obj : [obj];
	    };

	    function toggleClass(elem, className, bool) {
	        if (bool === true)
	            return elem.classList.add(className);
	        elem.classList.remove(className);
	    }
	    function createElement(tag, className, content) {
	        var e = window.document.createElement(tag);
	        className = className || "";
	        content = content || "";
	        e.className = className;
	        if (content !== undefined)
	            e.textContent = content;
	        return e;
	    }
	    function clearNode(node) {
	        while (node.firstChild)
	            node.removeChild(node.firstChild);
	    }
	    function findParent(node, condition) {
	        if (condition(node))
	            return node;
	        else if (node.parentNode)
	            return findParent(node.parentNode, condition);
	        return undefined; // nothing found
	    }
	    function createNumberInput(inputClassName, opts) {
	        var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
	        if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
	            numInput.type = "number";
	        }
	        else {
	            numInput.type = "text";
	            numInput.pattern = "\\d*";
	        }
	        if (opts !== undefined)
	            for (var key in opts)
	                numInput.setAttribute(key, opts[key]);
	        wrapper.appendChild(numInput);
	        wrapper.appendChild(arrowUp);
	        wrapper.appendChild(arrowDown);
	        return wrapper;
	    }
	    function getEventTarget(event) {
	        try {
	            if (typeof event.composedPath === "function") {
	                var path = event.composedPath();
	                return path[0];
	            }
	            return event.target;
	        }
	        catch (error) {
	            return event.target;
	        }
	    }

	    var doNothing = function () { return undefined; };
	    var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber]; };
	    var revFormat = {
	        D: doNothing,
	        F: function (dateObj, monthName, locale) {
	            dateObj.setMonth(locale.months.longhand.indexOf(monthName));
	        },
	        G: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        H: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        J: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        K: function (dateObj, amPM, locale) {
	            dateObj.setHours((dateObj.getHours() % 12) +
	                12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
	        },
	        M: function (dateObj, shortMonth, locale) {
	            dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
	        },
	        S: function (dateObj, seconds) {
	            dateObj.setSeconds(parseFloat(seconds));
	        },
	        U: function (_, unixSeconds) { return new Date(parseFloat(unixSeconds) * 1000); },
	        W: function (dateObj, weekNum, locale) {
	            var weekNumber = parseInt(weekNum);
	            var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
	            date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
	            return date;
	        },
	        Y: function (dateObj, year) {
	            dateObj.setFullYear(parseFloat(year));
	        },
	        Z: function (_, ISODate) { return new Date(ISODate); },
	        d: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        h: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        i: function (dateObj, minutes) {
	            dateObj.setMinutes(parseFloat(minutes));
	        },
	        j: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        l: doNothing,
	        m: function (dateObj, month) {
	            dateObj.setMonth(parseFloat(month) - 1);
	        },
	        n: function (dateObj, month) {
	            dateObj.setMonth(parseFloat(month) - 1);
	        },
	        s: function (dateObj, seconds) {
	            dateObj.setSeconds(parseFloat(seconds));
	        },
	        u: function (_, unixMillSeconds) {
	            return new Date(parseFloat(unixMillSeconds));
	        },
	        w: doNothing,
	        y: function (dateObj, year) {
	            dateObj.setFullYear(2000 + parseFloat(year));
	        },
	    };
	    var tokenRegex = {
	        D: "(\\w+)",
	        F: "(\\w+)",
	        G: "(\\d\\d|\\d)",
	        H: "(\\d\\d|\\d)",
	        J: "(\\d\\d|\\d)\\w+",
	        K: "",
	        M: "(\\w+)",
	        S: "(\\d\\d|\\d)",
	        U: "(.+)",
	        W: "(\\d\\d|\\d)",
	        Y: "(\\d{4})",
	        Z: "(.+)",
	        d: "(\\d\\d|\\d)",
	        h: "(\\d\\d|\\d)",
	        i: "(\\d\\d|\\d)",
	        j: "(\\d\\d|\\d)",
	        l: "(\\w+)",
	        m: "(\\d\\d|\\d)",
	        n: "(\\d\\d|\\d)",
	        s: "(\\d\\d|\\d)",
	        u: "(.+)",
	        w: "(\\d\\d|\\d)",
	        y: "(\\d{2})",
	    };
	    var formats = {
	        // get the date in UTC
	        Z: function (date) { return date.toISOString(); },
	        // weekday name, short, e.g. Thu
	        D: function (date, locale, options) {
	            return locale.weekdays.shorthand[formats.w(date, locale, options)];
	        },
	        // full month name e.g. January
	        F: function (date, locale, options) {
	            return monthToStr(formats.n(date, locale, options) - 1, false, locale);
	        },
	        // padded hour 1-12
	        G: function (date, locale, options) {
	            return pad(formats.h(date, locale, options));
	        },
	        // hours with leading zero e.g. 03
	        H: function (date) { return pad(date.getHours()); },
	        // day (1-30) with ordinal suffix e.g. 1st, 2nd
	        J: function (date, locale) {
	            return locale.ordinal !== undefined
	                ? date.getDate() + locale.ordinal(date.getDate())
	                : date.getDate();
	        },
	        // AM/PM
	        K: function (date, locale) { return locale.amPM[int(date.getHours() > 11)]; },
	        // shorthand month e.g. Jan, Sep, Oct, etc
	        M: function (date, locale) {
	            return monthToStr(date.getMonth(), true, locale);
	        },
	        // seconds 00-59
	        S: function (date) { return pad(date.getSeconds()); },
	        // unix timestamp
	        U: function (date) { return date.getTime() / 1000; },
	        W: function (date, _, options) {
	            return options.getWeek(date);
	        },
	        // full year e.g. 2016, padded (0001-9999)
	        Y: function (date) { return pad(date.getFullYear(), 4); },
	        // day in month, padded (01-30)
	        d: function (date) { return pad(date.getDate()); },
	        // hour from 1-12 (am/pm)
	        h: function (date) { return (date.getHours() % 12 ? date.getHours() % 12 : 12); },
	        // minutes, padded with leading zero e.g. 09
	        i: function (date) { return pad(date.getMinutes()); },
	        // day in month (1-30)
	        j: function (date) { return date.getDate(); },
	        // weekday name, full, e.g. Thursday
	        l: function (date, locale) {
	            return locale.weekdays.longhand[date.getDay()];
	        },
	        // padded month number (01-12)
	        m: function (date) { return pad(date.getMonth() + 1); },
	        // the month number (1-12)
	        n: function (date) { return date.getMonth() + 1; },
	        // seconds 0-59
	        s: function (date) { return date.getSeconds(); },
	        // Unix Milliseconds
	        u: function (date) { return date.getTime(); },
	        // number of the day of the week
	        w: function (date) { return date.getDay(); },
	        // last two digits of year e.g. 16 for 2016
	        y: function (date) { return String(date.getFullYear()).substring(2); },
	    };

	    var createDateFormatter = function (_a) {
	        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
	        return function (dateObj, frmt, overrideLocale) {
	            var locale = overrideLocale || l10n;
	            if (config.formatDate !== undefined && !isMobile) {
	                return config.formatDate(dateObj, frmt, locale);
	            }
	            return frmt
	                .split("")
	                .map(function (c, i, arr) {
	                return formats[c] && arr[i - 1] !== "\\"
	                    ? formats[c](dateObj, locale, config)
	                    : c !== "\\"
	                        ? c
	                        : "";
	            })
	                .join("");
	        };
	    };
	    var createDateParser = function (_a) {
	        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
	        return function (date, givenFormat, timeless, customLocale) {
	            if (date !== 0 && !date)
	                return undefined;
	            var locale = customLocale || l10n;
	            var parsedDate;
	            var dateOrig = date;
	            if (date instanceof Date)
	                parsedDate = new Date(date.getTime());
	            else if (typeof date !== "string" &&
	                date.toFixed !== undefined // timestamp
	            )
	                // create a copy
	                parsedDate = new Date(date);
	            else if (typeof date === "string") {
	                // date string
	                var format = givenFormat || (config || defaults).dateFormat;
	                var datestr = String(date).trim();
	                if (datestr === "today") {
	                    parsedDate = new Date();
	                    timeless = true;
	                }
	                else if (/Z$/.test(datestr) ||
	                    /GMT$/.test(datestr) // datestrings w/ timezone
	                )
	                    parsedDate = new Date(date);
	                else if (config && config.parseDate)
	                    parsedDate = config.parseDate(date, format);
	                else {
	                    parsedDate =
	                        !config || !config.noCalendar
	                            ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
	                            : new Date(new Date().setHours(0, 0, 0, 0));
	                    var matched = void 0, ops = [];
	                    for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
	                        var token_1 = format[i];
	                        var isBackSlash = token_1 === "\\";
	                        var escaped = format[i - 1] === "\\" || isBackSlash;
	                        if (tokenRegex[token_1] && !escaped) {
	                            regexStr += tokenRegex[token_1];
	                            var match = new RegExp(regexStr).exec(date);
	                            if (match && (matched = true)) {
	                                ops[token_1 !== "Y" ? "push" : "unshift"]({
	                                    fn: revFormat[token_1],
	                                    val: match[++matchIndex],
	                                });
	                            }
	                        }
	                        else if (!isBackSlash)
	                            regexStr += "."; // don't really care
	                        ops.forEach(function (_a) {
	                            var fn = _a.fn, val = _a.val;
	                            return (parsedDate = fn(parsedDate, val, locale) || parsedDate);
	                        });
	                    }
	                    parsedDate = matched ? parsedDate : undefined;
	                }
	            }
	            /* istanbul ignore next */
	            if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
	                config.errorHandler(new Error("Invalid date provided: " + dateOrig));
	                return undefined;
	            }
	            if (timeless === true)
	                parsedDate.setHours(0, 0, 0, 0);
	            return parsedDate;
	        };
	    };
	    /**
	     * Compute the difference in dates, measured in ms
	     */
	    function compareDates(date1, date2, timeless) {
	        if (timeless === void 0) { timeless = true; }
	        if (timeless !== false) {
	            return (new Date(date1.getTime()).setHours(0, 0, 0, 0) -
	                new Date(date2.getTime()).setHours(0, 0, 0, 0));
	        }
	        return date1.getTime() - date2.getTime();
	    }
	    var isBetween = function (ts, ts1, ts2) {
	        return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
	    };
	    var duration = {
	        DAY: 86400000,
	    };

	    if (typeof Object.assign !== "function") {
	        Object.assign = function (target) {
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            if (!target) {
	                throw TypeError("Cannot convert undefined or null to object");
	            }
	            var _loop_1 = function (source) {
	                if (source) {
	                    Object.keys(source).forEach(function (key) { return (target[key] = source[key]); });
	                }
	            };
	            for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	                var source = args_1[_a];
	                _loop_1(source);
	            }
	            return target;
	        };
	    }

	    var DEBOUNCED_CHANGE_MS = 300;
	    function FlatpickrInstance(element, instanceConfig) {
	        var self = {
	            config: __assign(__assign({}, defaults), flatpickr.defaultConfig),
	            l10n: english,
	        };
	        self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
	        self._handlers = [];
	        self.pluginElements = [];
	        self.loadedPlugins = [];
	        self._bind = bind;
	        self._setHoursFromDate = setHoursFromDate;
	        self._positionCalendar = positionCalendar;
	        self.changeMonth = changeMonth;
	        self.changeYear = changeYear;
	        self.clear = clear;
	        self.close = close;
	        self._createElement = createElement;
	        self.destroy = destroy;
	        self.isEnabled = isEnabled;
	        self.jumpToDate = jumpToDate;
	        self.open = open;
	        self.redraw = redraw;
	        self.set = set;
	        self.setDate = setDate;
	        self.toggle = toggle;
	        function setupHelperFunctions() {
	            self.utils = {
	                getDaysInMonth: function (month, yr) {
	                    if (month === void 0) { month = self.currentMonth; }
	                    if (yr === void 0) { yr = self.currentYear; }
	                    if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0))
	                        return 29;
	                    return self.l10n.daysInMonth[month];
	                },
	            };
	        }
	        function init() {
	            self.element = self.input = element;
	            self.isOpen = false;
	            parseConfig();
	            setupLocale();
	            setupInputs();
	            setupDates();
	            setupHelperFunctions();
	            if (!self.isMobile)
	                build();
	            bindEvents();
	            if (self.selectedDates.length || self.config.noCalendar) {
	                if (self.config.enableTime) {
	                    setHoursFromDate(self.config.noCalendar
	                        ? self.latestSelectedDateObj || self.config.minDate
	                        : undefined);
	                }
	                updateValue(false);
	            }
	            setCalendarWidth();
	            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	            /* TODO: investigate this further
	        
	              Currently, there is weird positioning behavior in safari causing pages
	              to scroll up. https://github.com/chmln/flatpickr/issues/563
	        
	              However, most browsers are not Safari and positioning is expensive when used
	              in scale. https://github.com/chmln/flatpickr/issues/1096
	            */
	            if (!self.isMobile && isSafari) {
	                positionCalendar();
	            }
	            triggerEvent("onReady");
	        }
	        function bindToInstance(fn) {
	            return fn.bind(self);
	        }
	        function setCalendarWidth() {
	            var config = self.config;
	            if (config.weekNumbers === false && config.showMonths === 1) {
	                return;
	            }
	            else if (config.noCalendar !== true) {
	                window.requestAnimationFrame(function () {
	                    if (self.calendarContainer !== undefined) {
	                        self.calendarContainer.style.visibility = "hidden";
	                        self.calendarContainer.style.display = "block";
	                    }
	                    if (self.daysContainer !== undefined) {
	                        var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
	                        self.daysContainer.style.width = daysWidth + "px";
	                        self.calendarContainer.style.width =
	                            daysWidth +
	                                (self.weekWrapper !== undefined
	                                    ? self.weekWrapper.offsetWidth
	                                    : 0) +
	                                "px";
	                        self.calendarContainer.style.removeProperty("visibility");
	                        self.calendarContainer.style.removeProperty("display");
	                    }
	                });
	            }
	        }
	        /**
	         * The handler for all events targeting the time inputs
	         */
	        function updateTime(e) {
	            if (self.selectedDates.length === 0) {
	                var defaultDate = self.config.minDate !== undefined
	                    ? new Date(self.config.minDate.getTime())
	                    : new Date();
	                var _a = getDefaultHours(), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
	                defaultDate.setHours(hours, minutes, seconds, 0);
	                self.setDate(defaultDate, false);
	            }
	            if (e !== undefined && e.type !== "blur") {
	                timeWrapper(e);
	            }
	            var prevValue = self._input.value;
	            setHoursFromInputs();
	            updateValue();
	            if (self._input.value !== prevValue) {
	                self._debouncedChange();
	            }
	        }
	        function ampm2military(hour, amPM) {
	            return (hour % 12) + 12 * int(amPM === self.l10n.amPM[1]);
	        }
	        function military2ampm(hour) {
	            switch (hour % 24) {
	                case 0:
	                case 12:
	                    return 12;
	                default:
	                    return hour % 12;
	            }
	        }
	        /**
	         * Syncs the selected date object time with user's time input
	         */
	        function setHoursFromInputs() {
	            if (self.hourElement === undefined || self.minuteElement === undefined)
	                return;
	            var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined
	                ? (parseInt(self.secondElement.value, 10) || 0) % 60
	                : 0;
	            if (self.amPM !== undefined) {
	                hours = ampm2military(hours, self.amPM.textContent);
	            }
	            var limitMinHours = self.config.minTime !== undefined ||
	                (self.config.minDate &&
	                    self.minDateHasTime &&
	                    self.latestSelectedDateObj &&
	                    compareDates(self.latestSelectedDateObj, self.config.minDate, true) ===
	                        0);
	            var limitMaxHours = self.config.maxTime !== undefined ||
	                (self.config.maxDate &&
	                    self.maxDateHasTime &&
	                    self.latestSelectedDateObj &&
	                    compareDates(self.latestSelectedDateObj, self.config.maxDate, true) ===
	                        0);
	            if (limitMaxHours) {
	                var maxTime = self.config.maxTime !== undefined
	                    ? self.config.maxTime
	                    : self.config.maxDate;
	                hours = Math.min(hours, maxTime.getHours());
	                if (hours === maxTime.getHours())
	                    minutes = Math.min(minutes, maxTime.getMinutes());
	                if (minutes === maxTime.getMinutes())
	                    seconds = Math.min(seconds, maxTime.getSeconds());
	            }
	            if (limitMinHours) {
	                var minTime = self.config.minTime !== undefined
	                    ? self.config.minTime
	                    : self.config.minDate;
	                hours = Math.max(hours, minTime.getHours());
	                if (hours === minTime.getHours())
	                    minutes = Math.max(minutes, minTime.getMinutes());
	                if (minutes === minTime.getMinutes())
	                    seconds = Math.max(seconds, minTime.getSeconds());
	            }
	            setHours(hours, minutes, seconds);
	        }
	        /**
	         * Syncs time input values with a date
	         */
	        function setHoursFromDate(dateObj) {
	            var date = dateObj || self.latestSelectedDateObj;
	            if (date) {
	                setHours(date.getHours(), date.getMinutes(), date.getSeconds());
	            }
	        }
	        function getDefaultHours() {
	            var hours = self.config.defaultHour;
	            var minutes = self.config.defaultMinute;
	            var seconds = self.config.defaultSeconds;
	            if (self.config.minDate !== undefined) {
	                var minHr = self.config.minDate.getHours();
	                var minMinutes = self.config.minDate.getMinutes();
	                hours = Math.max(hours, minHr);
	                if (hours === minHr)
	                    minutes = Math.max(minMinutes, minutes);
	                if (hours === minHr && minutes === minMinutes)
	                    seconds = self.config.minDate.getSeconds();
	            }
	            if (self.config.maxDate !== undefined) {
	                var maxHr = self.config.maxDate.getHours();
	                var maxMinutes = self.config.maxDate.getMinutes();
	                hours = Math.min(hours, maxHr);
	                if (hours === maxHr)
	                    minutes = Math.min(maxMinutes, minutes);
	                if (hours === maxHr && minutes === maxMinutes)
	                    seconds = self.config.maxDate.getSeconds();
	            }
	            return { hours: hours, minutes: minutes, seconds: seconds };
	        }
	        /**
	         * Sets the hours, minutes, and optionally seconds
	         * of the latest selected date object and the
	         * corresponding time inputs
	         * @param {Number} hours the hour. whether its military
	         *                 or am-pm gets inferred from config
	         * @param {Number} minutes the minutes
	         * @param {Number} seconds the seconds (optional)
	         */
	        function setHours(hours, minutes, seconds) {
	            if (self.latestSelectedDateObj !== undefined) {
	                self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
	            }
	            if (!self.hourElement || !self.minuteElement || self.isMobile)
	                return;
	            self.hourElement.value = pad(!self.config.time_24hr
	                ? ((12 + hours) % 12) + 12 * int(hours % 12 === 0)
	                : hours);
	            self.minuteElement.value = pad(minutes);
	            if (self.amPM !== undefined)
	                self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
	            if (self.secondElement !== undefined)
	                self.secondElement.value = pad(seconds);
	        }
	        /**
	         * Handles the year input and incrementing events
	         * @param {Event} event the keyup or increment event
	         */
	        function onYearInput(event) {
	            var eventTarget = getEventTarget(event);
	            var year = parseInt(eventTarget.value) + (event.delta || 0);
	            if (year / 1000 > 1 ||
	                (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
	                changeYear(year);
	            }
	        }
	        /**
	         * Essentially addEventListener + tracking
	         * @param {Element} element the element to addEventListener to
	         * @param {String} event the event name
	         * @param {Function} handler the event handler
	         */
	        function bind(element, event, handler, options) {
	            if (event instanceof Array)
	                return event.forEach(function (ev) { return bind(element, ev, handler, options); });
	            if (element instanceof Array)
	                return element.forEach(function (el) { return bind(el, event, handler, options); });
	            element.addEventListener(event, handler, options);
	            self._handlers.push({
	                element: element,
	                event: event,
	                handler: handler,
	                options: options,
	            });
	        }
	        function triggerChange() {
	            triggerEvent("onChange");
	        }
	        /**
	         * Adds all the necessary event listeners
	         */
	        function bindEvents() {
	            if (self.config.wrap) {
	                ["open", "close", "toggle", "clear"].forEach(function (evt) {
	                    Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
	                        return bind(el, "click", self[evt]);
	                    });
	                });
	            }
	            if (self.isMobile) {
	                setupMobile();
	                return;
	            }
	            var debouncedResize = debounce(onResize, 50);
	            self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
	            if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
	                bind(self.daysContainer, "mouseover", function (e) {
	                    if (self.config.mode === "range")
	                        onMouseOver(getEventTarget(e));
	                });
	            bind(window.document.body, "keydown", onKeyDown);
	            if (!self.config.inline && !self.config.static)
	                bind(window, "resize", debouncedResize);
	            if (window.ontouchstart !== undefined)
	                bind(window.document, "touchstart", documentClick);
	            else
	                bind(window.document, "click", documentClick);
	            bind(window.document, "focus", documentClick, { capture: true });
	            if (self.config.clickOpens === true) {
	                bind(self._input, "focus", self.open);
	                bind(self._input, "click", self.open);
	            }
	            if (self.daysContainer !== undefined) {
	                bind(self.monthNav, "click", onMonthNavClick);
	                bind(self.monthNav, ["keyup", "increment"], onYearInput);
	                bind(self.daysContainer, "click", selectDate);
	            }
	            if (self.timeContainer !== undefined &&
	                self.minuteElement !== undefined &&
	                self.hourElement !== undefined) {
	                var selText = function (e) {
	                    return getEventTarget(e).select();
	                };
	                bind(self.timeContainer, ["increment"], updateTime);
	                bind(self.timeContainer, "blur", updateTime, { capture: true });
	                bind(self.timeContainer, "click", timeIncrement);
	                bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
	                if (self.secondElement !== undefined)
	                    bind(self.secondElement, "focus", function () { return self.secondElement && self.secondElement.select(); });
	                if (self.amPM !== undefined) {
	                    bind(self.amPM, "click", function (e) {
	                        updateTime(e);
	                        triggerChange();
	                    });
	                }
	            }
	            if (self.config.allowInput)
	                bind(self._input, "blur", onBlur);
	        }
	        /**
	         * Set the calendar view to a particular date.
	         * @param {Date} jumpDate the date to set the view to
	         * @param {boolean} triggerChange if change events should be triggered
	         */
	        function jumpToDate(jumpDate, triggerChange) {
	            var jumpTo = jumpDate !== undefined
	                ? self.parseDate(jumpDate)
	                : self.latestSelectedDateObj ||
	                    (self.config.minDate && self.config.minDate > self.now
	                        ? self.config.minDate
	                        : self.config.maxDate && self.config.maxDate < self.now
	                            ? self.config.maxDate
	                            : self.now);
	            var oldYear = self.currentYear;
	            var oldMonth = self.currentMonth;
	            try {
	                if (jumpTo !== undefined) {
	                    self.currentYear = jumpTo.getFullYear();
	                    self.currentMonth = jumpTo.getMonth();
	                }
	            }
	            catch (e) {
	                /* istanbul ignore next */
	                e.message = "Invalid date supplied: " + jumpTo;
	                self.config.errorHandler(e);
	            }
	            if (triggerChange && self.currentYear !== oldYear) {
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	            if (triggerChange &&
	                (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
	                triggerEvent("onMonthChange");
	            }
	            self.redraw();
	        }
	        /**
	         * The up/down arrow handler for time inputs
	         * @param {Event} e the click event
	         */
	        function timeIncrement(e) {
	            var eventTarget = getEventTarget(e);
	            if (~eventTarget.className.indexOf("arrow"))
	                incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
	        }
	        /**
	         * Increments/decrements the value of input associ-
	         * ated with the up/down arrow by dispatching an
	         * "increment" event on the input.
	         *
	         * @param {Event} e the click event
	         * @param {Number} delta the diff (usually 1 or -1)
	         * @param {Element} inputElem the input element
	         */
	        function incrementNumInput(e, delta, inputElem) {
	            var target = e && getEventTarget(e);
	            var input = inputElem ||
	                (target && target.parentNode && target.parentNode.firstChild);
	            var event = createEvent("increment");
	            event.delta = delta;
	            input && input.dispatchEvent(event);
	        }
	        function build() {
	            var fragment = window.document.createDocumentFragment();
	            self.calendarContainer = createElement("div", "flatpickr-calendar");
	            self.calendarContainer.tabIndex = -1;
	            if (!self.config.noCalendar) {
	                fragment.appendChild(buildMonthNav());
	                self.innerContainer = createElement("div", "flatpickr-innerContainer");
	                if (self.config.weekNumbers) {
	                    var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
	                    self.innerContainer.appendChild(weekWrapper);
	                    self.weekNumbers = weekNumbers;
	                    self.weekWrapper = weekWrapper;
	                }
	                self.rContainer = createElement("div", "flatpickr-rContainer");
	                self.rContainer.appendChild(buildWeekdays());
	                if (!self.daysContainer) {
	                    self.daysContainer = createElement("div", "flatpickr-days");
	                    self.daysContainer.tabIndex = -1;
	                }
	                buildDays();
	                self.rContainer.appendChild(self.daysContainer);
	                self.innerContainer.appendChild(self.rContainer);
	                fragment.appendChild(self.innerContainer);
	            }
	            if (self.config.enableTime) {
	                fragment.appendChild(buildTime());
	            }
	            toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
	            toggleClass(self.calendarContainer, "animate", self.config.animate === true);
	            toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
	            self.calendarContainer.appendChild(fragment);
	            var customAppend = self.config.appendTo !== undefined &&
	                self.config.appendTo.nodeType !== undefined;
	            if (self.config.inline || self.config.static) {
	                self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
	                if (self.config.inline) {
	                    if (!customAppend && self.element.parentNode)
	                        self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
	                    else if (self.config.appendTo !== undefined)
	                        self.config.appendTo.appendChild(self.calendarContainer);
	                }
	                if (self.config.static) {
	                    var wrapper = createElement("div", "flatpickr-wrapper");
	                    if (self.element.parentNode)
	                        self.element.parentNode.insertBefore(wrapper, self.element);
	                    wrapper.appendChild(self.element);
	                    if (self.altInput)
	                        wrapper.appendChild(self.altInput);
	                    wrapper.appendChild(self.calendarContainer);
	                }
	            }
	            if (!self.config.static && !self.config.inline)
	                (self.config.appendTo !== undefined
	                    ? self.config.appendTo
	                    : window.document.body).appendChild(self.calendarContainer);
	        }
	        function createDay(className, date, dayNumber, i) {
	            var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
	            dayElement.dateObj = date;
	            dayElement.$i = i;
	            dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
	            if (className.indexOf("hidden") === -1 &&
	                compareDates(date, self.now) === 0) {
	                self.todayDateElem = dayElement;
	                dayElement.classList.add("today");
	                dayElement.setAttribute("aria-current", "date");
	            }
	            if (dateIsEnabled) {
	                dayElement.tabIndex = -1;
	                if (isDateSelected(date)) {
	                    dayElement.classList.add("selected");
	                    self.selectedDateElem = dayElement;
	                    if (self.config.mode === "range") {
	                        toggleClass(dayElement, "startRange", self.selectedDates[0] &&
	                            compareDates(date, self.selectedDates[0], true) === 0);
	                        toggleClass(dayElement, "endRange", self.selectedDates[1] &&
	                            compareDates(date, self.selectedDates[1], true) === 0);
	                        if (className === "nextMonthDay")
	                            dayElement.classList.add("inRange");
	                    }
	                }
	            }
	            else {
	                dayElement.classList.add("flatpickr-disabled");
	            }
	            if (self.config.mode === "range") {
	                if (isDateInRange(date) && !isDateSelected(date))
	                    dayElement.classList.add("inRange");
	            }
	            if (self.weekNumbers &&
	                self.config.showMonths === 1 &&
	                className !== "prevMonthDay" &&
	                dayNumber % 7 === 1) {
	                self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
	            }
	            triggerEvent("onDayCreate", dayElement);
	            return dayElement;
	        }
	        function focusOnDayElem(targetNode) {
	            targetNode.focus();
	            if (self.config.mode === "range")
	                onMouseOver(targetNode);
	        }
	        function getFirstAvailableDay(delta) {
	            var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
	            var endMonth = delta > 0 ? self.config.showMonths : -1;
	            for (var m = startMonth; m != endMonth; m += delta) {
	                var month = self.daysContainer.children[m];
	                var startIndex = delta > 0 ? 0 : month.children.length - 1;
	                var endIndex = delta > 0 ? month.children.length : -1;
	                for (var i = startIndex; i != endIndex; i += delta) {
	                    var c = month.children[i];
	                    if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
	                        return c;
	                }
	            }
	            return undefined;
	        }
	        function getNextAvailableDay(current, delta) {
	            var givenMonth = current.className.indexOf("Month") === -1
	                ? current.dateObj.getMonth()
	                : self.currentMonth;
	            var endMonth = delta > 0 ? self.config.showMonths : -1;
	            var loopDelta = delta > 0 ? 1 : -1;
	            for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
	                var month = self.daysContainer.children[m];
	                var startIndex = givenMonth - self.currentMonth === m
	                    ? current.$i + delta
	                    : delta < 0
	                        ? month.children.length - 1
	                        : 0;
	                var numMonthDays = month.children.length;
	                for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
	                    var c = month.children[i];
	                    if (c.className.indexOf("hidden") === -1 &&
	                        isEnabled(c.dateObj) &&
	                        Math.abs(current.$i - i) >= Math.abs(delta))
	                        return focusOnDayElem(c);
	                }
	            }
	            self.changeMonth(loopDelta);
	            focusOnDay(getFirstAvailableDay(loopDelta), 0);
	            return undefined;
	        }
	        function focusOnDay(current, offset) {
	            var dayFocused = isInView(document.activeElement || document.body);
	            var startElem = current !== undefined
	                ? current
	                : dayFocused
	                    ? document.activeElement
	                    : self.selectedDateElem !== undefined && isInView(self.selectedDateElem)
	                        ? self.selectedDateElem
	                        : self.todayDateElem !== undefined && isInView(self.todayDateElem)
	                            ? self.todayDateElem
	                            : getFirstAvailableDay(offset > 0 ? 1 : -1);
	            if (startElem === undefined) {
	                self._input.focus();
	            }
	            else if (!dayFocused) {
	                focusOnDayElem(startElem);
	            }
	            else {
	                getNextAvailableDay(startElem, offset);
	            }
	        }
	        function buildMonthDays(year, month) {
	            var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
	            var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
	            var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
	            var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
	            // prepend days from the ending of previous month
	            for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
	                days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
	            }
	            // Start at 1 since there is no 0th day
	            for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
	                days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
	            }
	            // append days from the next month
	            for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth &&
	                (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
	                days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
	            }
	            //updateNavigationCurrentMonth();
	            var dayContainer = createElement("div", "dayContainer");
	            dayContainer.appendChild(days);
	            return dayContainer;
	        }
	        function buildDays() {
	            if (self.daysContainer === undefined) {
	                return;
	            }
	            clearNode(self.daysContainer);
	            // TODO: week numbers for each month
	            if (self.weekNumbers)
	                clearNode(self.weekNumbers);
	            var frag = document.createDocumentFragment();
	            for (var i = 0; i < self.config.showMonths; i++) {
	                var d = new Date(self.currentYear, self.currentMonth, 1);
	                d.setMonth(self.currentMonth + i);
	                frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
	            }
	            self.daysContainer.appendChild(frag);
	            self.days = self.daysContainer.firstChild;
	            if (self.config.mode === "range" && self.selectedDates.length === 1) {
	                onMouseOver();
	            }
	        }
	        function buildMonthSwitch() {
	            if (self.config.showMonths > 1 ||
	                self.config.monthSelectorType !== "dropdown")
	                return;
	            var shouldBuildMonth = function (month) {
	                if (self.config.minDate !== undefined &&
	                    self.currentYear === self.config.minDate.getFullYear() &&
	                    month < self.config.minDate.getMonth()) {
	                    return false;
	                }
	                return !(self.config.maxDate !== undefined &&
	                    self.currentYear === self.config.maxDate.getFullYear() &&
	                    month > self.config.maxDate.getMonth());
	            };
	            self.monthsDropdownContainer.tabIndex = -1;
	            self.monthsDropdownContainer.innerHTML = "";
	            for (var i = 0; i < 12; i++) {
	                if (!shouldBuildMonth(i))
	                    continue;
	                var month = createElement("option", "flatpickr-monthDropdown-month");
	                month.value = new Date(self.currentYear, i).getMonth().toString();
	                month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
	                month.tabIndex = -1;
	                if (self.currentMonth === i) {
	                    month.selected = true;
	                }
	                self.monthsDropdownContainer.appendChild(month);
	            }
	        }
	        function buildMonth() {
	            var container = createElement("div", "flatpickr-month");
	            var monthNavFragment = window.document.createDocumentFragment();
	            var monthElement;
	            if (self.config.showMonths > 1 ||
	                self.config.monthSelectorType === "static") {
	                monthElement = createElement("span", "cur-month");
	            }
	            else {
	                self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
	                self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
	                bind(self.monthsDropdownContainer, "change", function (e) {
	                    var target = getEventTarget(e);
	                    var selectedMonth = parseInt(target.value, 10);
	                    self.changeMonth(selectedMonth - self.currentMonth);
	                    triggerEvent("onMonthChange");
	                });
	                buildMonthSwitch();
	                monthElement = self.monthsDropdownContainer;
	            }
	            var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
	            var yearElement = yearInput.getElementsByTagName("input")[0];
	            yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
	            if (self.config.minDate) {
	                yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
	            }
	            if (self.config.maxDate) {
	                yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
	                yearElement.disabled =
	                    !!self.config.minDate &&
	                        self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
	            }
	            var currentMonth = createElement("div", "flatpickr-current-month");
	            currentMonth.appendChild(monthElement);
	            currentMonth.appendChild(yearInput);
	            monthNavFragment.appendChild(currentMonth);
	            container.appendChild(monthNavFragment);
	            return {
	                container: container,
	                yearElement: yearElement,
	                monthElement: monthElement,
	            };
	        }
	        function buildMonths() {
	            clearNode(self.monthNav);
	            self.monthNav.appendChild(self.prevMonthNav);
	            if (self.config.showMonths) {
	                self.yearElements = [];
	                self.monthElements = [];
	            }
	            for (var m = self.config.showMonths; m--;) {
	                var month = buildMonth();
	                self.yearElements.push(month.yearElement);
	                self.monthElements.push(month.monthElement);
	                self.monthNav.appendChild(month.container);
	            }
	            self.monthNav.appendChild(self.nextMonthNav);
	        }
	        function buildMonthNav() {
	            self.monthNav = createElement("div", "flatpickr-months");
	            self.yearElements = [];
	            self.monthElements = [];
	            self.prevMonthNav = createElement("span", "flatpickr-prev-month");
	            self.prevMonthNav.innerHTML = self.config.prevArrow;
	            self.nextMonthNav = createElement("span", "flatpickr-next-month");
	            self.nextMonthNav.innerHTML = self.config.nextArrow;
	            buildMonths();
	            Object.defineProperty(self, "_hidePrevMonthArrow", {
	                get: function () { return self.__hidePrevMonthArrow; },
	                set: function (bool) {
	                    if (self.__hidePrevMonthArrow !== bool) {
	                        toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
	                        self.__hidePrevMonthArrow = bool;
	                    }
	                },
	            });
	            Object.defineProperty(self, "_hideNextMonthArrow", {
	                get: function () { return self.__hideNextMonthArrow; },
	                set: function (bool) {
	                    if (self.__hideNextMonthArrow !== bool) {
	                        toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
	                        self.__hideNextMonthArrow = bool;
	                    }
	                },
	            });
	            self.currentYearElement = self.yearElements[0];
	            updateNavigationCurrentMonth();
	            return self.monthNav;
	        }
	        function buildTime() {
	            self.calendarContainer.classList.add("hasTime");
	            if (self.config.noCalendar)
	                self.calendarContainer.classList.add("noCalendar");
	            self.timeContainer = createElement("div", "flatpickr-time");
	            self.timeContainer.tabIndex = -1;
	            var separator = createElement("span", "flatpickr-time-separator", ":");
	            var hourInput = createNumberInput("flatpickr-hour", {
	                "aria-label": self.l10n.hourAriaLabel,
	            });
	            self.hourElement = hourInput.getElementsByTagName("input")[0];
	            var minuteInput = createNumberInput("flatpickr-minute", {
	                "aria-label": self.l10n.minuteAriaLabel,
	            });
	            self.minuteElement = minuteInput.getElementsByTagName("input")[0];
	            self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
	            self.hourElement.value = pad(self.latestSelectedDateObj
	                ? self.latestSelectedDateObj.getHours()
	                : self.config.time_24hr
	                    ? self.config.defaultHour
	                    : military2ampm(self.config.defaultHour));
	            self.minuteElement.value = pad(self.latestSelectedDateObj
	                ? self.latestSelectedDateObj.getMinutes()
	                : self.config.defaultMinute);
	            self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
	            self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
	            self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
	            self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
	            self.minuteElement.setAttribute("min", "0");
	            self.minuteElement.setAttribute("max", "59");
	            self.timeContainer.appendChild(hourInput);
	            self.timeContainer.appendChild(separator);
	            self.timeContainer.appendChild(minuteInput);
	            if (self.config.time_24hr)
	                self.timeContainer.classList.add("time24hr");
	            if (self.config.enableSeconds) {
	                self.timeContainer.classList.add("hasSeconds");
	                var secondInput = createNumberInput("flatpickr-second");
	                self.secondElement = secondInput.getElementsByTagName("input")[0];
	                self.secondElement.value = pad(self.latestSelectedDateObj
	                    ? self.latestSelectedDateObj.getSeconds()
	                    : self.config.defaultSeconds);
	                self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
	                self.secondElement.setAttribute("min", "0");
	                self.secondElement.setAttribute("max", "59");
	                self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
	                self.timeContainer.appendChild(secondInput);
	            }
	            if (!self.config.time_24hr) {
	                // add self.amPM if appropriate
	                self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj
	                    ? self.hourElement.value
	                    : self.config.defaultHour) > 11)]);
	                self.amPM.title = self.l10n.toggleTitle;
	                self.amPM.tabIndex = -1;
	                self.timeContainer.appendChild(self.amPM);
	            }
	            return self.timeContainer;
	        }
	        function buildWeekdays() {
	            if (!self.weekdayContainer)
	                self.weekdayContainer = createElement("div", "flatpickr-weekdays");
	            else
	                clearNode(self.weekdayContainer);
	            for (var i = self.config.showMonths; i--;) {
	                var container = createElement("div", "flatpickr-weekdaycontainer");
	                self.weekdayContainer.appendChild(container);
	            }
	            updateWeekdays();
	            return self.weekdayContainer;
	        }
	        function updateWeekdays() {
	            if (!self.weekdayContainer) {
	                return;
	            }
	            var firstDayOfWeek = self.l10n.firstDayOfWeek;
	            var weekdays = __spreadArrays(self.l10n.weekdays.shorthand);
	            if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
	                weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
	            }
	            for (var i = self.config.showMonths; i--;) {
	                self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
	            }
	        }
	        /* istanbul ignore next */
	        function buildWeeks() {
	            self.calendarContainer.classList.add("hasWeeks");
	            var weekWrapper = createElement("div", "flatpickr-weekwrapper");
	            weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
	            var weekNumbers = createElement("div", "flatpickr-weeks");
	            weekWrapper.appendChild(weekNumbers);
	            return {
	                weekWrapper: weekWrapper,
	                weekNumbers: weekNumbers,
	            };
	        }
	        function changeMonth(value, isOffset) {
	            if (isOffset === void 0) { isOffset = true; }
	            var delta = isOffset ? value : value - self.currentMonth;
	            if ((delta < 0 && self._hidePrevMonthArrow === true) ||
	                (delta > 0 && self._hideNextMonthArrow === true))
	                return;
	            self.currentMonth += delta;
	            if (self.currentMonth < 0 || self.currentMonth > 11) {
	                self.currentYear += self.currentMonth > 11 ? 1 : -1;
	                self.currentMonth = (self.currentMonth + 12) % 12;
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	            buildDays();
	            triggerEvent("onMonthChange");
	            updateNavigationCurrentMonth();
	        }
	        function clear(triggerChangeEvent, toInitial) {
	            if (triggerChangeEvent === void 0) { triggerChangeEvent = true; }
	            if (toInitial === void 0) { toInitial = true; }
	            self.input.value = "";
	            if (self.altInput !== undefined)
	                self.altInput.value = "";
	            if (self.mobileInput !== undefined)
	                self.mobileInput.value = "";
	            self.selectedDates = [];
	            self.latestSelectedDateObj = undefined;
	            if (toInitial === true) {
	                self.currentYear = self._initialDate.getFullYear();
	                self.currentMonth = self._initialDate.getMonth();
	            }
	            if (self.config.enableTime === true) {
	                var _a = getDefaultHours(), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
	                setHours(hours, minutes, seconds);
	            }
	            self.redraw();
	            if (triggerChangeEvent)
	                // triggerChangeEvent is true (default) or an Event
	                triggerEvent("onChange");
	        }
	        function close() {
	            self.isOpen = false;
	            if (!self.isMobile) {
	                if (self.calendarContainer !== undefined) {
	                    self.calendarContainer.classList.remove("open");
	                }
	                if (self._input !== undefined) {
	                    self._input.classList.remove("active");
	                }
	            }
	            triggerEvent("onClose");
	        }
	        function destroy() {
	            if (self.config !== undefined)
	                triggerEvent("onDestroy");
	            for (var i = self._handlers.length; i--;) {
	                var h = self._handlers[i];
	                h.element.removeEventListener(h.event, h.handler, h.options);
	            }
	            self._handlers = [];
	            if (self.mobileInput) {
	                if (self.mobileInput.parentNode)
	                    self.mobileInput.parentNode.removeChild(self.mobileInput);
	                self.mobileInput = undefined;
	            }
	            else if (self.calendarContainer && self.calendarContainer.parentNode) {
	                if (self.config.static && self.calendarContainer.parentNode) {
	                    var wrapper = self.calendarContainer.parentNode;
	                    wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
	                    if (wrapper.parentNode) {
	                        while (wrapper.firstChild)
	                            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
	                        wrapper.parentNode.removeChild(wrapper);
	                    }
	                }
	                else
	                    self.calendarContainer.parentNode.removeChild(self.calendarContainer);
	            }
	            if (self.altInput) {
	                self.input.type = "text";
	                if (self.altInput.parentNode)
	                    self.altInput.parentNode.removeChild(self.altInput);
	                delete self.altInput;
	            }
	            if (self.input) {
	                self.input.type = self.input._type;
	                self.input.classList.remove("flatpickr-input");
	                self.input.removeAttribute("readonly");
	            }
	            [
	                "_showTimeInput",
	                "latestSelectedDateObj",
	                "_hideNextMonthArrow",
	                "_hidePrevMonthArrow",
	                "__hideNextMonthArrow",
	                "__hidePrevMonthArrow",
	                "isMobile",
	                "isOpen",
	                "selectedDateElem",
	                "minDateHasTime",
	                "maxDateHasTime",
	                "days",
	                "daysContainer",
	                "_input",
	                "_positionElement",
	                "innerContainer",
	                "rContainer",
	                "monthNav",
	                "todayDateElem",
	                "calendarContainer",
	                "weekdayContainer",
	                "prevMonthNav",
	                "nextMonthNav",
	                "monthsDropdownContainer",
	                "currentMonthElement",
	                "currentYearElement",
	                "navigationCurrentMonth",
	                "selectedDateElem",
	                "config",
	            ].forEach(function (k) {
	                try {
	                    delete self[k];
	                }
	                catch (_) { }
	            });
	        }
	        function isCalendarElem(elem) {
	            if (self.config.appendTo && self.config.appendTo.contains(elem))
	                return true;
	            return self.calendarContainer.contains(elem);
	        }
	        function documentClick(e) {
	            if (self.isOpen && !self.config.inline) {
	                var eventTarget_1 = getEventTarget(e);
	                var isCalendarElement = isCalendarElem(eventTarget_1);
	                var isInput = eventTarget_1 === self.input ||
	                    eventTarget_1 === self.altInput ||
	                    self.element.contains(eventTarget_1) ||
	                    // web components
	                    // e.path is not present in all browsers. circumventing typechecks
	                    (e.path &&
	                        e.path.indexOf &&
	                        (~e.path.indexOf(self.input) ||
	                            ~e.path.indexOf(self.altInput)));
	                var lostFocus = e.type === "blur"
	                    ? isInput &&
	                        e.relatedTarget &&
	                        !isCalendarElem(e.relatedTarget)
	                    : !isInput &&
	                        !isCalendarElement &&
	                        !isCalendarElem(e.relatedTarget);
	                var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
	                    return elem.contains(eventTarget_1);
	                });
	                if (lostFocus && isIgnored) {
	                    if (self.timeContainer !== undefined &&
	                        self.minuteElement !== undefined &&
	                        self.hourElement !== undefined &&
	                        self.input.value !== "" &&
	                        self.input.value !== undefined) {
	                        updateTime();
	                    }
	                    self.close();
	                    if (self.config &&
	                        self.config.mode === "range" &&
	                        self.selectedDates.length === 1) {
	                        self.clear(false);
	                        self.redraw();
	                    }
	                }
	            }
	        }
	        function changeYear(newYear) {
	            if (!newYear ||
	                (self.config.minDate && newYear < self.config.minDate.getFullYear()) ||
	                (self.config.maxDate && newYear > self.config.maxDate.getFullYear()))
	                return;
	            var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
	            self.currentYear = newYearNum || self.currentYear;
	            if (self.config.maxDate &&
	                self.currentYear === self.config.maxDate.getFullYear()) {
	                self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
	            }
	            else if (self.config.minDate &&
	                self.currentYear === self.config.minDate.getFullYear()) {
	                self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
	            }
	            if (isNewYear) {
	                self.redraw();
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	        }
	        function isEnabled(date, timeless) {
	            if (timeless === void 0) { timeless = true; }
	            var dateToCheck = self.parseDate(date, undefined, timeless); // timeless
	            if ((self.config.minDate &&
	                dateToCheck &&
	                compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) ||
	                (self.config.maxDate &&
	                    dateToCheck &&
	                    compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0))
	                return false;
	            if (self.config.enable.length === 0 && self.config.disable.length === 0)
	                return true;
	            if (dateToCheck === undefined)
	                return false;
	            var bool = self.config.enable.length > 0, array = bool ? self.config.enable : self.config.disable;
	            for (var i = 0, d = void 0; i < array.length; i++) {
	                d = array[i];
	                if (typeof d === "function" &&
	                    d(dateToCheck) // disabled by function
	                )
	                    return bool;
	                else if (d instanceof Date &&
	                    dateToCheck !== undefined &&
	                    d.getTime() === dateToCheck.getTime())
	                    // disabled by date
	                    return bool;
	                else if (typeof d === "string" && dateToCheck !== undefined) {
	                    // disabled by date string
	                    var parsed = self.parseDate(d, undefined, true);
	                    return parsed && parsed.getTime() === dateToCheck.getTime()
	                        ? bool
	                        : !bool;
	                }
	                else if (
	                // disabled by range
	                typeof d === "object" &&
	                    dateToCheck !== undefined &&
	                    d.from &&
	                    d.to &&
	                    dateToCheck.getTime() >= d.from.getTime() &&
	                    dateToCheck.getTime() <= d.to.getTime())
	                    return bool;
	            }
	            return !bool;
	        }
	        function isInView(elem) {
	            if (self.daysContainer !== undefined)
	                return (elem.className.indexOf("hidden") === -1 &&
	                    elem.className.indexOf("flatpickr-disabled") === -1 &&
	                    self.daysContainer.contains(elem));
	            return false;
	        }
	        function onBlur(e) {
	            var isInput = e.target === self._input;
	            if (isInput &&
	                !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
	                self.setDate(self._input.value, true, e.target === self.altInput
	                    ? self.config.altFormat
	                    : self.config.dateFormat);
	            }
	        }
	        function onKeyDown(e) {
	            // e.key                      e.keyCode
	            // "Backspace"                        8
	            // "Tab"                              9
	            // "Enter"                           13
	            // "Escape"     (IE "Esc")           27
	            // "ArrowLeft"  (IE "Left")          37
	            // "ArrowUp"    (IE "Up")            38
	            // "ArrowRight" (IE "Right")         39
	            // "ArrowDown"  (IE "Down")          40
	            // "Delete"     (IE "Del")           46
	            var eventTarget = getEventTarget(e);
	            var isInput = self.config.wrap
	                ? element.contains(eventTarget)
	                : eventTarget === self._input;
	            var allowInput = self.config.allowInput;
	            var allowKeydown = self.isOpen && (!allowInput || !isInput);
	            var allowInlineKeydown = self.config.inline && isInput && !allowInput;
	            if (e.keyCode === 13 && isInput) {
	                if (allowInput) {
	                    self.setDate(self._input.value, true, eventTarget === self.altInput
	                        ? self.config.altFormat
	                        : self.config.dateFormat);
	                    return eventTarget.blur();
	                }
	                else {
	                    self.open();
	                }
	            }
	            else if (isCalendarElem(eventTarget) ||
	                allowKeydown ||
	                allowInlineKeydown) {
	                var isTimeObj = !!self.timeContainer &&
	                    self.timeContainer.contains(eventTarget);
	                switch (e.keyCode) {
	                    case 13:
	                        if (isTimeObj) {
	                            e.preventDefault();
	                            updateTime();
	                            focusAndClose();
	                        }
	                        else
	                            selectDate(e);
	                        break;
	                    case 27: // escape
	                        e.preventDefault();
	                        focusAndClose();
	                        break;
	                    case 8:
	                    case 46:
	                        if (isInput && !self.config.allowInput) {
	                            e.preventDefault();
	                            self.clear();
	                        }
	                        break;
	                    case 37:
	                    case 39:
	                        if (!isTimeObj && !isInput) {
	                            e.preventDefault();
	                            if (self.daysContainer !== undefined &&
	                                (allowInput === false ||
	                                    (document.activeElement && isInView(document.activeElement)))) {
	                                var delta_1 = e.keyCode === 39 ? 1 : -1;
	                                if (!e.ctrlKey)
	                                    focusOnDay(undefined, delta_1);
	                                else {
	                                    e.stopPropagation();
	                                    changeMonth(delta_1);
	                                    focusOnDay(getFirstAvailableDay(1), 0);
	                                }
	                            }
	                        }
	                        else if (self.hourElement)
	                            self.hourElement.focus();
	                        break;
	                    case 38:
	                    case 40:
	                        e.preventDefault();
	                        var delta = e.keyCode === 40 ? 1 : -1;
	                        if ((self.daysContainer &&
	                            eventTarget.$i !== undefined) ||
	                            eventTarget === self.input ||
	                            eventTarget === self.altInput) {
	                            if (e.ctrlKey) {
	                                e.stopPropagation();
	                                changeYear(self.currentYear - delta);
	                                focusOnDay(getFirstAvailableDay(1), 0);
	                            }
	                            else if (!isTimeObj)
	                                focusOnDay(undefined, delta * 7);
	                        }
	                        else if (eventTarget === self.currentYearElement) {
	                            changeYear(self.currentYear - delta);
	                        }
	                        else if (self.config.enableTime) {
	                            if (!isTimeObj && self.hourElement)
	                                self.hourElement.focus();
	                            updateTime(e);
	                            self._debouncedChange();
	                        }
	                        break;
	                    case 9:
	                        if (isTimeObj) {
	                            var elems = [
	                                self.hourElement,
	                                self.minuteElement,
	                                self.secondElement,
	                                self.amPM,
	                            ]
	                                .concat(self.pluginElements)
	                                .filter(function (x) { return x; });
	                            var i = elems.indexOf(eventTarget);
	                            if (i !== -1) {
	                                var target = elems[i + (e.shiftKey ? -1 : 1)];
	                                e.preventDefault();
	                                (target || self._input).focus();
	                            }
	                        }
	                        else if (!self.config.noCalendar &&
	                            self.daysContainer &&
	                            self.daysContainer.contains(eventTarget) &&
	                            e.shiftKey) {
	                            e.preventDefault();
	                            self._input.focus();
	                        }
	                        break;
	                }
	            }
	            if (self.amPM !== undefined && eventTarget === self.amPM) {
	                switch (e.key) {
	                    case self.l10n.amPM[0].charAt(0):
	                    case self.l10n.amPM[0].charAt(0).toLowerCase():
	                        self.amPM.textContent = self.l10n.amPM[0];
	                        setHoursFromInputs();
	                        updateValue();
	                        break;
	                    case self.l10n.amPM[1].charAt(0):
	                    case self.l10n.amPM[1].charAt(0).toLowerCase():
	                        self.amPM.textContent = self.l10n.amPM[1];
	                        setHoursFromInputs();
	                        updateValue();
	                        break;
	                }
	            }
	            if (isInput || isCalendarElem(eventTarget)) {
	                triggerEvent("onKeyDown", e);
	            }
	        }
	        function onMouseOver(elem) {
	            if (self.selectedDates.length !== 1 ||
	                (elem &&
	                    (!elem.classList.contains("flatpickr-day") ||
	                        elem.classList.contains("flatpickr-disabled"))))
	                return;
	            var hoverDate = elem
	                ? elem.dateObj.getTime()
	                : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
	            var containsDisabled = false;
	            var minRange = 0, maxRange = 0;
	            for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
	                if (!isEnabled(new Date(t), true)) {
	                    containsDisabled =
	                        containsDisabled || (t > rangeStartDate && t < rangeEndDate);
	                    if (t < initialDate && (!minRange || t > minRange))
	                        minRange = t;
	                    else if (t > initialDate && (!maxRange || t < maxRange))
	                        maxRange = t;
	                }
	            }
	            for (var m = 0; m < self.config.showMonths; m++) {
	                var month = self.daysContainer.children[m];
	                var _loop_1 = function (i, l) {
	                    var dayElem = month.children[i], date = dayElem.dateObj;
	                    var timestamp = date.getTime();
	                    var outOfRange = (minRange > 0 && timestamp < minRange) ||
	                        (maxRange > 0 && timestamp > maxRange);
	                    if (outOfRange) {
	                        dayElem.classList.add("notAllowed");
	                        ["inRange", "startRange", "endRange"].forEach(function (c) {
	                            dayElem.classList.remove(c);
	                        });
	                        return "continue";
	                    }
	                    else if (containsDisabled && !outOfRange)
	                        return "continue";
	                    ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
	                        dayElem.classList.remove(c);
	                    });
	                    if (elem !== undefined) {
	                        elem.classList.add(hoverDate <= self.selectedDates[0].getTime()
	                            ? "startRange"
	                            : "endRange");
	                        if (initialDate < hoverDate && timestamp === initialDate)
	                            dayElem.classList.add("startRange");
	                        else if (initialDate > hoverDate && timestamp === initialDate)
	                            dayElem.classList.add("endRange");
	                        if (timestamp >= minRange &&
	                            (maxRange === 0 || timestamp <= maxRange) &&
	                            isBetween(timestamp, initialDate, hoverDate))
	                            dayElem.classList.add("inRange");
	                    }
	                };
	                for (var i = 0, l = month.children.length; i < l; i++) {
	                    _loop_1(i, l);
	                }
	            }
	        }
	        function onResize() {
	            if (self.isOpen && !self.config.static && !self.config.inline)
	                positionCalendar();
	        }
	        function open(e, positionElement) {
	            if (positionElement === void 0) { positionElement = self._positionElement; }
	            if (self.isMobile === true) {
	                if (e) {
	                    e.preventDefault();
	                    var eventTarget = getEventTarget(e);
	                    eventTarget && eventTarget.blur();
	                }
	                if (self.mobileInput !== undefined) {
	                    self.mobileInput.focus();
	                    self.mobileInput.click();
	                }
	                triggerEvent("onOpen");
	                return;
	            }
	            if (self._input.disabled || self.config.inline)
	                return;
	            var wasOpen = self.isOpen;
	            self.isOpen = true;
	            if (!wasOpen) {
	                self.calendarContainer.classList.add("open");
	                self._input.classList.add("active");
	                triggerEvent("onOpen");
	                positionCalendar(positionElement);
	            }
	            if (self.config.enableTime === true && self.config.noCalendar === true) {
	                if (self.config.allowInput === false &&
	                    (e === undefined ||
	                        !self.timeContainer.contains(e.relatedTarget))) {
	                    setTimeout(function () { return self.hourElement.select(); }, 50);
	                }
	            }
	        }
	        function minMaxDateSetter(type) {
	            return function (date) {
	                var dateObj = (self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat));
	                var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
	                if (dateObj !== undefined) {
	                    self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] =
	                        dateObj.getHours() > 0 ||
	                            dateObj.getMinutes() > 0 ||
	                            dateObj.getSeconds() > 0;
	                }
	                if (self.selectedDates) {
	                    self.selectedDates = self.selectedDates.filter(function (d) { return isEnabled(d); });
	                    if (!self.selectedDates.length && type === "min")
	                        setHoursFromDate(dateObj);
	                    updateValue();
	                }
	                if (self.daysContainer) {
	                    redraw();
	                    if (dateObj !== undefined)
	                        self.currentYearElement[type] = dateObj.getFullYear().toString();
	                    else
	                        self.currentYearElement.removeAttribute(type);
	                    self.currentYearElement.disabled =
	                        !!inverseDateObj &&
	                            dateObj !== undefined &&
	                            inverseDateObj.getFullYear() === dateObj.getFullYear();
	                }
	            };
	        }
	        function parseConfig() {
	            var boolOpts = [
	                "wrap",
	                "weekNumbers",
	                "allowInput",
	                "allowInvalidPreload",
	                "clickOpens",
	                "time_24hr",
	                "enableTime",
	                "noCalendar",
	                "altInput",
	                "shorthandCurrentMonth",
	                "inline",
	                "static",
	                "enableSeconds",
	                "disableMobile",
	            ];
	            var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
	            var formats = {};
	            self.config.parseDate = userConfig.parseDate;
	            self.config.formatDate = userConfig.formatDate;
	            Object.defineProperty(self.config, "enable", {
	                get: function () { return self.config._enable; },
	                set: function (dates) {
	                    self.config._enable = parseDateRules(dates);
	                },
	            });
	            Object.defineProperty(self.config, "disable", {
	                get: function () { return self.config._disable; },
	                set: function (dates) {
	                    self.config._disable = parseDateRules(dates);
	                },
	            });
	            var timeMode = userConfig.mode === "time";
	            if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
	                var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
	                formats.dateFormat =
	                    userConfig.noCalendar || timeMode
	                        ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
	                        : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
	            }
	            if (userConfig.altInput &&
	                (userConfig.enableTime || timeMode) &&
	                !userConfig.altFormat) {
	                var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
	                formats.altFormat =
	                    userConfig.noCalendar || timeMode
	                        ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K")
	                        : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
	            }
	            Object.defineProperty(self.config, "minDate", {
	                get: function () { return self.config._minDate; },
	                set: minMaxDateSetter("min"),
	            });
	            Object.defineProperty(self.config, "maxDate", {
	                get: function () { return self.config._maxDate; },
	                set: minMaxDateSetter("max"),
	            });
	            var minMaxTimeSetter = function (type) { return function (val) {
	                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
	            }; };
	            Object.defineProperty(self.config, "minTime", {
	                get: function () { return self.config._minTime; },
	                set: minMaxTimeSetter("min"),
	            });
	            Object.defineProperty(self.config, "maxTime", {
	                get: function () { return self.config._maxTime; },
	                set: minMaxTimeSetter("max"),
	            });
	            if (userConfig.mode === "time") {
	                self.config.noCalendar = true;
	                self.config.enableTime = true;
	            }
	            Object.assign(self.config, formats, userConfig);
	            for (var i = 0; i < boolOpts.length; i++)
	                // https://github.com/microsoft/TypeScript/issues/31663
	                self.config[boolOpts[i]] =
	                    self.config[boolOpts[i]] === true ||
	                        self.config[boolOpts[i]] === "true";
	            HOOKS.filter(function (hook) { return self.config[hook] !== undefined; }).forEach(function (hook) {
	                self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
	            });
	            self.isMobile =
	                !self.config.disableMobile &&
	                    !self.config.inline &&
	                    self.config.mode === "single" &&
	                    !self.config.disable.length &&
	                    !self.config.enable.length &&
	                    !self.config.weekNumbers &&
	                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	            for (var i = 0; i < self.config.plugins.length; i++) {
	                var pluginConf = self.config.plugins[i](self) || {};
	                for (var key in pluginConf) {
	                    if (HOOKS.indexOf(key) > -1) {
	                        self.config[key] = arrayify(pluginConf[key])
	                            .map(bindToInstance)
	                            .concat(self.config[key]);
	                    }
	                    else if (typeof userConfig[key] === "undefined")
	                        self.config[key] = pluginConf[key];
	                }
	            }
	            if (!userConfig.altInputClass) {
	                self.config.altInputClass =
	                    getInputElem().className + " " + self.config.altInputClass;
	            }
	            triggerEvent("onParseConfig");
	        }
	        function getInputElem() {
	            return self.config.wrap
	                ? element.querySelector("[data-input]")
	                : element;
	        }
	        function setupLocale() {
	            if (typeof self.config.locale !== "object" &&
	                typeof flatpickr.l10ns[self.config.locale] === "undefined")
	                self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
	            self.l10n = __assign(__assign({}, flatpickr.l10ns.default), (typeof self.config.locale === "object"
	                ? self.config.locale
	                : self.config.locale !== "default"
	                    ? flatpickr.l10ns[self.config.locale]
	                    : undefined));
	            tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
	            var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
	            if (userConfig.time_24hr === undefined &&
	                flatpickr.defaultConfig.time_24hr === undefined) {
	                self.config.time_24hr = self.l10n.time_24hr;
	            }
	            self.formatDate = createDateFormatter(self);
	            self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
	        }
	        function positionCalendar(customPositionElement) {
	            if (self.calendarContainer === undefined)
	                return;
	            triggerEvent("onPreCalendarPosition");
	            var positionElement = customPositionElement || self._positionElement;
	            var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, (function (acc, child) { return acc + child.offsetHeight; }), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" ||
	                (configPosVertical !== "below" &&
	                    distanceFromBottom < calendarHeight &&
	                    inputBounds.top > calendarHeight);
	            var top = window.pageYOffset +
	                inputBounds.top +
	                (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
	            toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
	            toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
	            if (self.config.inline)
	                return;
	            var left = window.pageXOffset + inputBounds.left;
	            var isCenter = false;
	            var isRight = false;
	            if (configPosHorizontal === "center") {
	                left -= (calendarWidth - inputBounds.width) / 2;
	                isCenter = true;
	            }
	            else if (configPosHorizontal === "right") {
	                left -= calendarWidth - inputBounds.width;
	                isRight = true;
	            }
	            toggleClass(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
	            toggleClass(self.calendarContainer, "arrowCenter", isCenter);
	            toggleClass(self.calendarContainer, "arrowRight", isRight);
	            var right = window.document.body.offsetWidth -
	                (window.pageXOffset + inputBounds.right);
	            var rightMost = left + calendarWidth > window.document.body.offsetWidth;
	            var centerMost = right + calendarWidth > window.document.body.offsetWidth;
	            toggleClass(self.calendarContainer, "rightMost", rightMost);
	            if (self.config.static)
	                return;
	            self.calendarContainer.style.top = top + "px";
	            if (!rightMost) {
	                self.calendarContainer.style.left = left + "px";
	                self.calendarContainer.style.right = "auto";
	            }
	            else if (!centerMost) {
	                self.calendarContainer.style.left = "auto";
	                self.calendarContainer.style.right = right + "px";
	            }
	            else {
	                var doc = getDocumentStyleSheet();
	                // some testing environments don't have css support
	                if (doc === undefined)
	                    return;
	                var bodyWidth = window.document.body.offsetWidth;
	                var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
	                var centerBefore = ".flatpickr-calendar.centerMost:before";
	                var centerAfter = ".flatpickr-calendar.centerMost:after";
	                var centerIndex = doc.cssRules.length;
	                var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
	                toggleClass(self.calendarContainer, "rightMost", false);
	                toggleClass(self.calendarContainer, "centerMost", true);
	                doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
	                self.calendarContainer.style.left = centerLeft + "px";
	                self.calendarContainer.style.right = "auto";
	            }
	        }
	        function getDocumentStyleSheet() {
	            var editableSheet = null;
	            for (var i = 0; i < document.styleSheets.length; i++) {
	                var sheet = document.styleSheets[i];
	                try {
	                    sheet.cssRules;
	                }
	                catch (err) {
	                    continue;
	                }
	                editableSheet = sheet;
	                break;
	            }
	            return editableSheet != null ? editableSheet : createStyleSheet();
	        }
	        function createStyleSheet() {
	            var style = document.createElement("style");
	            document.head.appendChild(style);
	            return style.sheet;
	        }
	        function redraw() {
	            if (self.config.noCalendar || self.isMobile)
	                return;
	            buildMonthSwitch();
	            updateNavigationCurrentMonth();
	            buildDays();
	        }
	        function focusAndClose() {
	            self._input.focus();
	            if (window.navigator.userAgent.indexOf("MSIE") !== -1 ||
	                navigator.msMaxTouchPoints !== undefined) {
	                // hack - bugs in the way IE handles focus keeps the calendar open
	                setTimeout(self.close, 0);
	            }
	            else {
	                self.close();
	            }
	        }
	        function selectDate(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            var isSelectable = function (day) {
	                return day.classList &&
	                    day.classList.contains("flatpickr-day") &&
	                    !day.classList.contains("flatpickr-disabled") &&
	                    !day.classList.contains("notAllowed");
	            };
	            var t = findParent(getEventTarget(e), isSelectable);
	            if (t === undefined)
	                return;
	            var target = t;
	            var selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
	            var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth ||
	                selectedDate.getMonth() >
	                    self.currentMonth + self.config.showMonths - 1) &&
	                self.config.mode !== "range";
	            self.selectedDateElem = target;
	            if (self.config.mode === "single")
	                self.selectedDates = [selectedDate];
	            else if (self.config.mode === "multiple") {
	                var selectedIndex = isDateSelected(selectedDate);
	                if (selectedIndex)
	                    self.selectedDates.splice(parseInt(selectedIndex), 1);
	                else
	                    self.selectedDates.push(selectedDate);
	            }
	            else if (self.config.mode === "range") {
	                if (self.selectedDates.length === 2) {
	                    self.clear(false, false);
	                }
	                self.latestSelectedDateObj = selectedDate;
	                self.selectedDates.push(selectedDate);
	                // unless selecting same date twice, sort ascendingly
	                if (compareDates(selectedDate, self.selectedDates[0], true) !== 0)
	                    self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
	            }
	            setHoursFromInputs();
	            if (shouldChangeMonth) {
	                var isNewYear = self.currentYear !== selectedDate.getFullYear();
	                self.currentYear = selectedDate.getFullYear();
	                self.currentMonth = selectedDate.getMonth();
	                if (isNewYear) {
	                    triggerEvent("onYearChange");
	                    buildMonthSwitch();
	                }
	                triggerEvent("onMonthChange");
	            }
	            updateNavigationCurrentMonth();
	            buildDays();
	            updateValue();
	            // maintain focus
	            if (!shouldChangeMonth &&
	                self.config.mode !== "range" &&
	                self.config.showMonths === 1)
	                focusOnDayElem(target);
	            else if (self.selectedDateElem !== undefined &&
	                self.hourElement === undefined) {
	                self.selectedDateElem && self.selectedDateElem.focus();
	            }
	            if (self.hourElement !== undefined)
	                self.hourElement !== undefined && self.hourElement.focus();
	            if (self.config.closeOnSelect) {
	                var single = self.config.mode === "single" && !self.config.enableTime;
	                var range = self.config.mode === "range" &&
	                    self.selectedDates.length === 2 &&
	                    !self.config.enableTime;
	                if (single || range) {
	                    focusAndClose();
	                }
	            }
	            triggerChange();
	        }
	        var CALLBACKS = {
	            locale: [setupLocale, updateWeekdays],
	            showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
	            minDate: [jumpToDate],
	            maxDate: [jumpToDate],
	        };
	        function set(option, value) {
	            if (option !== null && typeof option === "object") {
	                Object.assign(self.config, option);
	                for (var key in option) {
	                    if (CALLBACKS[key] !== undefined)
	                        CALLBACKS[key].forEach(function (x) { return x(); });
	                }
	            }
	            else {
	                self.config[option] = value;
	                if (CALLBACKS[option] !== undefined)
	                    CALLBACKS[option].forEach(function (x) { return x(); });
	                else if (HOOKS.indexOf(option) > -1)
	                    self.config[option] = arrayify(value);
	            }
	            self.redraw();
	            updateValue(true);
	        }
	        function setSelectedDate(inputDate, format) {
	            var dates = [];
	            if (inputDate instanceof Array)
	                dates = inputDate.map(function (d) { return self.parseDate(d, format); });
	            else if (inputDate instanceof Date || typeof inputDate === "number")
	                dates = [self.parseDate(inputDate, format)];
	            else if (typeof inputDate === "string") {
	                switch (self.config.mode) {
	                    case "single":
	                    case "time":
	                        dates = [self.parseDate(inputDate, format)];
	                        break;
	                    case "multiple":
	                        dates = inputDate
	                            .split(self.config.conjunction)
	                            .map(function (date) { return self.parseDate(date, format); });
	                        break;
	                    case "range":
	                        dates = inputDate
	                            .split(self.l10n.rangeSeparator)
	                            .map(function (date) { return self.parseDate(date, format); });
	                        break;
	                }
	            }
	            else
	                self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
	            self.selectedDates = (self.config.allowInvalidPreload
	                ? dates
	                : dates.filter(function (d) { return d instanceof Date && isEnabled(d, false); }));
	            if (self.config.mode === "range")
	                self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
	        }
	        function setDate(date, triggerChange, format) {
	            if (triggerChange === void 0) { triggerChange = false; }
	            if (format === void 0) { format = self.config.dateFormat; }
	            if ((date !== 0 && !date) || (date instanceof Array && date.length === 0))
	                return self.clear(triggerChange);
	            setSelectedDate(date, format);
	            self.latestSelectedDateObj =
	                self.selectedDates[self.selectedDates.length - 1];
	            self.redraw();
	            jumpToDate(undefined, triggerChange);
	            setHoursFromDate();
	            if (self.selectedDates.length === 0) {
	                self.clear(false);
	            }
	            updateValue(triggerChange);
	            if (triggerChange)
	                triggerEvent("onChange");
	        }
	        function parseDateRules(arr) {
	            return arr
	                .slice()
	                .map(function (rule) {
	                if (typeof rule === "string" ||
	                    typeof rule === "number" ||
	                    rule instanceof Date) {
	                    return self.parseDate(rule, undefined, true);
	                }
	                else if (rule &&
	                    typeof rule === "object" &&
	                    rule.from &&
	                    rule.to)
	                    return {
	                        from: self.parseDate(rule.from, undefined),
	                        to: self.parseDate(rule.to, undefined),
	                    };
	                return rule;
	            })
	                .filter(function (x) { return x; }); // remove falsy values
	        }
	        function setupDates() {
	            self.selectedDates = [];
	            self.now = self.parseDate(self.config.now) || new Date();
	            // Workaround IE11 setting placeholder as the input's value
	            var preloadedDate = self.config.defaultDate ||
	                ((self.input.nodeName === "INPUT" ||
	                    self.input.nodeName === "TEXTAREA") &&
	                    self.input.placeholder &&
	                    self.input.value === self.input.placeholder
	                    ? null
	                    : self.input.value);
	            if (preloadedDate)
	                setSelectedDate(preloadedDate, self.config.dateFormat);
	            self._initialDate =
	                self.selectedDates.length > 0
	                    ? self.selectedDates[0]
	                    : self.config.minDate &&
	                        self.config.minDate.getTime() > self.now.getTime()
	                        ? self.config.minDate
	                        : self.config.maxDate &&
	                            self.config.maxDate.getTime() < self.now.getTime()
	                            ? self.config.maxDate
	                            : self.now;
	            self.currentYear = self._initialDate.getFullYear();
	            self.currentMonth = self._initialDate.getMonth();
	            if (self.selectedDates.length > 0)
	                self.latestSelectedDateObj = self.selectedDates[0];
	            if (self.config.minTime !== undefined)
	                self.config.minTime = self.parseDate(self.config.minTime, "H:i");
	            if (self.config.maxTime !== undefined)
	                self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
	            self.minDateHasTime =
	                !!self.config.minDate &&
	                    (self.config.minDate.getHours() > 0 ||
	                        self.config.minDate.getMinutes() > 0 ||
	                        self.config.minDate.getSeconds() > 0);
	            self.maxDateHasTime =
	                !!self.config.maxDate &&
	                    (self.config.maxDate.getHours() > 0 ||
	                        self.config.maxDate.getMinutes() > 0 ||
	                        self.config.maxDate.getSeconds() > 0);
	        }
	        function setupInputs() {
	            self.input = getInputElem();
	            /* istanbul ignore next */
	            if (!self.input) {
	                self.config.errorHandler(new Error("Invalid input element specified"));
	                return;
	            }
	            // hack: store previous type to restore it after destroy()
	            self.input._type = self.input.type;
	            self.input.type = "text";
	            self.input.classList.add("flatpickr-input");
	            self._input = self.input;
	            if (self.config.altInput) {
	                // replicate self.element
	                self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
	                self._input = self.altInput;
	                self.altInput.placeholder = self.input.placeholder;
	                self.altInput.disabled = self.input.disabled;
	                self.altInput.required = self.input.required;
	                self.altInput.tabIndex = self.input.tabIndex;
	                self.altInput.type = "text";
	                self.input.setAttribute("type", "hidden");
	                if (!self.config.static && self.input.parentNode)
	                    self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
	            }
	            if (!self.config.allowInput)
	                self._input.setAttribute("readonly", "readonly");
	            self._positionElement = self.config.positionElement || self._input;
	        }
	        function setupMobile() {
	            var inputType = self.config.enableTime
	                ? self.config.noCalendar
	                    ? "time"
	                    : "datetime-local"
	                : "date";
	            self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
	            self.mobileInput.tabIndex = 1;
	            self.mobileInput.type = inputType;
	            self.mobileInput.disabled = self.input.disabled;
	            self.mobileInput.required = self.input.required;
	            self.mobileInput.placeholder = self.input.placeholder;
	            self.mobileFormatStr =
	                inputType === "datetime-local"
	                    ? "Y-m-d\\TH:i:S"
	                    : inputType === "date"
	                        ? "Y-m-d"
	                        : "H:i:S";
	            if (self.selectedDates.length > 0) {
	                self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
	            }
	            if (self.config.minDate)
	                self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
	            if (self.config.maxDate)
	                self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
	            if (self.input.getAttribute("step"))
	                self.mobileInput.step = String(self.input.getAttribute("step"));
	            self.input.type = "hidden";
	            if (self.altInput !== undefined)
	                self.altInput.type = "hidden";
	            try {
	                if (self.input.parentNode)
	                    self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
	            }
	            catch (_a) { }
	            bind(self.mobileInput, "change", function (e) {
	                self.setDate(getEventTarget(e).value, false, self.mobileFormatStr);
	                triggerEvent("onChange");
	                triggerEvent("onClose");
	            });
	        }
	        function toggle(e) {
	            if (self.isOpen === true)
	                return self.close();
	            self.open(e);
	        }
	        function triggerEvent(event, data) {
	            // If the instance has been destroyed already, all hooks have been removed
	            if (self.config === undefined)
	                return;
	            var hooks = self.config[event];
	            if (hooks !== undefined && hooks.length > 0) {
	                for (var i = 0; hooks[i] && i < hooks.length; i++)
	                    hooks[i](self.selectedDates, self.input.value, self, data);
	            }
	            if (event === "onChange") {
	                self.input.dispatchEvent(createEvent("change"));
	                // many front-end frameworks bind to the input event
	                self.input.dispatchEvent(createEvent("input"));
	            }
	        }
	        function createEvent(name) {
	            var e = document.createEvent("Event");
	            e.initEvent(name, true, true);
	            return e;
	        }
	        function isDateSelected(date) {
	            for (var i = 0; i < self.selectedDates.length; i++) {
	                if (compareDates(self.selectedDates[i], date) === 0)
	                    return "" + i;
	            }
	            return false;
	        }
	        function isDateInRange(date) {
	            if (self.config.mode !== "range" || self.selectedDates.length < 2)
	                return false;
	            return (compareDates(date, self.selectedDates[0]) >= 0 &&
	                compareDates(date, self.selectedDates[1]) <= 0);
	        }
	        function updateNavigationCurrentMonth() {
	            if (self.config.noCalendar || self.isMobile || !self.monthNav)
	                return;
	            self.yearElements.forEach(function (yearElement, i) {
	                var d = new Date(self.currentYear, self.currentMonth, 1);
	                d.setMonth(self.currentMonth + i);
	                if (self.config.showMonths > 1 ||
	                    self.config.monthSelectorType === "static") {
	                    self.monthElements[i].textContent =
	                        monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
	                }
	                else {
	                    self.monthsDropdownContainer.value = d.getMonth().toString();
	                }
	                yearElement.value = d.getFullYear().toString();
	            });
	            self._hidePrevMonthArrow =
	                self.config.minDate !== undefined &&
	                    (self.currentYear === self.config.minDate.getFullYear()
	                        ? self.currentMonth <= self.config.minDate.getMonth()
	                        : self.currentYear < self.config.minDate.getFullYear());
	            self._hideNextMonthArrow =
	                self.config.maxDate !== undefined &&
	                    (self.currentYear === self.config.maxDate.getFullYear()
	                        ? self.currentMonth + 1 > self.config.maxDate.getMonth()
	                        : self.currentYear > self.config.maxDate.getFullYear());
	        }
	        function getDateStr(format) {
	            return self.selectedDates
	                .map(function (dObj) { return self.formatDate(dObj, format); })
	                .filter(function (d, i, arr) {
	                return self.config.mode !== "range" ||
	                    self.config.enableTime ||
	                    arr.indexOf(d) === i;
	            })
	                .join(self.config.mode !== "range"
	                ? self.config.conjunction
	                : self.l10n.rangeSeparator);
	        }
	        /**
	         * Updates the values of inputs associated with the calendar
	         */
	        function updateValue(triggerChange) {
	            if (triggerChange === void 0) { triggerChange = true; }
	            if (self.mobileInput !== undefined && self.mobileFormatStr) {
	                self.mobileInput.value =
	                    self.latestSelectedDateObj !== undefined
	                        ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr)
	                        : "";
	            }
	            self.input.value = getDateStr(self.config.dateFormat);
	            if (self.altInput !== undefined) {
	                self.altInput.value = getDateStr(self.config.altFormat);
	            }
	            if (triggerChange !== false)
	                triggerEvent("onValueUpdate");
	        }
	        function onMonthNavClick(e) {
	            var eventTarget = getEventTarget(e);
	            var isPrevMonth = self.prevMonthNav.contains(eventTarget);
	            var isNextMonth = self.nextMonthNav.contains(eventTarget);
	            if (isPrevMonth || isNextMonth) {
	                changeMonth(isPrevMonth ? -1 : 1);
	            }
	            else if (self.yearElements.indexOf(eventTarget) >= 0) {
	                eventTarget.select();
	            }
	            else if (eventTarget.classList.contains("arrowUp")) {
	                self.changeYear(self.currentYear + 1);
	            }
	            else if (eventTarget.classList.contains("arrowDown")) {
	                self.changeYear(self.currentYear - 1);
	            }
	        }
	        function timeWrapper(e) {
	            e.preventDefault();
	            var isKeyDown = e.type === "keydown", eventTarget = getEventTarget(e), input = eventTarget;
	            if (self.amPM !== undefined && eventTarget === self.amPM) {
	                self.amPM.textContent =
	                    self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	            }
	            var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta ||
	                (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
	            var newValue = curValue + step * delta;
	            if (typeof input.value !== "undefined" && input.value.length === 2) {
	                var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
	                if (newValue < min) {
	                    newValue =
	                        max +
	                            newValue +
	                            int(!isHourElem) +
	                            (int(isHourElem) && int(!self.amPM));
	                    if (isMinuteElem)
	                        incrementNumInput(undefined, -1, self.hourElement);
	                }
	                else if (newValue > max) {
	                    newValue =
	                        input === self.hourElement ? newValue - max - int(!self.amPM) : min;
	                    if (isMinuteElem)
	                        incrementNumInput(undefined, 1, self.hourElement);
	                }
	                if (self.amPM &&
	                    isHourElem &&
	                    (step === 1
	                        ? newValue + curValue === 23
	                        : Math.abs(newValue - curValue) > step)) {
	                    self.amPM.textContent =
	                        self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	                }
	                input.value = pad(newValue);
	            }
	        }
	        init();
	        return self;
	    }
	    /* istanbul ignore next */
	    function _flatpickr(nodeList, config) {
	        // static list
	        var nodes = Array.prototype.slice
	            .call(nodeList)
	            .filter(function (x) { return x instanceof HTMLElement; });
	        var instances = [];
	        for (var i = 0; i < nodes.length; i++) {
	            var node = nodes[i];
	            try {
	                if (node.getAttribute("data-fp-omit") !== null)
	                    continue;
	                if (node._flatpickr !== undefined) {
	                    node._flatpickr.destroy();
	                    node._flatpickr = undefined;
	                }
	                node._flatpickr = FlatpickrInstance(node, config || {});
	                instances.push(node._flatpickr);
	            }
	            catch (e) {
	                console.error(e);
	            }
	        }
	        return instances.length === 1 ? instances[0] : instances;
	    }
	    /* istanbul ignore next */
	    if (typeof HTMLElement !== "undefined" &&
	        typeof HTMLCollection !== "undefined" &&
	        typeof NodeList !== "undefined") {
	        // browser env
	        HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
	            return _flatpickr(this, config);
	        };
	        HTMLElement.prototype.flatpickr = function (config) {
	            return _flatpickr([this], config);
	        };
	    }
	    /* istanbul ignore next */
	    var flatpickr = function (selector, config) {
	        if (typeof selector === "string") {
	            return _flatpickr(window.document.querySelectorAll(selector), config);
	        }
	        else if (selector instanceof Node) {
	            return _flatpickr([selector], config);
	        }
	        else {
	            return _flatpickr(selector, config);
	        }
	    };
	    /* istanbul ignore next */
	    flatpickr.defaultConfig = {};
	    flatpickr.l10ns = {
	        en: __assign({}, english),
	        default: __assign({}, english),
	    };
	    flatpickr.localize = function (l10n) {
	        flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
	    };
	    flatpickr.setDefaults = function (config) {
	        flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
	    };
	    flatpickr.parseDate = createDateParser({});
	    flatpickr.formatDate = createDateFormatter({});
	    flatpickr.compareDates = compareDates;
	    /* istanbul ignore next */
	    if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
	        jQuery.fn.flatpickr = function (config) {
	            return _flatpickr(this, config);
	        };
	    }
	    // eslint-disable-next-line @typescript-eslint/camelcase
	    Date.prototype.fp_incr = function (days) {
	        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
	    };
	    if (typeof window !== "undefined") {
	        window.flatpickr = flatpickr;
	    }

	    return flatpickr;

	})));
	});

	var de = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
	   factory(exports) ;
	}(commonjsGlobal, (function (exports) {
	  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
	      ? window.flatpickr
	      : {
	          l10ns: {},
	      };
	  var German = {
	      weekdays: {
	          shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
	          longhand: [
	              "Sonntag",
	              "Montag",
	              "Dienstag",
	              "Mittwoch",
	              "Donnerstag",
	              "Freitag",
	              "Samstag",
	          ],
	      },
	      months: {
	          shorthand: [
	              "Jan",
	              "Feb",
	              "Mär",
	              "Apr",
	              "Mai",
	              "Jun",
	              "Jul",
	              "Aug",
	              "Sep",
	              "Okt",
	              "Nov",
	              "Dez",
	          ],
	          longhand: [
	              "Januar",
	              "Februar",
	              "März",
	              "April",
	              "Mai",
	              "Juni",
	              "Juli",
	              "August",
	              "September",
	              "Oktober",
	              "November",
	              "Dezember",
	          ],
	      },
	      firstDayOfWeek: 1,
	      weekAbbreviation: "KW",
	      rangeSeparator: " bis ",
	      scrollTitle: "Zum Ändern scrollen",
	      toggleTitle: "Zum Umschalten klicken",
	      time_24hr: true,
	  };
	  fp.l10ns.de = German;
	  var de = fp.l10ns;

	  exports.German = German;
	  exports.default = de;

	  Object.defineProperty(exports, '__esModule', { value: true });

	})));
	});

	/**
	 *
	 * --------------------------------------------------------------------------
	 * WKO InHouse (v0.1.0): datepicker.js
	 * --------------------------------------------------------------------------
	 */

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var VERSION$c = "0.1.0";
	var DATA_ATTR$1 = "data-flatpickr";
	var Selector$1 = {
	  DATA_FLATPICKR: "[" + DATA_ATTR$1 + "]"
	};
	/**
	 * ------------------------------------------------------------------------
	 * Class Definition
	 * ------------------------------------------------------------------------
	 */

	var Datepicker = /*#__PURE__*/function () {
	  function Datepicker(inputEl) {
	    this.inputEl = inputEl;
	  }

	  var _proto = Datepicker.prototype;

	  _proto.initialize = function initialize() {
	    if (this.inputEl && this.inputEl.dataset.flatpickr) {
	      var options = {};
	      var flatpickrDataOption = this.inputEl.dataset.flatpickr;

	      try {
	        options = JSON.parse(flatpickrDataOption);
	      } catch (_unused) {
	        options = {};
	      }

	      flatpickr(this.inputEl, _objectSpread2$1({
	        locale: de.German
	      }, options));
	    }
	  };

	  _createClass$1(Datepicker, null, [{
	    key: "VERSION",
	    get: function get() {
	      return VERSION$c;
	    }
	  }]);

	  return Datepicker;
	}();
	document.addEventListener("DOMContentLoaded", function () {
	  var inputElements = Array.prototype.slice.call(document.querySelectorAll(Selector$1.DATA_FLATPICKR)).map(function (element) {
	    return new Datepicker(element);
	  });
	  inputElements.forEach(function (datepicker) {
	    return datepicker.initialize();
	  });
	});

	exports.Alert = Alert;
	exports.Button = Button;
	exports.Carousel = Carousel;
	exports.Collapse = Collapse;
	exports.Datepicker = Datepicker;
	exports.Dropdown = Dropdown;
	exports.LazySVGSprite = LazySVGSprite;
	exports.Modal = Modal;
	exports.Popover = Popover;
	exports.ScrollSpy = ScrollSpy;
	exports.Tab = Tab;
	exports.Toast = Toast;
	exports.Tooltip = Tooltip;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=wko-ds-bootstrap.bundle.js.map
